/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
! function(t, e, s, i, o, n, r) {
    "use strict";

    function a(t) {
        t.querySelectorAll(".form-field").forEach((t => {
            const e = t.querySelector("label"),
                s = t.querySelector("input, textarea");
            e && s && (s.addEventListener("keyup", (t => {
                "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float")
            })), s.value && s.value.length && e.classList.add("label--float"))
        }))
    }! function() {
        const t = {
            NODE_ENV: "production"
        };
        try {
            if (process) return process.env = Object.assign({}, process.env), void Object.assign(process.env, t)
        } catch (t) {}
        globalThis.process = {
            env: t
        }
    }(), window.theme = window.theme || {}, window.theme.sizes = {
        mobile: 480,
        small: 750,
        large: 990,
        widescreen: 1400
    }, window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    let l = p();

    function c() {
        const t = {};
        return t.windowHeight = Math.min(window.screen.height, window.innerHeight), t.footerHeight = m('[data-section-type*="footer"]'), t.headerHeight = m("[data-header-height]"), t.stickyHeaderHeight = document.querySelector("[data-header-sticky]") ? t.headerHeight : 0, t.collectionNavHeight = m("[data-collection-nav]"), t.logoHeight = function() {
            const t = m("[data-footer-logo]");
            return t > 0 ? t + 20 : 0
        }(), t
    }

    function h() {
        document.addEventListener("theme:resize", u), d()
    }

    function d() {
        const {
            windowHeight: t,
            headerHeight: e,
            logoHeight: s,
            footerHeight: i,
            collectionNavHeight: o
        } = c();
        document.documentElement.style.setProperty("--full-height", `${t}px`), document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"), document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"), document.documentElement.style.setProperty("--one-half", t / 2 + "px"), document.documentElement.style.setProperty("--one-third", t / 3 + "px"), document.documentElement.style.setProperty("--collection-nav-height", `${o}px`), document.documentElement.style.setProperty("--header-height", `${e}px`), document.documentElement.style.setProperty("--footer-height", `${i}px`), document.documentElement.style.setProperty("--content-full", t - e - s / 2 + "px"), document.documentElement.style.setProperty("--content-min", t - e - i + "px"), document.querySelector("[data-tracking-consent].popup-cookies--bottom") && document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`)
    }

    function u() {
        const {
            windowHeight: t,
            headerHeight: e,
            logoHeight: s,
            footerHeight: i,
            collectionNavHeight: o
        } = c(), n = p();
        (n !== l || window.innerWidth > window.theme.sizes.mobile) && (document.documentElement.style.setProperty("--full-height", `${t}px`), document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"), document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"), document.documentElement.style.setProperty("--one-half", t / 2 + "px"), document.documentElement.style.setProperty("--one-third", t / 3 + "px"), l = n), document.documentElement.style.setProperty("--collection-nav-height", `${o}px`), document.documentElement.style.setProperty("--header-height", `${e}px`), document.documentElement.style.setProperty("--footer-height", `${i}px`), document.documentElement.style.setProperty("--content-full", t - e - s / 2 + "px"), document.documentElement.style.setProperty("--content-min", t - e - i + "px"), document.querySelector("[data-tracking-consent].popup-cookies--bottom") && document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`)
    }

    function p() {
        return window.matchMedia("(orientation: portrait)").matches ? "portrait" : window.matchMedia("(orientation: landscape)").matches ? "landscape" : void 0
    }

    function m(t) {
        const e = document.querySelector(t);
        return e ? e.offsetHeight : 0
    }

    function v(t, e) {
        let s;
        return function() {
            if (t) {
                const i = () => t.apply(this, arguments);
                clearTimeout(s), s = setTimeout(i, e)
            }
        }
    }

    function g() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    }

    function f() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    }

    function y() {
        return g() >= window.theme.sizes.small
    }

    function b() {
        return g() < window.theme.sizes.small
    }
    window.initialWindowHeight = Math.min(window.screen.height, window.innerHeight);
    let w = g(),
        E = f();
    let S = window.scrollY,
        L = null,
        k = null,
        A = null,
        C = null,
        T = 0;

    function q(e) {
        setTimeout((() => {
            T && clearTimeout(T), t.disablePageScroll(e.detail, {
                allowTouchMove: t => "TEXTAREA" === t.tagName
            }), document.documentElement.setAttribute("data-scroll-locked", "")
        }))
    }

    function x(t) {
        const e = t.detail;
        e ? T = setTimeout(M, e) : M()
    }

    function M() {
        t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked")
    }
    const P = (t, e = "", s) => {
        const i = s || document.createElement("div");
        return i.classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t)
    };

    function I(t) {
        t.querySelectorAll(".rte table").forEach((t => {
            P(t, "rte__table-wrapper"), t.setAttribute("data-scroll-lock-scrollable", "")
        }));
        t.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((t => {
            P(t, "rte__video-wrapper")
        }))
    }

    function H(t) {
        const e = t.querySelectorAll("[data-aria-toggle]");
        e.length && e.forEach((t => {
            t.addEventListener("click", (function(t) {
                t.preventDefault();
                const e = t.currentTarget;
                e.setAttribute("aria-expanded", "false" == e.getAttribute("aria-expanded") ? "true" : "false");
                const s = e.getAttribute("aria-controls"),
                    i = document.querySelector(`#${s}`),
                    o = () => {
                        i.classList.remove("expanding"), i.removeEventListener("transitionend", o)
                    },
                    n = () => {
                        i.classList.add("expanding"), i.removeEventListener("transitionstart", n)
                    };
                i.addEventListener("transitionstart", n), i.addEventListener("transitionend", o), i.classList.toggle("expanded")
            }))
        }))
    }
    const O = "is-loading",
        B = "img.is-loading";

    function D(t, e) {
        e = e || {};
        var s = t.tabIndex;
        t.tabIndex = -1, t.dataset.tabIndex = s, t.focus(), void 0 !== e.className && t.classList.add(e.className), t.addEventListener("blur", (function i(o) {
            o.target.removeEventListener(o.type, i), t.tabIndex = s, delete t.dataset.tabIndex, void 0 !== e.className && t.classList.remove(e.className)
        }))
    }

    function F(t) {
        return Array.prototype.slice.call(t.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled")).filter((function(t) {
            return !(!(t.offsetWidth || t.offsetHeight || t.getClientRects().length) || (e = t, s = window.getComputedStyle(e), "none" === s.display || "hidden" === s.visibility));
            var e, s
        }))
    }
    var $ = {};

    function _(t, e) {
        e = e || {};
        var s = F(t),
            i = e.elementToFocus || t,
            o = s[0],
            n = s[s.length - 1];
        N(), $.focusin = function(e) {
            t !== e.target && !t.contains(e.target) && o && o === e.target && o.focus(), e.target !== t && e.target !== n && e.target !== o || document.addEventListener("keydown", $.keydown)
        }, $.focusout = function() {
            document.removeEventListener("keydown", $.keydown)
        }, $.keydown = function(e) {
            "Tab" === e.code && (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()), e.target !== t && e.target !== o || !e.shiftKey || (e.preventDefault(), n.focus()))
        }, document.addEventListener("focusout", $.focusout), document.addEventListener("focusin", $.focusin), D(i, e)
    }

    function N() {
        document.removeEventListener("focusin", $.focusin), document.removeEventListener("focusout", $.focusout), document.removeEventListener("keydown", $.keydown)
    }

    function R() {
        window.accessibility.lastElement && document.body.classList.contains("is-focused") && setTimeout((() => {
            var t;
            null === (t = window.accessibility.lastElement) || void 0 === t || t.focus()
        }))
    }
    var W = Object.freeze({
        __proto__: null,
        forceFocus: D,
        focusHash: function(t) {
            t = t || {};
            var e = window.location.hash,
                s = document.getElementById(e.slice(1));
            if (s && t.ignore && s.matches(t.ignore)) return !1;
            e && s && D(s, t)
        },
        bindInPageLinks: function(t) {
            return t = t || {}, Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((function(e) {
                if ("#" === e.hash || "" === e.hash) return !1;
                if (t.ignore && e.matches(t.ignore)) return !1;
                if (s = e.hash.substr(1), null === document.getElementById(s)) return !1;
                var s, i = document.querySelector(e.hash);
                return !!i && (e.addEventListener("click", (function() {
                    D(i, t)
                })), !0)
            }))
        },
        focusable: F,
        trapFocus: _,
        removeTrapFocus: N,
        autoFocusLastElement: R,
        accessibleLinks: function(t, e) {
            if ("string" != typeof t) throw new TypeError(t + " is not a String.");
            if (0 !== (t = document.querySelectorAll(t)).length) {
                (e = e || {}).messages = e.messages || {};
                var s, i, o, n = {
                        newWindow: e.messages.newWindow || "Opens in a new window.",
                        external: e.messages.external || "Opens external website.",
                        newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window."
                    },
                    r = e.prefix || "a11y",
                    a = {
                        newWindow: r + "-new-window-message",
                        external: r + "-external-message",
                        newWindowExternal: r + "-new-window-external-message"
                    };
                t.forEach((function(t) {
                    var e = t.getAttribute("target"),
                        s = t.getAttribute("rel"),
                        i = function(t) {
                            return t.hostname !== window.location.hostname
                        }(t),
                        o = "_blank" === e,
                        n = null === s || -1 === s.indexOf("noopener");
                    if (o && n) {
                        var r = null === s ? "noopener" : s + " noopener";
                        t.setAttribute("rel", r)
                    }
                    i && o ? t.setAttribute("aria-describedby", a.newWindowExternal) : i ? t.setAttribute("aria-describedby", a.external) : o && t.setAttribute("aria-describedby", a.newWindow)
                })), s = n, i = document.createElement("ul"), o = Object.keys(s).reduce((function(t, e) {
                    return t + "<li id=" + a[e] + ">" + s[e] + "</li>"
                }), ""), i.setAttribute("hidden", !0), i.innerHTML = o, document.body.appendChild(i)
            }
        }
    });
    const z = 'input[type="search"]',
        U = '[aria-selected="true"] a',
        V = 'button[type="reset"]',
        j = "hidden";
    let X = class extends HTMLElement {
        toggleResetButton() {
            const t = this.resetButton.classList.contains(j);
            this.input.value.length > 0 && t ? this.resetButton.classList.remove(j) : 0 !== this.input.value.length || t || this.resetButton.classList.add(j)
        }
        onChange() {
            this.toggleResetButton()
        }
        shouldResetForm() {
            return !document.querySelector(U)
        }
        onFormReset(t) {
            t.preventDefault(), this.shouldResetForm() && (this.input.value = "", this.toggleResetButton(), t.target.querySelector(z).focus())
        }
        constructor() {
            super(), this.input = this.querySelector(z), this.resetButton = this.querySelector(V), this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)), this.input.addEventListener("input", v((t => {
                this.onChange(t)
            }), 300).bind(this)))
        }
    };
    customElements.define("header-search-form", X);
    const J = '[role="option"]',
        Y = '[aria-selected="true"]',
        Q = "[data-popular-searches]",
        G = "predictive-search",
        K = "[data-predictive-search-results]",
        Z = "[data-predictive-search-status]",
        tt = 'input[type="search"]',
        et = "[data-popdown]",
        st = "[data-predictive-search-live-region-count-value]",
        it = "[data-search-results-groups-wrapper]",
        ot = "[data-predictive-search-search-for-text]",
        nt = "#shopify-section-predictive-search",
        rt = '[aria-selected="true"] a',
        at = '[aria-selected="true"] a, button[aria-selected="true"]';
    let lt = class extends X {
        connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this)), this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.addEventListener("keyup", this.onKeyup.bind(this)), this.addEventListener("keydown", this.onKeydown.bind(this))
        }
        getQuery() {
            return this.input.value.trim()
        }
        onChange() {
            super.onChange();
            const t = this.getQuery();
            var e;
            this.searchTerm && t.startsWith(this.searchTerm) || (null === (e = this.querySelector(it)) || void 0 === e || e.remove());
            this.updateSearchForTerm(this.searchTerm, t), this.searchTerm = t, this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset()
        }
        onFormSubmit(t) {
            this.getQuery().length && !this.querySelector(rt) || t.preventDefault()
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && (this.searchTerm = "", this.abortController.abort(), this.abortController = new AbortController, this.closeResults(!0))
        }
        shouldResetForm() {
            return !document.querySelector(rt)
        }
        onFocus() {
            const t = this.getQuery();
            t.length && (this.searchTerm !== t ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm))
        }
        onFocusOut() {
            setTimeout((() => {
                this.contains(document.activeElement) || this.close()
            }))
        }
        onKeyup(t) {
            switch (this.getQuery().length || this.close(!0), t.preventDefault(), t.code) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption()
            }
        }
        onKeydown(t) {
            "ArrowUp" !== t.code && "ArrowDown" !== t.code || t.preventDefault()
        }
        updateSearchForTerm(t, e) {
            const s = this.querySelector(ot),
                i = null == s ? void 0 : s.innerText;
            if (i) {
                var o;
                if ((null === (o = i.match(new RegExp(t, "g"))) || void 0 === o ? void 0 : o.length) > 1) return;
                const n = i.replace(t, e);
                s.innerText = n
            }
        }
        switchOption(t) {
            if (!this.getAttribute("open")) return;
            const e = "up" === t,
                s = this.querySelector(Y),
                i = Array.from(this.querySelectorAll(J)).filter((t => null !== t.offsetParent));
            let o = 0;
            if (e && !s) return;
            let n = -1,
                r = 0;
            for (; - 1 === n && r <= i.length;) i[r] === s && (n = r), r++;
            if (this.statusElement.textContent = "", !e && s ? o = n === i.length - 1 ? 0 : n + 1 : e && (o = 0 === n ? i.length - 1 : n - 1), o === n) return;
            const a = i[o];
            a.setAttribute("aria-selected", !0), s && s.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", a.id)
        }
        selectOption() {
            const t = this.querySelector(at);
            t && t.click()
        }
        getSearchResults(t) {
            const e = t.replace(" ", "-").toLowerCase();
            this.setLiveRegionLoadingState(), this.cachedResults[e] ? this.renderSearchResults(this.cachedResults[e]) : fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(t)}&section_id=predictive-search`, {
                signal: this.abortController.signal
            }).then((t => {
                if (!t.ok) {
                    var e = new Error(t.status);
                    throw this.close(), e
                }
                return t.text()
            })).then((t => {
                const s = (new DOMParser).parseFromString(t, "text/html").querySelector(nt).innerHTML;
                this.allPredictiveSearchInstances.forEach((t => {
                    t.cachedResults[e] = s
                })), this.renderSearchResults(s)
            })).catch((t => {
                if (20 !== (null == t ? void 0 : t.code)) throw this.close(), t
            }))
        }
        setLiveRegionLoadingState() {
            this.statusElement = this.statusElement || this.querySelector(Z), this.loadingText = this.loadingText || this.getAttribute("data-loading-text"), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0)
        }
        setLiveRegionText(t) {
            this.statusElement.setAttribute("aria-hidden", "false"), this.statusElement.textContent = t, setTimeout((() => {
                this.statusElement.setAttribute("aria-hidden", "true")
            }), 1e3)
        }
        renderSearchResults(t) {
            this.predictiveSearchResults.innerHTML = t, this.setAttribute("results", !0), this.setLiveRegionResults(), this.open()
        }
        setLiveRegionResults() {
            this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(st).textContent)
        }
        open() {
            this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), this.isOpen = !0, this.predictiveSearchResults.style.setProperty("--full-screen", `${window.visualViewport.height}px`)
        }
        close(t = !1) {
            this.closeResults(t), this.isOpen = !1, this.predictiveSearchResults.style.removeProperty("--full-screen")
        }
        closeResults(t = !1) {
            var e;
            t && (this.input.value = "", this.removeAttribute("results"));
            const s = this.querySelector(Y);
            s && s.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", ""), this.removeAttribute("loading"), this.removeAttribute("open"), this.input.setAttribute("aria-expanded", !1), null === (e = this.predictiveSearchResults) || void 0 === e || e.removeAttribute("style")
        }
        reset() {
            this.predictiveSearchResults.innerHTML = "", this.input.val = "", this.a11y.removeTrapFocus(), this.popularSearches && (this.input.dispatchEvent(new Event("blur", {
                bubbles: !1
            })), this.a11y.trapFocus(this.searchPopdown, {
                elementToFocus: this.input
            }))
        }
        constructor() {
            var t;
            super(), this.a11y = W, this.abortController = new AbortController, this.allPredictiveSearchInstances = document.querySelectorAll(G), this.cachedResults = {}, this.input = this.querySelector(tt), this.isOpen = !1, this.predictiveSearchResults = this.querySelector(K), this.searchPopdown = this.closest(et), this.popularSearches = null === (t = this.searchPopdown) || void 0 === t ? void 0 : t.querySelector(Q), this.searchTerm = ""
        }
    };
    const ct = "[data-popout-list]",
        ht = "[data-popout-toggle]",
        dt = "[data-popout-toggle-text]",
        ut = "[data-popout-input]",
        pt = "[data-popout-option]",
        mt = "[data-product-image]",
        vt = "[data-grid-item]",
        gt = "popout-list--visible",
        ft = "is-visible",
        yt = "is-active",
        bt = "select-popout--top",
        wt = "aria-expanded",
        Et = "aria-current",
        St = "data-value",
        Lt = "data-popout-toggle-text",
        kt = "submit";
    let At = class extends HTMLElement {
            connectedCallback() {
                this.popoutList = this.querySelector(ct), this.popoutToggle = this.querySelector(ht), this.popoutToggleText = this.querySelector(dt), this.popoutInput = this.querySelector(ut), this.popoutOptions = this.querySelectorAll(pt), this.productGridItem = this.popoutList.closest(vt), this.fireSubmitEvent = this.hasAttribute(kt), this.popupToggleFocusoutEvent = t => this.onPopupToggleFocusout(t), this.popupListFocusoutEvent = t => this.onPopupListFocusout(t), this.popupToggleClickEvent = t => this.onPopupToggleClick(t), this.keyUpEvent = t => this.onKeyUp(t), this.bodyClickEvent = t => this.onBodyClick(t), this._connectOptions(), this._connectToggle(), this._onFocusOut(), this.popupListMaxWidth()
            }
            onPopupToggleClick(t) {
                const e = "true" === t.currentTarget.getAttribute(wt);
                if (this.productGridItem) {
                    const t = this.productGridItem.querySelector(mt);
                    t && t.classList.toggle(ft, !e), this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom-this.productGridItem.getBoundingClientRect().bottom)}px`
                }
                t.currentTarget.setAttribute(wt, !e), this.popoutList.classList.toggle(gt), this.popupListMaxWidth(), this.toggleListPosition(), document.body.addEventListener("click", this.bodyClickEvent)
            }
            onPopupToggleFocusout(t) {
                this.contains(t.relatedTarget) || this._hideList()
            }
            onPopupListFocusout(t) {
                const e = t.currentTarget.contains(t.relatedTarget);
                this.popoutList.classList.contains(gt) && !e && this._hideList()
            }
            toggleListPosition() {
                const t = "true" === this.querySelector(ht).getAttribute(wt),
                    e = window.innerHeight,
                    s = this.popoutList.getBoundingClientRect().bottom,
                    i = () => {
                        this.classList.remove(bt), this.popoutList.removeEventListener("transitionend", i)
                    };
                t ? e < s && this.classList.add(bt) : this.popoutList.addEventListener("transitionend", i)
            }
            popupListMaxWidth() {
                this.popoutList.style.setProperty("--max-width", "100vw"), requestAnimationFrame((() => {
                    this.popoutList.style.setProperty("--max-width", `${parseInt(document.body.clientWidth-this.popoutList.getBoundingClientRect().left)}px`)
                }))
            }
            popupOptionsClick(t) {
                if ("#" === t.target.closest(pt).attributes.href.value) {
                    t.preventDefault();
                    const e = t.currentTarget.hasAttribute(St) ? t.currentTarget.getAttribute(St) : "";
                    if (this.popoutInput.value = e, this.popoutInput.disabled && this.popoutInput.removeAttribute("disabled"), this.fireSubmitEvent) this._submitForm(e);
                    else {
                        const s = t.currentTarget.parentElement,
                            i = this.popoutList.querySelector(`.${yt}`),
                            o = this.popoutList.querySelector(`[${Et}]`);
                        this.popoutInput.dispatchEvent(new Event("change")), i && (i.classList.remove(yt), s.classList.add(yt)), "quantity" != this.popoutInput.name || s.nextSibling || this.classList.add(yt), o && o.hasAttribute(`${Et}`) && (o.removeAttribute(`${Et}`), t.currentTarget.setAttribute(`${Et}`, "true")), "" !== e && (this.popoutToggleText.innerHTML = e, this.popoutToggleText.hasAttribute(Lt) && "" !== this.popoutToggleText.getAttribute(Lt) && this.popoutToggleText.setAttribute(Lt, e)), this.onPopupToggleFocusout(t), this.onPopupListFocusout(t)
                    }
                }
            }
            onKeyUp(t) {
                "Escape" === t.code && (this._hideList(), this.popoutToggle.focus())
            }
            onBodyClick(t) {
                const e = this.contains(t.target);
                this.popoutList.classList.contains(gt) && !e && this._hideList()
            }
            _connectToggle() {
                this.popoutToggle.addEventListener("click", this.popupToggleClickEvent)
            }
            _connectOptions() {
                this.popoutOptions.length && this.popoutOptions.forEach((t => {
                    t.addEventListener("click", (t => this.popupOptionsClick(t)))
                }))
            }
            _onFocusOut() {
                this.addEventListener("keyup", this.keyUpEvent), this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent), this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent)
            }
            _submitForm() {
                const t = this.closest("form");
                t && t.submit()
            }
            _hideList() {
                this.popoutList.classList.remove(gt), this.popoutToggle.setAttribute(wt, !1), this.toggleListPosition(), document.body.removeEventListener("click", this.bodyClickEvent)
            }
            constructor() {
                super()
            }
        },
        Ct = class extends HTMLElement {
            connectedCallback() {
                this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
                    bubbles: !0
                }), this.buttonClickEvent = this.onButtonClick.bind(this), this.onQuantityChangeEvent = this.onQuantityChange.bind(this), this.input.addEventListener("change", this.onQuantityChangeEvent), this.querySelectorAll("button").forEach((t => t.addEventListener("click", this.buttonClickEvent)))
            }
            onButtonClick(t) {
                t.preventDefault();
                const e = this.input.value,
                    s = "BUTTON" == t.target.nodeName ? t.target : t.target.closest("button");
                "increase" === s.name && this.input.stepUp(), "decrease" === s.name && this.input.stepDown(), e !== this.input.value && this.input.dispatchEvent(this.changeEvent)
            }
            onQuantityChange() {
                "updates[]" == this.input.name && this.updateCart()
            }
            updateCart() {
                "" !== this.quantityValue && this.dispatchEvent(new CustomEvent("theme:cart:update", {
                    bubbles: !0,
                    detail: {
                        id: this.input.dataset.id,
                        quantity: this.input.value
                    }
                }))

            }
            constructor() {
                super()
            }
        };
    const Tt = "[data-aos]:not(.aos-animate)",
        qt = "[data-aos-anchor]",
        xt = "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
        Mt = "aos-animate",
        Pt = {
            attributes: !1,
            childList: !0,
            subtree: !0
        };
    let It = [];
    const Ht = t => {
            for (const e of t)
                if ("childList" === e.type) {
                    const t = e.target,
                        s = t.querySelectorAll(Tt),
                        i = t.querySelectorAll(qt);
                    s.length && s.forEach((t => {
                        Ot.observe(t)
                    })), i.length && Dt(i)
                }
        },
        Ot = new IntersectionObserver(((t, e) => {
            t.forEach((t => {
                t.isIntersecting && (t.target.classList.add(Mt), e.unobserve(t.target))
            }))
        }), {
            root: null,
            rootMargin: "0px",
            threshold: [0, .1, .25, .5, .75, 1]
        }),
        Bt = new IntersectionObserver(((t, e) => {
            t.forEach((t => {
                if (t.intersectionRatio) {
                    const s = t.target.querySelectorAll(Tt);
                    s.length && s.forEach((t => {
                        t.classList.add(Mt)
                    })), e.unobserve(t.target)
                }
            }))
        }), {
            root: null,
            rootMargin: "0px",
            threshold: [.1, .25, .5, .75, 1]
        });

    function Dt(t) {
        t.length && t.forEach((t => {
            const e = t.dataset.aosAnchor;
            if (e && -1 === It.indexOf(e)) {
                const t = document.querySelector(e);
                t && (Bt.observe(t), It.push(e))
            }
        }))
    }
    const Ft = "[data-deferred-media-button]",
        $t = "video, model-viewer, iframe",
        _t = '[data-host="youtube"]',
        Nt = '[data-host="vimeo"]',
        Rt = "[data-grid-item]",
        Wt = ".shopify-section",
        zt = "template",
        Ut = "video",
        Vt = "product-model",
        jt = "loaded",
        Xt = "autoplay";
    let Jt = class extends HTMLElement {
        connectedCallback() {
            this.productGridItem && (this.section.addEventListener("mouseover", this.mouseOverEvent, {
                once: !0
            }), this.addEventListener("mouseenter", this.mouseEnterEvent), this.addEventListener("mouseleave", this.mouseLeaveEvent))
        }
        disconnectedCallback() {
            this.productGridItem && (this.section.removeEventListener("mouseover", this.mouseOverEvent, {
                once: !0
            }), this.removeEventListener("mouseenter", this.mouseEnterEvent), this.removeEventListener("mouseleave", this.mouseLeaveEvent))
        }
        mouseEnterActions() {
            this.hovered = !0, this.videoActions(), this.getAttribute(jt) || this.loadContent()
        }
        mouseLeaveActions() {
            this.hovered = !1, this.videoActions()
        }
        videoActions() {
            if (this.getAttribute(jt)) {
                const t = this.querySelector(_t),
                    e = this.querySelector(Nt),
                    s = t || e,
                    i = this.querySelector(Ut);
                if (s) {
                    let t = this.hovered ? "playVideo" : "pauseVideo",
                        i = `{"event":"command","func":"${t}","args":""}`;
                    e && (t = this.hovered ? "play" : "pause", i = `{"method":"${t}"}`), s.contentWindow.postMessage(i, "*"), s.addEventListener("load", (t => {
                        this.videoActions()
                    }))
                } else i && (this.hovered ? i.play() : i.pause())
            }
        }
        loadContent(t = !0) {
            if (this.pauseAllMedia(), !this.getAttribute(jt)) {
                const e = document.createElement("div"),
                    s = this.querySelector(zt).content.firstElementChild.cloneNode(!0);
                e.appendChild(s), this.setAttribute(jt, !0);
                const i = this.appendChild(e.querySelector($t));
                t && i.focus(), "VIDEO" == i.nodeName && i.getAttribute(Xt) && i.play(), this.productGridItem && this.videoActions()
            }
        }
        pauseAllMedia() {
            document.querySelectorAll(_t).forEach((t => {
                t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
            })), document.querySelectorAll(Nt).forEach((t => {
                t.contentWindow.postMessage('{"method":"pause"}', "*")
            })), document.querySelectorAll(Ut).forEach((t => t.pause())), document.querySelectorAll(Vt).forEach((t => {
                t.modelViewerUI && t.modelViewerUI.pause()
            }))
        }
        constructor() {
            super();
            const t = this.querySelector(Ft);
            null == t || t.addEventListener("click", this.loadContent.bind(this)), this.section = this.closest(Wt), this.productGridItem = this.closest(Rt), this.hovered = !1, this.mouseEnterEvent = () => this.mouseEnterActions(), this.mouseLeaveEvent = () => this.mouseLeaveActions()
        }
    };
    const Yt = "product-modal",
        Qt = "[data-popup-close]",
        Gt = "[data-notification-form]",
        Kt = "[data-product-notification-heading]",
        Zt = "has-success",
        te = "hidden";
    let ee = class extends HTMLElement {
        connectedCallback() {
            this.checkState(), this.notificationForm.addEventListener("submit", (t => this.notificationSubmitEvent(t))), this.popupClose.addEventListener("click", (() => {
                this.removeStorage()
            }))
        }
        checkState() {
            if (-1 !== window.location.search.indexOf("?contact_posted=true")) {
                this.querySelector(Kt).classList.add(te), this.closest(Yt).classList.add(Zt), this.popup.removeAttribute("inert"), "function" == typeof this.popup.showModal ? this.popup.showModal() : this.popup.setAttribute("open", "")
            }
        }
        notificationSubmitEvent(t) {
            this.preventSubmit && (t.preventDefault(), this.removeStorage(), this.writeStorage(), this.preventSubmit = !1, this.notificationForm.submit())
        }
        writeStorage() {
            void 0 !== window.sessionStorage && window.sessionStorage.setItem("notification_form_id", this.notificationForm.id)
        }
        removeStorage() {
            window.sessionStorage.removeItem("notification_form_id")
        }
        constructor() {
            super(), this.notificationForm = this.querySelector(Gt), this.preventSubmit = !0, this.popup = this.closest("dialog"), this.popupClose = this.popup.querySelector(Qt)
        }
    };
    const se = "is-visible";
    class ie {
        init() {
            var t;
            const e = {
                root: this.container,
                threshold: [.01, .5, .75, .99]
            };
            this.observer = new IntersectionObserver((t => {
                t.forEach((t => {
                    t.intersectionRatio >= .99 ? t.target.classList.add(se) : t.target.classList.remove(se)
                }))
            }), e), null === (t = this.container.querySelectorAll(this.itemSelector)) || void 0 === t || t.forEach((t => {
                this.observer.observe(t)
            }))
        }
        destroy() {
            this.observer.disconnect()
        }
        constructor(t, e) {
            t && e && (this.observer = null, this.container = t, this.itemSelector = e, this.init())
        }
    }
    const oe = "is-dragging",
        ne = "is-enabled",
        re = "is-scrolling",
        ae = "is-visible",
        le = "[data-grid-item]";
    class ce {
        handleMouseDown(t) {
            t.preventDefault(), this.isDown = !0, this.startX = t.pageX - this.slider.offsetLeft, this.scrollLeft = this.slider.scrollLeft, this.cancelMomentumTracking()
        }
        handleMouseLeave() {
            this.isDown && (this.isDown = !1, this.beginMomentumTracking())
        }
        handleMouseUp() {
            this.isDown = !1, this.beginMomentumTracking()
        }
        handleMouseMove(t) {
            if (!this.isDown) return;
            t.preventDefault();
            const e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
                s = this.slider.scrollLeft,
                i = e > 0 ? 1 : -1;
            this.slider.classList.add(oe, re), this.slider.scrollLeft = this.scrollLeft - e, this.slider.scrollLeft !== s && (this.velX = this.slider.scrollLeft - s || i)
        }
        handleMouseWheel() {
            this.cancelMomentumTracking(), this.slider.classList.remove(re)
        }
        beginMomentumTracking() {
            this.isScrolling = !1, this.slider.classList.remove(oe), this.cancelMomentumTracking(), this.scrollToSlide()
        }
        cancelMomentumTracking() {
            cancelAnimationFrame(this.scrollAnimation)
        }
        scrollToSlide() {
            if (!this.velX && !this.isScrolling) return;
            const t = this.slider.querySelector(`${le}.${ae}`);
            if (!t) return;
            const e = parseInt(window.getComputedStyle(t).marginRight) || 0,
                s = t.offsetWidth + e,
                i = t.offsetLeft,
                o = this.velX > 0 ? 1 : -1,
                n = Math.floor(Math.abs(this.velX) / 100) || 1;
            this.startPosition = this.slider.scrollLeft, this.distance = i - this.startPosition, this.startTime = performance.now(), this.isScrolling = !0, o < 0 && this.velX < s && (this.distance -= s * n), o > 0 && this.velX < s && (this.distance += s * n), this.scrollAnimation = requestAnimationFrame(this.scrollStep)
        }
        scrollStep() {
            const t = performance.now() - this.startTime,
                e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(1);
            this.slider.scrollLeft = e, t < this.duration ? this.scrollAnimation = requestAnimationFrame(this.scrollStep) : (this.slider.classList.remove(re), this.velX = 0, this.isScrolling = !1)
        }
        easeOutCubic(t) {
            return t /= this.duration, t--, this.distance * (t * t * t + 1) + this.startPosition
        }
        destroy() {
            this.slider.classList.remove(ne), this.slider.removeEventListener("mousedown", this.handleMouseDown), this.slider.removeEventListener("mouseleave", this.handleMouseLeave), this.slider.removeEventListener("mouseup", this.handleMouseUp), this.slider.removeEventListener("mousemove", this.handleMouseMove), this.slider.removeEventListener("wheel", this.handleMouseWheel)
        }
        constructor(t) {
            this.slider = t, this.isDown = !1, this.startX = 0, this.scrollLeft = 0, this.velX = 0, this.scrollAnimation = null, this.isScrolling = !1, this.duration = 800, this.scrollStep = this.scrollStep.bind(this), this.scrollToSlide = this.scrollToSlide.bind(this), this.handleMouseDown = this.handleMouseDown.bind(this), this.handleMouseLeave = this.handleMouseLeave.bind(this), this.handleMouseUp = this.handleMouseUp.bind(this), this.handleMouseMove = this.handleMouseMove.bind(this), this.handleMouseWheel = this.handleMouseWheel.bind(this), this.slider.addEventListener("mousedown", this.handleMouseDown), this.slider.addEventListener("mouseleave", this.handleMouseLeave), this.slider.addEventListener("mouseup", this.handleMouseUp), this.slider.addEventListener("mousemove", this.handleMouseMove), this.slider.addEventListener("wheel", this.handleMouseWheel, {
                passive: !0
            }), this.slider.classList.add(ne)
        }
    }
    const he = "[data-button-arrow]",
        de = "[data-collection-image]",
        ue = "[data-column-image]",
        pe = "[data-product-image]",
        me = "[data-grid-item]",
        ve = "[data-grid-slider]",
        ge = "data-button-prev",
        fe = "data-button-next",
        ye = "align-arrows",
        be = "slider__arrows",
        we = "is-visible",
        Ee = "scroll-snap-disabled";
    class Se extends HTMLElement {
        connectedCallback() {
            this.init(), this.addEventListener("theme:grid-slider:init", this.init)
        }
        init() {
            var t;
            this.slider = this.querySelector(ve), this.slides = this.querySelectorAll(me), this.buttons = this.querySelectorAll(he), this.slider.classList.add(Ee), this.toggleSlider(), document.addEventListener("theme:resize:width", this.toggleSlider), (t = this, new Promise((e => {
                const s = t.querySelectorAll("[data-aos]");
                let i = 0;

                function o(t) {
                    i++, i === s.length && e(), t.target.removeEventListener("animationend", o)
                }
                s.forEach((t => {
                    t.addEventListener("animationend", o)
                }))
            }))).then((() => {
                this.slider.classList.remove(Ee)
            }))
        }
        toggleSlider() {
            if (!(this.slider.clientWidth < this.getSlidesWidth()) || !y() && window.theme.touch) this.destroy();
            else {
                if (this.isInitialized) return;
                this.slidesObserver = new ie(this.slider, me), this.initArrows(), this.isInitialized = !0, this.draggableSlider = new ce(this.slider)
            }
        }
        initArrows() {
            if (!this.buttons.length) {
                const t = document.createElement("div");
                t.classList.add(be), t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next, this.append(t), this.buttons = this.querySelectorAll(he), this.buttonPrev = this.querySelector(`[${ge}]`), this.buttonNext = this.querySelector(`[${fe}]`)
            }
            this.toggleArrowsObserver(), this.hasAttribute(ye) && (this.positionArrows(), this.arrowsResizeObserver()), this.buttons.forEach((t => {
                t.addEventListener("click", this.onButtonArrowClick)
            }))
        }
        buttonArrowClickEvent(t) {
            t.preventDefault();
            const e = this.slider.querySelector(`${me}.${we}`);
            let s = null;
            t.target.hasAttribute(ge) && (s = null == e ? void 0 : e.previousElementSibling), t.target.hasAttribute(fe) && (s = null == e ? void 0 : e.nextElementSibling), this.goToSlide(s)
        }
        removeArrows() {
            var t;
            null === (t = this.querySelector(`.${be}`)) || void 0 === t || t.remove()
        }
        goToSlide(t) {
            t && this.slider.scrollTo({
                top: 0,
                left: t.offsetLeft,
                behavior: "smooth"
            })
        }
        getSlidesWidth() {
            var t;
            return (null === (t = this.slider.querySelector(me)) || void 0 === t ? void 0 : t.clientWidth) * this.slider.querySelectorAll(me).length
        }
        toggleArrowsObserver() {
            if (this.buttonPrev && this.buttonNext) {
                const t = this.slides.length,
                    e = this.slides[0],
                    s = this.slides[t - 1],
                    i = {
                        attributes: !0,
                        childList: !1,
                        subtree: !1
                    },
                    o = t => {
                        for (const i of t)
                            if ("attributes" === i.type) {
                                const t = i.target,
                                    o = Boolean(t.classList.contains(we));
                                t == e && (this.buttonPrev.disabled = o), t == s && (this.buttonNext.disabled = o)
                            }
                    };
                e && s && (this.firstLastSlidesObserver = new MutationObserver(o), this.firstLastSlidesObserver.observe(e, i), this.firstLastSlidesObserver.observe(s, i))
            }
        }
        positionArrows() {
            const t = this.slider.querySelector(pe) || this.slider.querySelector(de) || this.slider.querySelector(ue) || this.slider;
            t && this.style.setProperty("--button-position", t.clientHeight / 2 + "px")
        }
        arrowsResizeObserver() {
            document.addEventListener("theme:resize:width", this.positionArrows)
        }
        disconnectedCallback() {
            this.destroy(), document.removeEventListener("theme:resize:width", this.toggleSlider)
        }
        destroy() {
            var t, e;
            this.isInitialized = !1, null === (t = this.draggableSlider) || void 0 === t || t.destroy(), this.draggableSlider = null, null === (e = this.slidesObserver) || void 0 === e || e.destroy(), this.slidesObserver = null, this.removeArrows(), document.removeEventListener("theme:resize:width", this.positionArrows)
        }
        constructor() {
            super(), this.isInitialized = !1, this.draggableSlider = null, this.positionArrows = this.positionArrows.bind(this), this.onButtonArrowClick = t => this.buttonArrowClickEvent(t), this.slidesObserver = null, this.firstLastSlidesObserver = null, this.isDragging = !1, this.toggleSlider = this.toggleSlider.bind(this)
        }
    }
    const Le = "time",
        ke = "[data-days]",
        Ae = "[data-hours]",
        Ce = "[data-minutes]",
        Te = "[data-seconds]",
        qe = ".shopify-section",
        xe = "[data-countdown-block]",
        Me = "[data-ticker-text]",
        Pe = "data-expiration-behavior",
        Ie = "data-clone",
        He = "show-message",
        Oe = "hidden",
        Be = "hide-section",
        De = "show-message";
    let Fe = class extends HTMLElement {
        connectedCallback() {
            isNaN(this.endDate) || this.endDate <= Date.now() ? this.onComplete() : (this.update(), this.interval = setInterval(this.update, 1e3))
        }
        disconnectedCallback() {
            this.stopTimer()
        }
        convertTime(t) {
            const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
            t -= e * this.daysInMs;
            const s = this.formatDigits(parseInt(t / this.hoursInMs, 10));
            t -= s * this.hoursInMs;
            const i = this.formatDigits(parseInt(t / this.minutesInMs, 10));
            t -= i * this.minutesInMs;
            return {
                days: e,
                hours: s,
                minutes: i,
                seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10))
            }
        }
        formatDigits(t) {
            return t < 10 && (t = "0" + t), t
        }
        render(t) {
            this.days.textContent = t.days, this.hours.textContent = t.hours, this.minutes.textContent = t.minutes, this.seconds.textContent = t.seconds
        }
        stopTimer() {
            clearInterval(this.interval)
        }
        onComplete() {
            var t, e;
            (this.render({
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            }), this.shouldHideOnComplete) && (null === (t = this.countdownParent) || void 0 === t || t.classList.add(Oe), null === (e = this.countdownParent) || void 0 === e || e.dispatchEvent(new CustomEvent("theme:countdown:hide", {
                detail: {
                    element: this
                },
                bubbles: !0
            })));
            if (this.shouldShowMessage) {
                var s, i;
                if (null === (s = this.classList) || void 0 === s || s.add(He), this.closest(Me).hasAttribute(Ie)) return;
                null === (i = this.countdownParent) || void 0 === i || i.dispatchEvent(new CustomEvent("theme:countdown:expire", {
                    bubbles: !0
                }))
            }
        }
        update() {
            const t = (new Date).getTime(),
                e = this.endDate - t;
            e < 1e3 && (this.stopTimer(), this.onComplete());
            const s = this.convertTime(e);
            this.render(s)
        }
        constructor() {
            super(), this.section = this.closest(qe), this.countdownParent = this.closest(xe) || this.section, this.expirationBehavior = this.getAttribute(Pe), this.time = this.querySelector(Le), this.days = this.querySelector(ke), this.hours = this.querySelector(Ae), this.minutes = this.querySelector(Ce), this.seconds = this.querySelector(Te), this.endDate = Date.parse(this.time.dateTime), this.daysInMs = 864e5, this.hoursInMs = this.daysInMs / 24, this.minutesInMs = this.hoursInMs / 60, this.secondsInMs = this.minutesInMs / 60, this.shouldHideOnComplete = this.expirationBehavior === Be, this.shouldShowMessage = this.expirationBehavior === De, this.update = this.update.bind(this)
        }
    };
    window.requestIdleCallback = window.requestIdleCallback || function(t) {
            var e = Date.now();
            return setTimeout((function() {
                t({
                    didTimeout: !1,
                    timeRemaining: function() {
                        return Math.max(0, 50 - (Date.now() - e))
                    }
                })
            }), 1)
        }, window.cancelIdleCallback = window.cancelIdleCallback || function(t) {
            clearTimeout(t)
        }, window.theme.settings.enableAnimations && (! function() {
            const t = document.querySelectorAll(xt);
            t.length && t.forEach((t => {
                Ot.observe(t)
            }))
        }(), function() {
            const t = document.querySelectorAll(qt);
            t.length && Dt(t)
        }(), new MutationObserver(Ht).observe(document.body, Pt), document.addEventListener("shopify:section:unload", (t => {
            var e;
            const s = "#" + (null === (e = t.target.querySelector("[data-section-id]")) || void 0 === e ? void 0 : e.id),
                i = It.indexOf(s); - 1 !== i && It.splice(i, 1)
        }))), window.addEventListener("resize", v((function() {
            document.dispatchEvent(new CustomEvent("theme:resize", {
                bubbles: !0
            })), w !== g() && (document.dispatchEvent(new CustomEvent("theme:resize:width", {
                bubbles: !0
            })), w = g()), E !== f() && (document.dispatchEvent(new CustomEvent("theme:resize:height", {
                bubbles: !0
            })), E = f())
        }), 50)),
        function() {
            let t;
            window.addEventListener("scroll", (function() {
                t && window.cancelAnimationFrame(t), t = window.requestAnimationFrame((function() {
                    ! function() {
                        const t = window.scrollY;
                        t > S ? (k = !0, L = !1) : t < S ? (k = !1, L = !0) : (L = null, k = null), S = t, document.dispatchEvent(new CustomEvent("theme:scroll", {
                            detail: {
                                up: L,
                                down: k,
                                position: t
                            },
                            bubbles: !1
                        })), L && !A && document.dispatchEvent(new CustomEvent("theme:scroll:up", {
                            detail: {
                                position: t
                            },
                            bubbles: !1
                        })), k && !C && document.dispatchEvent(new CustomEvent("theme:scroll:down", {
                            detail: {
                                position: t
                            },
                            bubbles: !1
                        })), C = k, A = L
                    }()
                }))
            }), {
                passive: !0
            }), window.addEventListener("theme:scroll:lock", q), window.addEventListener("theme:scroll:unlock", x)
        }(), "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? (document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch"), window.theme.touch = !0) : window.theme.touch = !1, d(), document.addEventListener("load", (t => {
            "img" == t.target.tagName.toLowerCase() && t.target.classList.contains(O) && (t.target.classList.remove(O), t.target.parentNode.classList.remove(O), t.target.parentNode.parentNode.classList.contains(O) && t.target.parentNode.parentNode.classList.remove(O))
        }), !0), window.addEventListener("DOMContentLoaded", (() => {
            h(), H(document), a(document), I(document), document.querySelectorAll(B).forEach((t => {
                t.complete && (t.classList.remove(O), t.parentNode.classList.remove(O), t.parentNode.parentNode.classList.contains(O) && t.parentNode.parentNode.classList.remove(O))
            })), document.body.classList.add("is-loaded"), requestIdleCallback((() => {
                Shopify.visualPreviewMode && document.documentElement.classList.add("preview-mode")
            }))
        })), document.addEventListener("shopify:section:load", (t => {
            const e = t.target;
            a(e), I(e), H(document), h()
        })), customElements.get("popout-select") || customElements.define("popout-select", At), customElements.get("quantity-counter") || customElements.define("quantity-counter", Ct), customElements.get("predictive-search") || customElements.define("predictive-search", lt), customElements.get("deferred-media") || customElements.define("deferred-media", Jt), customElements.get("grid-slider") || customElements.define("grid-slider", Se), customElements.get("countdown-timer") || customElements.define("countdown-timer", Fe), customElements.get("product-notification") || customElements.define("product-notification", ee);
    const $e = (t, e = !1, s = "block") => {
        t && (e ? t.style.removeProperty("display") : t.style.display = s)
    };
    Shopify.Products = function() {
        const t = {
            howManyToShow: 4,
            howManyToStoreInMemory: 10,
            wrapperId: "recently-viewed-products",
            section: null,
            target: "api-product-grid-item",
            onComplete: null
        };
        let e = [],
            s = null,
            i = null;
        const o = new Date,
            n = new Date;
        n.setTime(o.getTime() + 7776e6);
        const r = {
                configuration: {
                    expires: n.toGMTString(),
                    path: "/",
                    domain: window.location.hostname,
                    sameSite: "none",
                    secure: !0
                },
                name: "shopify_recently_viewed",
                write: function(t) {
                    const e = t.join(" ");
                    document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`
                },
                read: function() {
                    let t = [],
                        e = null;
                    return -1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t => t.startsWith(this.name))) && (e = document.cookie.split("; ").find((t => t.startsWith(this.name))).split("=")[1]), null !== e && (t = e.split(" ")), t
                },
                destroy: function() {
                    document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`
                },
                remove: function(t) {
                    const e = this.read(),
                        s = e.indexOf(t); - 1 !== s && (e.splice(s, 1), this.write(e))
                }
            },
            a = (e, s, o, n, l, c) => {
                s.length && e < c ? fetch(`${window.theme.routes.root}products/${s[0]}?section_id=${l}`).then((t => t.text())).then((t => {
                    const i = 100 * e,
                        r = o.id ? `#${o.id}` : "",
                        h = document.createElement("div");
                    let d = t;
                    d = d.includes("||itemAnimationDelay||") ? d.replaceAll("||itemAnimationDelay||", i) : d, d = d.includes("||itemAnimationAnchor||") ? d.replaceAll("||itemAnimationAnchor||", r) : d, h.innerHTML = d, o.innerHTML += h.querySelector("[data-api-content]").innerHTML, s.shift(), e++, a(e, s, o, n, l, c)
                })).catch((() => {
                    r.remove(s[0]), s.shift(), a(e, s, o, n, l, c)
                })) : ((e, s) => {
                    $e(e, !0);
                    const o = r.read().length;
                    if (Shopify.recentlyViewed && i && o && o < i && e.children.length) {
                        let t = [],
                            s = [],
                            i = 0;
                        for (const e in Shopify.recentlyViewed) {
                            i += 1;
                            const o = Shopify.recentlyViewed[e].split(" "),
                                n = parseInt(e.split("_")[1]);
                            t = [...t, ...o], (r.read().length === n || i === Object.keys(Shopify.recentlyViewed).length && !s.length) && (s = [...s, ...o])
                        }
                        for (let i = 0; i < e.children.length; i++) {
                            const o = e.children[i];
                            t.length && o.classList.remove(...t), s.length && o.classList.add(...s)
                        }
                    }
                    if (t.onComplete) try {
                        t.onComplete(e, s)
                    } catch (t) {
                        console.log(t)
                    }
                })(o, n)
            };
        return {
            showRecentlyViewed: function(o) {
                const n = o || {};
                Object.assign(t, n), e = r.read(), s = document.querySelector(`#${t.wrapperId}`), i = t.howManyToShow, t.howManyToShow = Math.min(e.length, t.howManyToShow), t.howManyToShow && s && a(0, e, s, t.section, t.target, i)
            },
            getConfig: function() {
                return t
            },
            clearList: function() {
                r.destroy()
            },
            recordRecentlyViewed: function(e) {
                const s = e || {};
                Object.assign(t, s);
                let i = r.read();
                if (-1 !== window.location.pathname.indexOf("/products/")) {
                    let e = decodeURIComponent(window.location.pathname).match(/\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/)[0].split("/products/")[1];
                    t.handle && (e = t.handle);
                    const s = i.indexOf(e); - 1 === s ? (i.unshift(e), i = i.splice(0, t.howManyToStoreInMemory)) : (i.splice(s, 1), i.unshift(e)), r.write(i)
                }
            },
            hasProducts: r.read().length > 0
        }
    }();
    const _e = (t, e = [], s = !1) => {
        const i = Object.keys(t).map((i => {
            let o = t[i];
            if ("[object Object]" === Object.prototype.toString.call(o) || Array.isArray(o)) return Array.isArray(t) ? e.push("") : e.push(i), _e(o, e, Array.isArray(o));
            {
                let t = i;
                if (e.length > 0) {
                    t = (s ? e : [...e, i]).reduce(((t, e) => "" === t ? e : `${t}[${e}]`), "")
                }
                return s ? `${t}[]=${o}` : `${t}=${o}`
            }
        })).join("&");
        return e.pop(), i
    };

    function Ne(t) {
        this.status = t.status || null, this.headers = t.headers || null, this.json = t.json || null, this.body = t.body || null
    }
    Ne.prototype = Error.prototype;
    const Re = "is-focused",
        We = "[data-skip-content]",
        ze = 'a[href="#"]';
    window.accessibility = new class {
        init() {
            this.a11y = W, this.html = document.documentElement, this.body = document.body, this.inPageLink = document.querySelector(We), this.linkesWithOnlyHash = document.querySelectorAll(ze), this.a11y.focusHash(), this.a11y.bindInPageLinks(), this.clickEvents(), this.focusEvents()
        }
        clickEvents() {
            this.inPageLink && this.inPageLink.addEventListener("click", (t => {
                t.preventDefault()
            })), this.linkesWithOnlyHash && this.linkesWithOnlyHash.forEach((t => {
                t.addEventListener("click", (t => {
                    t.preventDefault()
                }))
            }))
        }
        focusEvents() {
            document.addEventListener("mousedown", (() => {
                this.body.classList.remove(Re)
            })), document.addEventListener("keyup", (t => {
                "Tab" === t.code && this.body.classList.add(Re)
            }))
        }
        constructor() {
            this.init()
        }
    };
    const Ue = (t, e) => {
            let s, i;
            return function o(...n) {
                const r = Date.now();
                i = clearTimeout(i), !s || r - s >= e ? (t.apply(null, n), s = r) : i = setTimeout(o.bind(null, ...n), e - (r - s))
            }
        },
        Ve = "is-animated",
        je = "is-added",
        Xe = "is-disabled",
        Je = "is-empty",
        Ye = "is-hidden",
        Qe = "is-hiding",
        Ge = "is-loading",
        Ke = "is-open",
        Ze = "is-removed",
        ts = "is-success",
        es = "is-visible",
        ss = "is-expanded",
        is = "is-updated",
        os = "variant--soldout",
        ns = "variant--unavailable",
        rs = "[data-api-content]",
        as = "[data-api-line-items]",
        ls = "[data-api-upsell-items]",
        cs = "[data-api-cart-price]",
        hs = "[data-animation]",
        ds = "[data-skip-upsell-product]",
        us = "[data-add-to-cart-bar]",
        ps = "[data-cart-error-close]",
        ms = "cart-drawer",
        vs = "[data-cart-drawer-close]",
        gs = "[data-cart-empty]",
        fs = "[data-cart-errors]",
        ys = "[data-item-remove]",
        bs = "[data-cart-page]",
        ws = "[data-cart-form]",
        Es = "[data-cart-acceptance-checkbox]",
        Ss = "[data-cart-checkout-buttons]",
        Ls = "[data-cart-checkout-button]",
        ks = "[data-cart-total]",
        As = "[data-checkout-buttons]",
        Cs = "[data-error-message]",
        Ts = "[data-close-error]",
        qs = "[data-cart-errors-container]",
        xs = "[data-form-wrapper]",
        Ms = "[data-free-shipping]",
        Ps = "[data-progress-graph]",
        Is = "[data-progress-bar]",
        Hs = "[data-header-wrapper]",
        Os = "[data-item]",
        Bs = "[data-items-holder]",
        Ds = "[data-left-to-spend]",
        Fs = "[data-drawer]",
        $s = "[data-section-id]",
        _s = "[data-cart-price-holder]",
        Ns = "[data-quick-add-holder]",
        Rs = "[data-quick-add-modal]",
        Ws = 'input[name="updates[]"]',
        zs = "[data-upsell-products]",
        Us = "[data-upsell-widget]",
        Vs = "[data-terms-error-message]",
        js = "[data-collapsible-body]",
        Xs = "recently-viewed-products-cart",
        Js = "data-cart-total",
        Ys = "disabled",
        Qs = "data-free-shipping",
        Gs = "data-free-shipping-limit",
        Ks = "data-item",
        Zs = "data-item-index",
        ti = "data-item-title",
        ei = "open",
        si = "data-quick-add-holder",
        ii = "data-scroll-locked",
        oi = "data-upsell-auto-open";
    let ni = class extends HTMLElement {
        connectedCallback() {
            this.cartPage = document.querySelector(bs), this.cartForm = document.querySelector(ws), this.cartDrawer = document.querySelector(ms), this.cartEmpty = document.querySelector(gs), this.cartTermsCheckbox = document.querySelector(Es), this.cartCheckoutButtonWrapper = document.querySelector(Ss), this.cartCheckoutButton = document.querySelector(Ls), this.checkoutButtons = document.querySelector(As), this.itemsHolder = document.querySelector(Bs), this.priceHolder = document.querySelector(_s), this.items = document.querySelectorAll(Os), this.cartTotal = document.querySelector(ks), this.freeShipping = document.querySelectorAll(Ms), this.cartErrorHolder = document.querySelector(fs), this.cartCloseErrorMessage = document.querySelector(ps), this.headerWrapper = document.querySelector(Hs), this.navDrawer = document.querySelector(Fs), this.upsellProductsHolder = document.querySelector(zs), this.subtotal = window.theme.subtotal, this.cart = this.cartDrawer || this.cartPage, this.animateItems = this.animateItems.bind(this), this.addToCart = this.addToCart.bind(this), this.cartAddEvent = this.cartAddEvent.bind(this), this.updateProgress = this.updateProgress.bind(this), this.onCartDrawerClose = this.onCartDrawerClose.bind(this), document.addEventListener("theme:cart:add", this.cartAddEvent), document.addEventListener("theme:cart-drawer:open", this.animateItems), document.addEventListener("theme:cart-drawer:close", this.onCartDrawerClose), document.addEventListener("theme:announcement:init", this.updateProgress), this.skipUpsellProductsArray = [], this.skipUpsellProductEvent(), this.checkSkippedUpsellProductsFromStorage(), this.toggleCartUpsellWidgetVisibility(), this.circumference = 28 * Math.PI, this.freeShippingLimit = this.freeShipping.length ? 100 * Number(this.freeShipping[0].getAttribute(Gs)) * window.Shopify.currency.rate : 0, this.freeShippingMessageHandle(this.subtotal), this.updateProgress(), this.cart && (this.build = this.build.bind(this), this.updateCart = this.updateCart.bind(this), this.productAddCallback = this.productAddCallback.bind(this), this.formSubmitHandler = Ue(this.formSubmitHandler.bind(this), 50), this.cartPage && this.animateItems(), this.recentlyViewedProducts(), this.hasItemsInCart = this.hasItemsInCart.bind(this), this.cartCount = this.getCartItemCount(), this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this), this.totalItems = this.items.length, this.cartUpdateFailed = !1, this.cartEvents(), this.cartRemoveEvents(), this.cartUpdateEvents(), document.addEventListener("theme:product:add", this.productAddCallback), document.addEventListener("theme:product:add-error", this.productAddCallback), document.dispatchEvent(new CustomEvent("theme:cart:load", {
                bubbles: !0
            })))
        }
        disconnectedCallback() {
            document.removeEventListener("theme:cart:add", this.cartAddEvent), document.removeEventListener("theme:announcement:init", this.updateProgress), document.removeEventListener("theme:product:add", this.productAddCallback), document.removeEventListener("theme:product:add-error", this.productAddCallback), document.dispatchEvent(new CustomEvent("theme:cart:unload", {
                bubbles: !0
            })), document.documentElement.hasAttribute(ii) && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            }))
        }
        onCartDrawerClose() {
            var t;
            this.resetAnimatedItems(), (null === (t = this.cartDrawer) || void 0 === t ? void 0 : t.classList.contains(Ke)) && this.cart.classList.remove(is), this.cartEmpty.classList.remove(is), this.cartErrorHolder.classList.remove(ss), this.cart.querySelectorAll(hs).forEach((t => {
                const e = () => {
                    t.classList.remove(Qe), t.removeEventListener("animationend", e)
                };
                t.classList.add(Qe), t.addEventListener("animationend", e)
            }))
        }
        cartUpdateEvents() {
            this.items = document.querySelectorAll(Os), this.items.forEach((t => {
                t.addEventListener("theme:cart:update", (e => {
                    this.updateCart({
                        id: e.detail.id,
                        quantity: e.detail.quantity
                    }, t)

                }))
            }))
        }
        cartRemoveEvents() {
            document.querySelectorAll(ys).forEach((t => {
                const e = t.closest(Os);
                t.addEventListener("click", (s => {
                    s.preventDefault(), t.classList.contains(Xe) || this.updateCart({
                        id: t.dataset.id,
                        quantity: 0
                    }, e)
                }))
            })), this.cartCloseErrorMessage && this.cartCloseErrorMessage.addEventListener("click", (t => {
                t.preventDefault(), this.cartErrorHolder.classList.remove(ss)
            }))
        }
        cartAddEvent(t) {
            let e = "",
                s = t.detail.button;
            if (s.hasAttribute("disabled")) return;
            const i = s.closest("form");
            i.checkValidity() ? (e = new FormData(i), null !== i && i.querySelector('[type="file"]') || (t.preventDefault(), this.addToCart(e, s))) : i.reportValidity()
        }
        cartEvents() {
            this.cartTermsCheckbox && (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler), this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler), this.cartForm.removeEventListener("submit", this.formSubmitHandler), this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler), this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler), this.cartForm.addEventListener("submit", this.formSubmitHandler))
        }
        formSubmitHandler() {
            const t = document.querySelector(Es).checked,
                e = document.querySelector(Vs);
            if (t) e.classList.remove(ss), this.cartCheckoutButton.removeAttribute(Ys);
            else {
                if (document.querySelector(Vs).length > 0) return;
                e.innerText = theme.strings.cartAcceptanceError, this.cartCheckoutButton.setAttribute(Ys, !0), e.classList.add(ss)
            }
        }
        formErrorsEvents(t) {
            const e = t.querySelector(Ts);
            null == e || e.addEventListener("click", (e => {
                e.preventDefault(), t && t.classList.remove(es)
            }))
        }
        getCart() {
            fetch(theme.routes.cart_url + "?section_id=api-cart-items").then(this.cartErrorsHandler).then((t => t.text())).then((t => {
                const e = document.createElement("div");
                e.innerHTML = t;
                const s = e.querySelector(rs);
                this.build(s)
            })).catch((t => console.log(t)))
        }
        addToCart(t, e) {
            this.cart && this.cart.classList.add(Ge);
            const s = null == e ? void 0 : e.closest(Ns);
            e && (e.classList.add(Ge), e.disabled = !0), s && s.classList.add(es), fetch(theme.routes.cart_add_url, {
                method: "POST",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    Accept: "application/javascript"
                },
                body: t
            }).then((t => t.json())).then((t => {
                if (t.status) return this.addToCartError(t, e), void(e && (e.classList.remove(Ge), e.disabled = !1));
                this.cart ? (e && (e.classList.remove(Ge), e.classList.add(je), e.dispatchEvent(new CustomEvent("theme:product:add", {
                    detail: {
                        response: t,
                        button: e
                    },
                    bubbles: !0
                }))), this.getCart()) : window.location = theme.routes.cart_url
            })).catch((t => {
                this.addToCartError(t, e), this.enableCartButtons()
            }))
        }
        updateCart(t = {}, e = null) {
            this.cart.classList.add(Ge);
            let s = t.quantity;
            null !== e && (s ? e.classList.add(Ge) : e.classList.add(Ze)), this.disableCartButtons();
            const i = this.cart.querySelector(`[${Ks}="${t.id}"]`) || e,
                o = (null == i ? void 0 : i.hasAttribute(Zs)) ? parseInt(i.getAttribute(Zs)) : 0,
                n = (null == i ? void 0 : i.hasAttribute(ti)) ? i.getAttribute(ti) : null;
            if (0 === o) return;
            const r = {
                line: o,
                quantity: s
            };
            fetch(theme.routes.cart_change_url, {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify(r)
            }).then((t => t.text())).then((t => {
                if (JSON.parse(t).errors) return this.cartUpdateFailed = !0, this.updateErrorText(n), this.toggleErrorMessage(), this.resetLineItem(e), void this.enableCartButtons();
                this.getCart()
            })).catch((t => {
                console.log(t), this.enableCartButtons()
            }))
        }
        resetLineItem(t) {
            const e = t.querySelector(Ws),
                s = e.getAttribute("value");
            e.value = s, t.classList.remove(Ge)
        }
        disableCartButtons() {
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${ys}`);
            t.length && t.forEach((t => {
                t.classList.add(Xe), t.blur(), t.disabled = !0
            })), e.length && e.forEach((t => {
                t.setAttribute(Ys, !0)
            }))
        }
        enableCartButtons() {
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${ys}`);
            t.length && t.forEach((t => {
                t.classList.remove(Xe), t.disabled = !1
            })), e.length && e.forEach((t => {
                t.removeAttribute(Ys)
            })), this.cart.classList.remove(Ge)
        }
        updateErrorText(t) {
            this.cartErrorHolder.querySelector(Cs).innerText = t
        }
        toggleErrorMessage() {
            this.cartErrorHolder && (this.cartErrorHolder.classList.toggle(ss, this.cartUpdateFailed), this.cartUpdateFailed = !1)
        }
        cartErrorsHandler(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new Ne({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        addToCartError(t, e) {
            var s;
            if (null !== e) {
                const s = e.closest($s) || e.closest(Ns) || e.closest(Rs);
                let i = null == s ? void 0 : s.querySelector(qs);
                const o = e.closest(Ns);
                if (o && o.querySelector(qs) && (i = o.querySelector(qs)), i) {
                    let e = `${t.message}: ${t.description}`;
                    t.message == t.description && (e = t.message), i.innerHTML = `<div class="errors">${e}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`, i.classList.add(es), this.formErrorsEvents(i)
                }
                e.dispatchEvent(new CustomEvent("theme:product:add-error", {
                    detail: {
                        response: t,
                        button: e
                    },
                    bubbles: !0
                }))
            }
            const i = null == e ? void 0 : e.closest(Ns);
            i && i.dispatchEvent(new CustomEvent("theme:cart:error", {
                bubbles: !0,
                detail: {
                    message: t.message,
                    description: t.description,
                    holder: i
                }
            })), null === (s = this.cart) || void 0 === s || s.classList.remove(Ge)
        }
        productAddCallback(t) {
            let e = [],
                s = null;
            const i = "theme:product:add-error" == t.type,
                o = t.detail.button,
                n = document.querySelector(us);
            e.push(o), s = o.closest(Ns), n && e.push(n), e.forEach((t => {
                t.classList.remove(Ge), i || t.classList.add(je)
            })), setTimeout((() => {
                e.forEach((t => {
                    var e, s;
                    t.classList.remove(je);
                    (null === (e = t.closest(xs)) || void 0 === e ? void 0 : e.classList.contains(os)) || (null === (s = t.closest(xs)) || void 0 === s ? void 0 : s.classList.contains(ns)) || (t.disabled = !1)
                })), null == s || s.classList.remove(es)
            }), 1e3)
        }
        toggleClassesOnContainers() {
            const t = this.hasItemsInCart();
            this.cart.classList.toggle(Je, !t), t || setTimeout((() => {
                _(this.cartDrawer, {
                    elementToFocus: this.cartDrawer.querySelector(vs)
                })
            }), 100)
        }
        build(t) {
            var e;
            const i = t.querySelector(as),
                o = t.querySelector(ls),
                n = Boolean(null === i && null === o),
                r = t.querySelector(cs),
                a = t.querySelector(ks);

            this.priceHolder && r && (this.priceHolder.innerHTML = r.innerHTML), n ? (this.itemsHolder.innerHTML = t.innerHTML, this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = "")) : (this.itemsHolder.innerHTML = i.innerHTML, this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = o.innerHTML), this.skipUpsellProductEvent(), this.checkSkippedUpsellProductsFromStorage(), this.toggleCartUpsellWidgetVisibility()), this.newTotalItems = i && i.querySelectorAll(Os).length ? i.querySelectorAll(Os).length : 0, this.subtotal = a && a.hasAttribute(Js) ? parseInt(a.getAttribute(Js)) : 0, this.cartCount = this.getCartItemCount(), document.dispatchEvent(new CustomEvent("theme:cart:change", {
                bubbles: !0,
                detail: {
                    cartCount: this.cartCount
                }
            })), this.cartTotal.innerHTML = 0 === this.subtotal ? window.theme.strings.free : s.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat), this.totalItems !== this.newTotalItems && (this.totalItems = this.newTotalItems, this.toggleClassesOnContainers()), (null === (e = this.cartDrawer) || void 0 === e ? void 0 : e.classList.contains(Ke)) && this.cart.classList.add(is), this.cart.classList.remove(Ge), this.hasItemsInCart() || this.cartEmpty.querySelectorAll(hs).forEach((t => {
                t.classList.remove(Ve)
            })), this.freeShippingMessageHandle(this.subtotal), this.cartRemoveEvents(), this.cartUpdateEvents(), this.toggleErrorMessage(), this.enableCartButtons(), this.updateProgress(), this.animateItems(), document.dispatchEvent(new CustomEvent("theme:product:added", {
                bubbles: !0
            }))

            const total = this.cartTotal.textContent.replace(/[^0-9.-]/g, '');
            document.dispatchEvent(
                new CustomEvent('cart:updated', {
                    detail: {
                    cartTotal: Number(total),
                    itemCount: this.cartCount
                    }
                })
            );
        }
        getCartItemCount() {
            return Array.from(this.cart.querySelectorAll(Ws)).reduce(((t, e) => t + parseInt(e.value)), 0)
        }
        hasItemsInCart() {
            return this.totalItems > 0
        }
        freeShippingMessageHandle(t) {
            this.freeShipping.length && this.freeShipping.forEach((e => {
                const s = e.hasAttribute(Qs) && "true" === e.getAttribute(Qs) && t >= 0;
                e.classList.toggle(ts, s && t >= this.freeShippingLimit)
            }))
        }
        updateProgress() {
            if (this.freeShipping = document.querySelectorAll(Ms), !this.freeShipping.length) return;
            const t = isNaN(this.subtotal / this.freeShippingLimit) ? 100 : this.subtotal / this.freeShippingLimit,
                e = Math.min(100 * t, 100),
                i = this.circumference - e / 100 * this.circumference / 2,
                o = s.formatMoney(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
            this.freeShipping.forEach((t => {
                const s = t.querySelector(Is),
                    n = t.querySelector(Ps),
                    r = t.querySelector(Ds);
                r && (r.innerHTML = o.replace(".00", "")), s && (s.value = e), n && n.style.setProperty("--stroke-dashoffset", `${i}`)
            }))
        }
        skipUpsellProductEvent() {
            if (null === this.upsellProductsHolder) return;
            const t = this.upsellProductsHolder.querySelectorAll(ds);
            t.length && t.forEach((t => {
                t.addEventListener("click", (e => {
                    e.preventDefault();
                    const s = t.closest(Ns).getAttribute(si);
                    this.skipUpsellProductsArray.includes(s) || this.skipUpsellProductsArray.push(s), window.sessionStorage.setItem("skip_upsell_products", this.skipUpsellProductsArray), this.removeUpsellProduct(s), this.toggleCartUpsellWidgetVisibility()
                }))
            }))
        }
        checkSkippedUpsellProductsFromStorage() {
            const t = window.sessionStorage.getItem("skip_upsell_products");
            if (!t) return;
            t.split(",").forEach((t => {
                this.skipUpsellProductsArray.includes(t) || this.skipUpsellProductsArray.push(t), this.removeUpsellProduct(t)
            }))
        }
        removeUpsellProduct(t) {
            if (!this.upsellProductsHolder) return;
            const e = this.upsellProductsHolder.querySelector(`[${si}="${t}"]`);
            e && e.parentNode.remove()
        }
        toggleCartUpsellWidgetVisibility() {
            if (!this.upsellProductsHolder) return;
            const t = this.upsellProductsHolder.querySelectorAll(Ns),
                e = this.upsellProductsHolder.closest(Us);
            if (e && (e.classList.toggle(Ye, !t.length), t.length && !e.hasAttribute(ei) && e.hasAttribute(oi))) {
                e.setAttribute(ei, !0);
                const t = e.querySelector(js);
                t && (t.style.height = "auto")
            }
        }
        resetAnimatedItems() {
            this.cart.querySelectorAll(hs).forEach((t => {
                t.classList.remove(Ve), t.classList.remove(Qe)
            }))
        }
        animateItems(t) {
            requestAnimationFrame((() => {
                let e = this.cart;
                t && t.detail && t.detail.target && (e = t.detail.target), null == e || e.querySelectorAll(hs).forEach((t => {
                    t.classList.add(Ve)
                }))
            }))
        }
        recentlyViewedProducts() {
            this.cart.querySelector(`#${Xs}`) && Shopify.Products.showRecentlyViewed({
                howManyToShow: 3,
                wrapperId: Xs,
                section: this,
                target: "api-upsell-product"
            })
        }
        constructor() {
            super()
        }
    };
    customElements.get("cart-items") || customElements.define("cart-items", ni);
    const ri = "data-cart-count",
        ai = "data-limit";
    let li = class extends HTMLElement {
        connectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback)
        }
        disconnectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback)
        }
        onCartChange(t) {
            this.cartCount = t.detail.cartCount, this.update()
        }
        update() {
            if (null !== this.cartCount) {
                this.setAttribute(ri, this.cartCount);
                let t = this.cartCount;
                this.limit && this.cartCount >= this.limit && (t = "9+"), this.innerText = t
            }
        }
        constructor() {
            super(), this.cartCount = null, this.limit = this.getAttribute(ai), this.onCartChangeCallback = this.onCartChange.bind(this)
        }
    };

    function ci(t) {
        return new Promise((e => {
            null == t || t.addEventListener("animationend", (function s(i) {
                i.target == t && (t.removeEventListener("animationend", s), e())
            }))
        }))
    }
    customElements.get("cart-count") || customElements.define("cart-count", li);
    const hi = "is-open",
        di = "is-closing",
        ui = "drawer--duplicate",
        pi = "drawer-editor-error",
        mi = {
            cartDrawer: "cart-drawer",
            cartDrawerClose: "[data-cart-drawer-close]",
            cartDrawerSection: '[data-section-type="cart-drawer"]',
            cartDrawerInner: "[data-cart-drawer-inner]",
            shopifySection: ".shopify-section"
        },
        vi = "data-drawer-underlay";
    let gi = class extends HTMLElement {
        connectedCallback() {
            const t = this.closest(mi.shopifySection);
            if (window.theme.hasCartDrawer) {
                if (!window.Shopify.designMode) return void t.remove();
                {
                    const t = document.createElement("div");
                    t.classList.add(pi), t.innerText = "Cart drawer section already exists.", this.querySelector(`.${pi}`) || this.querySelector(mi.cartDrawerInner).append(t), this.classList.add(ui)
                }
            }
            window.theme.hasCartDrawer = !0, this.addEventListener("theme:cart-drawer:show", this.openCartDrawer), document.addEventListener("theme:cart:toggle", this.toggleCartDrawer), document.addEventListener("theme:quick-add:open", this.closeCartDrawer), document.addEventListener("theme:product:added", this.openCartDrawerOnProductAdded), document.addEventListener("shopify:block:select", this.openCartDrawerOnSelect), document.addEventListener("shopify:section:select", this.openCartDrawerOnSelect), document.addEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:product:added", this.openCartDrawerOnProductAdded), document.removeEventListener("theme:cart:toggle", this.toggleCartDrawer), document.removeEventListener("theme:quick-add:open", this.closeCartDrawer), document.removeEventListener("shopify:block:select", this.openCartDrawerOnSelect), document.removeEventListener("shopify:section:select", this.openCartDrawerOnSelect), document.removeEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect), document.querySelectorAll(mi.cartDrawer).length <= 1 && (window.theme.hasCartDrawer = !1)
        }
        openCartDrawerOnProductAdded() {
            this.cartDrawerIsOpen || this.openCartDrawer()
        }
        openCartDrawerOnSelect(t) {
            (t.target.querySelector(mi.shopifySection) || t.target.closest(mi.shopifySection) || t.target) === this.cartDrawerSection && this.openCartDrawer(!0)
        }
        closeCartDrawerOnDeselect() {
            this.cartDrawerIsOpen && this.closeCartDrawer()
        }
        openCartDrawer(t = !1) {
            !t && this.classList.contains(ui) || (this.cartDrawerIsOpen = !0, this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this), document.body.addEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:cart-drawer:open", {
                detail: {
                    target: this
                },
                bubbles: !0
            })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), this.classList.add(hi), this.observeAdditionalCheckoutButtons(), ci(this.cartDrawerInner).then((() => {
                _(this, {
                    elementToFocus: this.querySelector(mi.cartDrawerClose)
                })
            })))
        }
        closeCartDrawer() {
            this.classList.contains(hi) && (this.classList.add(di), this.classList.remove(hi), this.cartDrawerIsOpen = !1, document.dispatchEvent(new CustomEvent("theme:cart-drawer:close", {
                bubbles: !0
            })), N(), R(), document.body.removeEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            })), ci(this.cartDrawerInner).then((() => {
                this.classList.remove(di)
            })))
        }
        toggleCartDrawer() {
            this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer()
        }
        closeCartEvents() {
            this.cartDrawerClose.addEventListener("click", (t => {
                t.preventDefault(), this.closeCartDrawer()
            })), this.addEventListener("keyup", (t => {
                "Escape" === t.code && this.closeCartDrawer()
            }))
        }
        onBodyClick(t) {
            t.target.hasAttribute(vi) && this.closeCartDrawer()
        }
        observeAdditionalCheckoutButtons() {
            const t = this.querySelector(mi.additionalCheckoutButtons);
            if (t) {
                const e = new MutationObserver((() => {
                    _(this, {
                        elementToFocus: this.querySelector(mi.cartDrawerClose)
                    }), e.disconnect()
                }));
                e.observe(t, {
                    subtree: !0,
                    childList: !0
                })
            }
        }
        constructor() {
            super(), this.cartDrawerIsOpen = !1, this.cartDrawerClose = this.querySelector(mi.cartDrawerClose), this.cartDrawerInner = this.querySelector(mi.cartDrawerInner), this.openCartDrawer = this.openCartDrawer.bind(this), this.closeCartDrawer = this.closeCartDrawer.bind(this), this.toggleCartDrawer = this.toggleCartDrawer.bind(this), this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this), this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this), this.closeCartDrawerOnDeselect = this.closeCartDrawerOnDeselect.bind(this), this.cartDrawerSection = this.closest(mi.shopifySection), this.closeCartEvents()
        }
    };
    customElements.get("cart-drawer") || customElements.define("cart-drawer", gi);
    const fi = "[data-collapsible]",
        yi = "[data-collapsible-trigger]",
        bi = "[data-collapsible-body]",
        wi = "[data-collapsible-content]",
        Ei = "open",
        Si = "single";
    let Li = class extends HTMLElement {
        connectedCallback() {
            this.collapsibles.forEach((t => {
                const e = t.querySelector(yi),
                    s = t.querySelector(bi);
                e.addEventListener("click", (t => this.onCollapsibleClick(t))), s.addEventListener("transitionend", (e => {
                    e.target === s && ("true" == t.getAttribute(Ei) && this.setBodyHeight(s, "auto"), "false" == t.getAttribute(Ei) && (t.removeAttribute(Ei), this.setBodyHeight(s, "")))
                }))
            }))
        }
        open(t) {
            if ("true" == t.getAttribute("open")) return;
            const e = t.querySelector(bi),
                s = t.querySelector(wi);
            t.setAttribute("open", !0), this.setBodyHeight(e, s.offsetHeight)
        }
        close(t) {
            if (!t.hasAttribute("open")) return;
            const e = t.querySelector(bi),
                s = t.querySelector(wi);
            this.setBodyHeight(e, s.offsetHeight), t.setAttribute("open", !1), requestAnimationFrame((() => {
                requestAnimationFrame((() => {
                    this.setBodyHeight(e, 0)
                }))
            }))
        }
        setBodyHeight(t, e) {
            t.style.height = "auto" !== e && "" !== e ? `${e}px` : e
        }
        onCollapsibleClick(t) {
            t.preventDefault();
            const e = (t.target.matches(yi) ? t.target : t.target.closest(yi)).closest(fi);
            this.single && this.collapsibles.forEach((t => {
                t.hasAttribute(Ei) && t != e && requestAnimationFrame((() => {
                    this.close(t)
                }))
            })), e.hasAttribute(Ei) ? this.close(e) : this.open(e), e.dispatchEvent(new CustomEvent("theme:form:sticky", {
                bubbles: !0,
                detail: {
                    element: "accordion"
                }
            }))
        }
        constructor() {
            super(), this.collapsibles = this.querySelectorAll(fi), this.single = this.hasAttribute(Si)
        }
    };
    customElements.get("collapsible-elements") || customElements.define("collapsible-elements", Li);
    const ki = "details",
        Ai = "[data-popdown]",
        Ci = "[data-popdown-close]",
        Ti = 'input:not([type="hidden"])',
        qi = "data-popdown-underlay",
        xi = "is-open";
    let Mi = class extends HTMLElement {
        connectedCallback() {
            this.popdown.addEventListener("transitionend", this.popdownTransitionCallback), this.popdownContainer.addEventListener("keyup", (t => "ESCAPE" === t.code.toUpperCase() && this.close())), this.popdownContainer.addEventListener("toggle", this.detailsToggleCallback), this.popdownClose.addEventListener("click", this.close.bind(this))
        }
        detailsToggleCallback(t) {
            t.target.hasAttribute("open") && this.open()
        }
        popdownTransitionCallback(t) {
            t.target === this.popdown && (this.classList.contains(xi) ? "transform" === t.propertyName && this.a11y.trapFocus(this.popdown, {
                elementToFocus: this.popdown.querySelector(Ti)
            }) : (this.popdownContainer.removeAttribute("open"), this.a11y.removeTrapFocus()))
        }
        onBodyClick(t) {
            this.contains(t.target) && !t.target.hasAttribute(qi) || this.close()
        }
        open() {
            this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this), document.body.addEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), requestAnimationFrame((() => {
                this.classList.add(xi)
            }))
        }
        close() {
            this.classList.remove(xi), document.body.removeEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            }))
        }
        constructor() {
            super(), this.popdown = this.querySelector(Ai), this.popdownContainer = this.querySelector(ki), this.popdownClose = this.querySelector(Ci), this.popdownTransitionCallback = this.popdownTransitionCallback.bind(this), this.detailsToggleCallback = this.detailsToggleCallback.bind(this), this.a11y = W
        }
    };
    customElements.define("header-search-popdown", Mi);
    const Pi = 'input[type="search"]';
    customElements.define("main-search", class extends X {
        setupEventListeners() {
            let t = [];
            this.allSearchInputs.forEach((e => t.push(e.form))), this.input.addEventListener("focus", this.onInputFocus.bind(this)), t.length < 2 || (t.forEach((t => t.addEventListener("reset", this.onFormReset.bind(this)))), this.allSearchInputs.forEach((t => t.addEventListener("input", this.onInput.bind(this)))))
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && this.keepInSync("", this.input)
        }
        onInput(t) {
            const e = t.target;
            this.keepInSync(e.value, e)
        }
        onInputFocus() {
            y() || this.scrollIntoView({
                behavior: "smooth"
            })
        }
        keepInSync(t, e) {
            this.allSearchInputs.forEach((s => {
                s !== e && (s.value = t)
            }))
        }
        constructor() {
            super(), this.allSearchInputs = document.querySelectorAll(Pi), this.setupEventListeners()
        }
    });
    const Ii = "[data-template-no-shipping]",
        Hi = ".get-rates",
        Oi = "#address_container",
        Bi = "#address_country",
        Di = "#address_province",
        Fi = "#address_zip",
        $i = "#wrapper-response",
        _i = "#shipping-calculator-response-template",
        Ni = "data-template-no-shipping",
        Ri = "data-default",
        Wi = "is-hidden",
        zi = "error",
        Ui = "center",
        Vi = "success",
        ji = "disabled",
        Xi = "get-rates--trigger",
        Ji = "Error : country is not supported.",
        Yi = "We do not ship to this destination.",
        Qi = "Error : ";
    let Gi = class extends HTMLElement {
        connectedCallback() {
            const t = document.querySelector("html");
            let s = "en";
            if (t.hasAttribute("lang") && "" !== t.getAttribute("lang") && (s = t.getAttribute("lang")), this.fieldsContainer && e.AddressForm(this.fieldsContainer, s, {
                    shippingCountriesOnly: !0
                }), this.selectCountry && this.selectCountry.hasAttribute(Ri) && this.selectProvince && this.selectProvince.hasAttribute(Ri) && this.selectCountry.addEventListener("change", this.onCountryChangeEvent), this.getRatesButton && (this.getRatesButton.addEventListener("click", this.onButtonClickEvent), theme.settings.customerLoggedIn && this.getRatesButton.classList.contains(Xi))) {
                const t = document.querySelector(Fi);
                t && t.value && this.getRatesButton.dispatchEvent(new Event("click"))
            }
        }
        disconnectedCallback() {
            this.selectCountry && this.selectCountry.hasAttribute(Ri) && this.selectProvince && this.selectProvince.hasAttribute(Ri) && this.selectCountry.removeEventListener("change", this.onCountryChangeEvent), this.getRatesButton && this.getRatesButton.removeEventListener("click", this.onButtonClickEvent)
        }
        onCountryChange() {
            this.selectCountry.removeAttribute(Ri), this.selectProvince.removeAttribute(Ri)
        }
        onButtonClick() {
            for (this.disableButtons(); this.wrapper.firstChild;) this.wrapper.removeChild(this.wrapper.firstChild);
            this.wrapper.classList.add(Wi);
            const t = {};
            let e = this.selectCountry.value,
                s = this.selectProvince.value;
            const i = this.selectCountry.getAttribute(Ri);
            "" === e && i && "" !== i && (e = i);
            const o = this.selectProvince.getAttribute(Ri);
            "" === s && o && "" !== o && (s = o), t.zip = document.querySelector(Fi).value || "", t.country = e || "", t.province = s || "", this.getCartShippingRatesForDestination(t)
        }
        formatRate(t) {
            return "0.00" === t ? window.theme.strings.free : s.formatMoney(t, theme.moneyFormat)
        }
        render(t) {
            if (this.template && this.wrapper) {
                this.wrapper.innerHTML = "";
                let e = "",
                    s = "",
                    i = `${zi} ${Ui}`,
                    o = this.template.innerHTML;
                const n = /[^[\]]+(?=])/g;
                if (t.rates && t.rates.length) {
                    let s = n.exec(o)[0];
                    t.rates.forEach((t => {
                        let i = s;
                        i = i.replace(/\|\|rateName\|\|/, t.name), i = i.replace(/\|\|ratePrice\|\|/, this.formatRate(t.price)), e += i
                    }))
                }
                if (t.success) {
                    i = `${Vi} ${Ui}`;
                    const e = document.createElement("div");
                    e.innerHTML = this.template.innerHTML;
                    const o = e.querySelector(Ii);
                    t.rates.length < 1 && o && (s = o.getAttribute(Ni))
                } else s = t.errorFeedback;
                o = o.replace(n, "").replace("[]", ""), o = o.replace(/\|\|ratesList\|\|/g, e), o = o.replace(/\|\|successClass\|\|/g, i), o = o.replace(/\|\|ratesText\|\|/g, s), this.wrapper.innerHTML += o, this.wrapper.classList.remove(Wi)
            }
        }
        enableButtons() {
            this.getRatesButton.removeAttribute("disabled"), this.getRatesButton.classList.remove(ji), this.getRatesButton.textContent = theme.strings.shippingCalcSubmitButton
        }
        disableButtons() {
            this.getRatesButton.setAttribute("disabled", "disabled"), this.getRatesButton.classList.add(ji), this.getRatesButton.textContent = theme.strings.shippingCalcSubmitButtonDisabled
        }
        getCartShippingRatesForDestination(t) {
            const e = encodeURI(_e({
                    shipping_address: t
                })),
                s = `${theme.routes.cart_url}/shipping_rates.json?${e}`;
            fetch(s).then(this.handleErrors).then((t => t.text())).then((e => {
                const s = JSON.parse(e).shipping_rates;
                this.onCartShippingRatesUpdate(s, t)
            })).catch((t => {
                this.onError(t.json)
            }))
        }
        fullMessagesFromErrors(t) {
            const e = [];
            for (const s in t)
                for (const i of t[s]) e.push(i);
            return e
        }
        handleErrors(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new Ne({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        onError(t) {
            this.enableButtons();
            let e = "";
            e = t.message ? t.message + "(" + t.status + "): " + t.description : Qi + this.fullMessagesFromErrors(t).join("; "), e === Ji && (e = Yi), this.render({
                rates: [],
                errorFeedback: e,
                success: !1
            })
        }
        onCartShippingRatesUpdate(t, e) {
            this.enableButtons();
            let s = "";
            e.zip && (s += e.zip + ", "), e.province && (s += e.province + ", "), s += e.country, this.render({
                rates: t,
                address: s,
                success: !0
            })
        }
        constructor() {
            super(), this.getRatesButton = this.querySelector(Hi), this.fieldsContainer = this.querySelector(Oi), this.selectCountry = this.querySelector(Bi), this.selectProvince = this.querySelector(Di), this.template = this.querySelector(_i), this.wrapper = this.querySelector($i), this.onCountryChangeEvent = () => this.onCountryChange(), this.onButtonClickEvent = () => this.onButtonClick()
        }
    };
    customElements.get("shipping-calculator") || customElements.define("shipping-calculator", Gi);
    const Ki = "[data-actions]",
        Zi = "[data-content]",
        to = "[data-button]",
        eo = "data-height",
        so = "is-open",
        io = "is-enabled";
    let oo = class extends HTMLElement {
        connectedCallback() {
            this.setHeight(this.initialHeight), this.trigger.addEventListener("click", (() => {
                this.setHeight(this.content.offsetHeight), this.classList.add(so)
            })), this.setHeight(this.initialHeight), this.toggleActions(), document.addEventListener("theme:resize", this.toggleActions)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize", this.toggleActions)
        }
        setHeight(t) {
            this.style.setProperty("--height", `${t}px`)
        }
        toggleActions() {
            this.classList.toggle(io, this.content.offsetHeight + this.actions.offsetHeight > this.initialHeight)
        }
        constructor() {
            super(), this.initialHeight = this.getAttribute(eo), this.content = this.querySelector(Zi), this.trigger = this.querySelector(to), this.actions = this.querySelector(Ki), this.toggleActions = this.toggleActions.bind(this)
        }
    };
    customElements.get("toggle-ellipsis") || customElements.define("toggle-ellipsis", oo);
    const no = ".template-addresses",
        ro = "#AddressNewForm",
        ao = ".address-new-toggle",
        lo = ".address-edit-toggle",
        co = ".address-delete",
        ho = "data-form-id",
        uo = "data-confirm-message",
        po = "#EditAddress",
        mo = "AddressCountryNew",
        vo = "AddressProvinceNew",
        go = "AddressProvinceContainerNew",
        fo = ".address-country-option",
        yo = "AddressCountry",
        bo = "AddressProvince",
        wo = "AddressProvinceContainer",
        Eo = "hidden";
    const So = document.querySelector(no);
    So && new class {
        init() {
            if (this.addressNewForm) {
                const t = this.section,
                    e = this.addressNewForm;
                this.customerAddresses();
                const s = t.querySelectorAll(ao);
                s.length && s.forEach((t => {
                    t.addEventListener("click", (function() {
                        e.classList.toggle(Eo)
                    }))
                }));
                const i = t.querySelectorAll(lo);
                i.length && i.forEach((e => {
                    e.addEventListener("click", (function() {
                        const e = this.getAttribute(ho);
                        t.querySelector(`${po}_${e}`).classList.toggle(Eo)
                    }))
                }));
                const o = t.querySelectorAll(co);
                o.length && o.forEach((t => {
                    t.addEventListener("click", (function() {
                        const t = this.getAttribute(ho),
                            e = this.getAttribute(uo);
                        confirm(e) && Shopify.postLink(window.theme.routes.addresses_url + "/" + t, {
                            parameters: {
                                _method: "delete"
                            }
                        })
                    }))
                }))
            }
        }
        customerAddresses() {
            Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(mo, vo, {
                hideElement: go
            }), this.section.querySelectorAll(fo).forEach((t => {
                const e = t.getAttribute(ho),
                    s = `${yo}_${e}`,
                    i = `${bo}_${e}`,
                    o = `${wo}_${e}`;
                new Shopify.CountryProvinceSelector(s, i, {
                    hideElement: o
                })
            }))
        }
        constructor(t) {
            this.section = t, this.addressNewForm = this.section.querySelector(ro), this.init()
        }
    }(So);
    const Lo = ".customer-logged-in",
        ko = ".account",
        Ao = ".account-sidebar--mobile";
    const Co = document.querySelector(Lo);
    Co && new class {
        init() {
            this.section.querySelector(ko) && this.accountMobileSidebar()
        }
        accountMobileSidebar() {
            this.section.querySelector(Ao) && this.section.querySelector(Ao).addEventListener("click", (function() {
                const t = this.nextElementSibling;
                t && "UL" === t.tagName && t.classList.toggle("visible")
            }))
        }
        constructor(t) {
            this.section = t, this.init()
        }
    }(Co);
    const To = "[data-account-form]",
        qo = "[data-show-reset]",
        xo = "[data-hide-reset]",
        Mo = "[data-recover-password]",
        Po = "[data-recover-success]",
        Io = "[data-login-form]",
        Ho = "#recover",
        Oo = "is-hidden";
    const Bo = document.querySelector(To);
    Bo && new class {
        init() {
            window.location.hash == Ho || this.recoverSuccess ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(), this.showButton.addEventListener("click", function(t) {
                t.preventDefault(), this.showRecoverPasswordForm()
            }.bind(this), !1), this.hideButton.addEventListener("click", function(t) {
                t.preventDefault(), this.hideRecoverPasswordForm()
            }.bind(this), !1)
        }
        showRecoverPasswordForm() {
            return this.login.classList.add(Oo), this.recover.classList.remove(Oo), window.location.hash = Ho, !1
        }
        hideRecoverPasswordForm() {
            return this.recover.classList.add(Oo), this.login.classList.remove(Oo), window.location.hash = "", !1
        }
        constructor(t) {
            this.form = t, this.showButton = t.querySelector(qo), this.hideButton = t.querySelector(xo), this.recover = t.querySelector(Mo), this.recoverSuccess = t.querySelector(Po), this.login = t.querySelector(Io), this.init()
        }
    }(Bo), window.Shopify = window.Shopify || {}, window.Shopify.theme = window.Shopify.theme || {}, window.Shopify.theme.sections = window.Shopify.theme.sections || {}, window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}, window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    const Do = window.Shopify.theme.sections.registered,
        Fo = window.Shopify.theme.sections.instances,
        $o = "data-section-id",
        _o = "data-section-type";
    let No = class {
        callFunctions(t, e = null) {
            this.callStack[t].forEach((t => {
                const s = {
                    id: this.id,
                    type: this.type,
                    container: this.container
                };
                e ? t.call(s, e) : t.call(s)
            }))
        }
        onLoad() {
            this.callFunctions("onLoad")
        }
        onUnload() {
            this.callFunctions("onUnload")
        }
        onSelect(t) {
            this.callFunctions("onSelect", t)
        }
        onDeselect(t) {
            this.callFunctions("onDeselect", t)
        }
        onBlockSelect(t) {
            this.callFunctions("onBlockSelect", t)
        }
        onBlockDeselect(t) {
            this.callFunctions("onBlockDeselect", t)
        }
        onReorder(t) {
            this.callFunctions("onReorder", t)
        }
        constructor(t, e) {
            this.container = function(t) {
                if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === t.getAttribute($o)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + $o + " attribute.");
                return t
            }(t), this.id = t.getAttribute($o), this.type = e.type, this.callStack = e.getStack();
            try {
                this.onLoad()
            } catch (t) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t)
            }
        }
    };

    function Ro(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== Do[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const s = new class {
            getStack() {
                return this.callStack
            }
            constructor(t = null, e = []) {
                this.type = t, this.components = function(t) {
                    if (void 0 !== t && "object" != typeof t || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                    return t
                }(e), this.callStack = {
                    onLoad: [],
                    onUnload: [],
                    onSelect: [],
                    onDeselect: [],
                    onBlockSelect: [],
                    onBlockDeselect: [],
                    onReorder: []
                }, e.forEach((t => {
                    for (const [e, s] of Object.entries(t)) {
                        const t = this.callStack[e];
                        Array.isArray(t) && "function" == typeof s ? t.push(s) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(s))
                    }
                }))
            }
        }(t, e);
        return Do[t] = s, Do
    }

    function Wo(t, e) {
        t = Vo(t), void 0 === e && (e = document.querySelectorAll("[" + _o + "]")), e = jo(e), t.forEach((function(t) {
            const s = Do[t];
            void 0 !== s && (e = e.filter((function(e) {
                return !(zo(e).length > 0) && (null !== e.getAttribute(_o) && (e.getAttribute(_o) !== t || (Fo.push(new No(e, s)), !1)))
            })))
        }))
    }

    function zo(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var s = t[0];
        if (t instanceof Element || s instanceof Element) jo(t).forEach((function(t) {
            e = e.concat(Fo.filter((function(e) {
                return e.container === t
            })))
        }));
        else if ("string" == typeof t || "string" == typeof s) {
            Vo(t).forEach((function(t) {
                e = e.concat(Fo.filter((function(e) {
                    return e.type === t
                })))
            }))
        }
        return e
    }

    function Uo(t) {
        for (var e, s = 0; s < Fo.length; s++)
            if (Fo[s].id === t) {
                e = Fo[s];
                break
            } return e
    }

    function Vo(t) {
        return "*" === t ? t = Object.keys(Do) : "string" == typeof t ? t = [t] : t.constructor === No ? t = [t.prototype.type] : Array.isArray(t) && t[0].constructor === No && (t = t.map((function(t) {
            return t.type
        }))), t = t.map((function(t) {
            return t.toLowerCase()
        }))
    }

    function jo(t) {
        return NodeList.prototype.isPrototypeOf(t) && t.length > 0 ? t = Array.prototype.slice.call(t) : NodeList.prototype.isPrototypeOf(t) && 0 === t.length || null === t ? t = [] : !Array.isArray(t) && t instanceof Element && (t = [t]), t
    }
    window.Shopify.designMode && (document.addEventListener("shopify:section:load", (function(t) {
        var e = t.detail.sectionId,
            s = t.target.querySelector("[" + $o + '="' + e + '"]');
        null !== s && Wo(s.getAttribute(_o), s)
    })), document.addEventListener("shopify:section:reorder", (function(t) {
        var e = t.detail.sectionId,
            s = t.target.querySelector("[" + $o + '="' + e + '"]');
        "object" == typeof zo(s)[0] && zo(s).forEach((function(t) {
            t.onReorder()
        }))
    })), document.addEventListener("shopify:section:unload", (function(t) {
        var e = t.detail.sectionId,
            s = t.target.querySelector("[" + $o + '="' + e + '"]');
        "object" == typeof zo(s)[0] && zo(s).forEach((function(t) {
            var e = Fo.map((function(t) {
                return t.id
            })).indexOf(t.id);
            Fo.splice(e, 1), t.onUnload()
        }))
    })), document.addEventListener("shopify:section:select", (function(t) {
        var e = Uo(t.detail.sectionId);
        "object" == typeof e && e.onSelect(t)
    })), document.addEventListener("shopify:section:deselect", (function(t) {
        var e = Uo(t.detail.sectionId);
        "object" == typeof e && e.onDeselect(t)
    })), document.addEventListener("shopify:block:select", (function(t) {
        var e = Uo(t.detail.sectionId);
        "object" == typeof e && e.onBlockSelect(t)
    })), document.addEventListener("shopify:block:deselect", (function(t) {
        var e = Uo(t.detail.sectionId);
        "object" == typeof e && e.onBlockDeselect(t)
    })));
    const Xo = "data-tooltip",
        Jo = "data-tooltip-stop-mouseenter",
        Yo = "tooltip-default",
        Qo = "is-visible",
        Go = "is-hiding";
    let Ko = {},
        Zo = class {
            init() {
                if (!document.querySelector(`.${this.class}`)) {
                    const t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
                        e = document.createElement("div");
                    e.className = this.class, e.innerHTML = t, document.body.appendChild(e)
                }
                this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent), this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent), this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent), document.addEventListener("theme:tooltip:close", this.removePinEvent)
            }
            addPin(t = !1) {
                const e = document.querySelector(`.${this.class}`);
                if (this.label && e && (t && !this.tooltip.hasAttribute(Jo) || !t)) {
                    const t = e.querySelector(`.${this.class}__arrow`),
                        s = e.querySelector(`.${this.class}__inner`);
                    e.querySelector(`.${this.class}__text`).innerHTML = this.label;
                    const i = s.offsetWidth,
                        o = this.tooltip.getBoundingClientRect(),
                        n = o.top,
                        r = o.width,
                        a = n + o.height + window.scrollY;
                    let l = o.left - i / 2 + r / 2;
                    const c = 24,
                        h = l + i - g() + c;
                    h > 0 && (l -= h), l < 0 && (l = 0), t.style.left = `${o.left+r/2}px`, e.style.setProperty("--tooltip-top", `${a}px`), s.style.transform = `translateX(${l}px)`, e.classList.remove(Go), e.classList.add(Qo), document.addEventListener("theme:scroll", this.removePinEvent)
                }
            }
            removePin(t, e = !1, s = !1) {
                const i = document.querySelector(`.${this.class}`),
                    o = i.classList.contains(Qo);
                i && (e && !this.tooltip.hasAttribute(Jo) || !e) && (o && (s || t.detail.hideTransition) && (i.classList.add(Go), this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout), this.hideTransitionTimeout = setTimeout((() => {
                    i.classList.remove(Go)
                }), this.transitionSpeed)), i.classList.remove(Qo), document.removeEventListener("theme:scroll", this.removePinEvent))
            }
            unload() {
                this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent), this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent), this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent), document.removeEventListener("theme:tooltip:close", this.removePinEvent), document.removeEventListener("theme:scroll", this.removePinEvent)
            }
            constructor(t, e = {}) {
                this.tooltip = t, this.tooltip.hasAttribute(Xo) && (this.label = this.tooltip.getAttribute(Xo), this.class = e.class || Yo, this.transitionSpeed = e.transitionSpeed || 200, this.hideTransitionTimeout = 0, this.addPinEvent = () => this.addPin(), this.addPinMouseEvent = () => this.addPin(!0), this.removePinEvent = t => Ue(this.removePin(t), 50), this.removePinMouseEvent = t => this.removePin(t, !0, !0), this.init())
            }
        };
    const tn = {
        onLoad() {
            Ko[this.id] = [];
            this.container.querySelectorAll(`[${Xo}]`).forEach((t => {
                Ko[this.id].push(new Zo(t))
            }))
        },
        onUnload: function() {
            Ko[this.id].forEach((t => {
                "function" == typeof t.unload && t.unload()
            }))
        }
    };
    var en = {};
    const sn = {
        onLoad() {
            en[this.id] = [];
            this.container.querySelectorAll("[data-parallax-wrapper]").forEach((t => {
                const e = t.querySelector("[data-parallax-img]");
                en[this.id].push(new i(e, {
                    center: !0,
                    round: !0,
                    frame: t
                }))
            })), window.addEventListener("load", (() => {
                en[this.id].forEach((t => {
                    "function" == typeof t.refresh && t.refresh()
                }))
            }))
        },
        onUnload: function() {
            en[this.id].forEach((t => {
                "function" == typeof t.destroy && t.destroy()
            }))
        }
    };
    Ro("article", [tn, sn]);
    const on = "[data-aos]",
        nn = ".collection-item__image",
        rn = "[data-column-image]",
        an = ".flickity-button.next",
        ln = ".flickity-button.previous",
        cn = "a:not(.btn)",
        hn = ".product-item__image",
        dn = "[data-slide]",
        un = "data-slide",
        pn = "[data-slider]",
        mn = "[data-slider-thumb]",
        vn = {
            arrowPositionMiddle: "data-arrow-position-middle",
            slideIndex: "data-slide-index",
            sliderOptions: "data-options",
            slideTextColor: "data-slide-text-color"
        },
        gn = "aos-animate",
        fn = "desktop",
        yn = "is-focused",
        bn = "flickity-enabled",
        wn = "is-initialized",
        En = "is-loading",
        Sn = "is-selected",
        Ln = "mobile",
        kn = "single-slide",
        An = "js-slider--initialized",
        Cn = {};
    let Tn = class {
        init() {
            this.slideshow.classList.add(En);
            let t = dn;
            const e = y(),
                s = `${dn}:not(.${Ln})`,
                i = `${dn}:not(.${fn})`;
            (this.slideshow.querySelectorAll(i).length || this.slideshow.querySelectorAll(s).length) && (t = e ? s : i), this.slideshow.querySelectorAll(t).length <= 1 && (this.slideshow.classList.add(kn), this.slideshow.classList.remove(En)), this.sliderOptions = {
                cellSelector: t,
                contain: !0,
                wrapAround: !0,
                adaptiveHeight: !0,
                ...this.customOptions,
                on: {
                    ready: () => {
                        requestAnimationFrame((() => {
                            this.slideshow.classList.add(wn), this.slideshow.classList.remove(En), this.slideshow.parentNode.dispatchEvent(new CustomEvent("theme:slider:loaded", {
                                bubbles: !0,
                                detail: {
                                    slider: this
                                }
                            }))
                        })), this.slideActions(), this.sliderOptions.prevNextButtons && this.positionArrows()
                    },
                    change: t => {
                        const e = this.slideshowSlides[t];
                        if (!e || this.sliderOptions.groupCells) return;
                        const s = e.querySelectorAll(on);
                        s.length && s.forEach((t => {
                            t.classList.remove(gn), requestAnimationFrame((() => {
                                setTimeout((() => {
                                    t.classList.add(gn)
                                }), 0)
                            }))
                        }))
                    },
                    resize: () => {
                        this.sliderOptions.prevNextButtons && this.positionArrows()
                    }
                }
            }, this.sliderOptions.fade && (this.flkty = new n(this.slideshow, this.sliderOptions)), this.sliderOptions.fade || (this.flkty = new o(this.slideshow, this.sliderOptions)), this.flkty.on("change", (() => this.slideActions(!0))), this.sliderThumbs.length && this.sliderThumbs.forEach((t => {
                t.addEventListener("click", (e => {
                    e.preventDefault();
                    const s = [...t.parentElement.children].indexOf(t);
                    this.flkty.select(s)
                }))
            })), this.flkty && this.flkty.isActive || this.slideshow.classList.remove(En)
        }
        slideActions(t = !1) {
            const e = this.slideshow.querySelector(`.${Sn}`);
            if (!e) return;
            const s = e.hasAttribute(vn.slideTextColor) ? e.getAttribute(vn.slideTextColor) : "",
                i = e.querySelector(cn),
                o = this.slideshow.querySelectorAll(`${dn} a, ${dn} button`);
            if (document.body.classList.contains(yn) && i && this.sliderOptions.groupCells && t && i.focus(), o.length && o.forEach((t => {
                    const e = t.closest(dn);
                    if (e) {
                        const s = e.classList.contains(Sn) ? 0 : -1;
                        t.setAttribute("tabindex", s)
                    }
                })), "rgba(0,0,0,0)" !== s && "" !== s && this.slideshow.style.setProperty("--text", s), this.sliderThumbs.length && this.sliderThumbs.length === this.slideshowSlides.length && e.hasAttribute(vn.slideIndex)) {
                const t = parseInt(e.getAttribute(vn.slideIndex)),
                    s = this.container.querySelector(`${mn}.${Sn}`);
                s && s.classList.remove(Sn), this.sliderThumbs[t].classList.add(Sn)
            }
        }
        positionArrows() {
            if (this.slideshow.hasAttribute(vn.arrowPositionMiddle) && this.sliderOptions.prevNextButtons) {
                const t = this.slideshow.querySelector(nn) || this.slideshow.querySelector(hn) || this.slideshow.querySelector(rn);
                if (!t) return;
                this.slideshow.querySelector(ln).style.top = t.clientHeight / 2 + "px", this.slideshow.querySelector(an).style.top = t.clientHeight / 2 + "px"
            }
        }
        onUnload() {
            this.slideshow && this.flkty && (this.flkty.options.watchCSS = !1, this.flkty.destroy())
        }
        onBlockSelect(t) {
            if (!this.slideshow) return;
            const e = this.slideshow.querySelector(`[${un}="${t.detail.blockId}"]`);
            if (!e) return;
            let s = parseInt(e.getAttribute(vn.slideIndex));
            this.multipleSlides && !this.slideshow.classList.contains(An) && (s = 0), this.slideshow.classList.add(Sn), this.flkty && this.slideshow.classList.contains(bn) && (this.flkty.selectCell(s), this.flkty.stopPlayer())
        }
        onBlockDeselect() {
            this.slideshow && (this.slideshow.classList.remove(Sn), this.flkty && this.sliderOptions.hasOwnProperty("autoPlay") && this.sliderOptions.autoPlay && this.flkty.playPlayer())
        }
        constructor(t, e = null) {
            this.container = t, this.slideshow = e || this.container.querySelector(pn), this.slideshow && (this.slideshowSlides = this.slideshow.querySelectorAll(dn), this.slideshowSlides.length <= 1 || (this.sliderThumbs = this.container.querySelectorAll(mn), this.multipleSlides = this.slideshow.hasAttribute(vn.slidesLargeDesktop), this.slideshow.hasAttribute(vn.sliderOptions) && (this.customOptions = JSON.parse(decodeURIComponent(this.slideshow.getAttribute(vn.sliderOptions)))), this.flkty = null, this.init()))
        }
    };
    const qn = {
        onLoad() {
            Cn[this.id] = [];
            this.container.querySelectorAll(pn).forEach((t => {
                Cn[this.id].push(new Tn(this.container, t))
            }))
        },
        onUnload() {
            Cn[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        },
        onBlockSelect(t) {
            Cn[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            Cn[this.id].forEach((e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            }))
        }
    };
    Ro("blog-section", [qn]), Ro("hero", sn), Ro("double", qn);
    const xn = t => {
        let {
            stickyHeaderHeight: e
        } = c();
        window.scrollTo({
            top: t + window.scrollY - e,
            left: 0,
            behavior: "smooth"
        })
    };
    let Mn = class {
        write() {
            (-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) && (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`)
        }
        read() {
            if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t => t.startsWith(this.name)))) {
                return document.cookie.split("; ").find((t => t.startsWith(this.name))).split("=")[1]
            }
            return !1
        }
        destroy() {
            document.cookie.split("; ").find((t => t.startsWith(this.name))) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`)
        }
        constructor(t, e, s = 7) {
            const i = new Date,
                o = new Date;
            o.setTime(i.getTime() + 864e5 * s), this.configuration = {
                expires: o.toGMTString(),
                path: "/",
                domain: window.location.hostname,
                sameSite: "none",
                secure: !0
            }, this.name = t, this.value = e
        }
    };
    const Pn = "[data-newsletter-form]",
        In = "[data-newsletter-heading]",
        Hn = "[data-newsletter]",
        On = "has-success",
        Bn = "has-error",
        Dn = "hidden",
        Fn = "data-cookie-name",
        $n = {};
    const _n = {
        onLoad() {
            $n[this.id] = [];
            this.container.querySelectorAll(Pn).forEach((t => {
                $n[this.id].push(new class {
                    init() {
                        this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage()
                    }
                    newsletterSubmitEvent(t) {
                        this.stopSubmit && (t.preventDefault(), t.stopImmediatePropagation(), this.removeStorage(), this.writeStorage(), this.stopSubmit = !1, this.newsletter.submit())
                    }
                    checkForChallengePage() {
                        this.isChallengePage = "/challenge" === window.location.pathname
                    }
                    writeStorage() {
                        void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id)
                    }
                    readStorage() {
                        this.formID = this.sessionStorage.getItem("newsletter_form_id")
                    }
                    removeStorage() {
                        this.sessionStorage.removeItem("newsletter_form_id")
                    }
                    showMessage() {
                        if (this.readStorage(), this.newsletter.id === this.formID) {
                            const t = document.getElementById(this.formID),
                                e = t.parentElement.querySelector(In),
                                s = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                i = -1 !== window.location.search.indexOf("accepts_marketing");
                            s ? (t.classList.remove(Bn), t.classList.add(On), e && (e.classList.add(Dn), t.classList.remove(Dn)), this.popup && this.cookie.write()) : i && (t.classList.remove(On), t.classList.add(Bn), e && (e.classList.add(Dn), t.classList.remove(Dn))), (s || i) && window.addEventListener("load", (() => {
                                this.scrollToForm(t)
                            }))
                        }
                    }
                    scrollToForm(t) {
                        const e = t.getBoundingClientRect();
                        e.top >= 0 && e.left >= 0 && e.bottom <= f() && e.right <= g() || setTimeout((() => {
                            xn(t.getBoundingClientRect().top)
                        }), 500)
                    }
                    unload() {
                        this.newsletter.removeEventListener("submit", this.newsletterSubmit)
                    }
                    constructor(t) {
                        this.sessionStorage = window.sessionStorage, this.newsletter = t, this.popup = this.newsletter.closest(Hn), this.popup && (this.cookie = new Mn(this.popup.getAttribute(Fn), "user_has_closed", null)), this.stopSubmit = !0, this.isChallengePage = !1, this.formID = null, this.checkForChallengePage(), this.newsletterSubmit = t => this.newsletterSubmitEvent(t), this.isChallengePage || this.init()
                    }
                }(t))
            }))
        },
        onUnload() {
            $n[this.id].forEach((t => {
                "function" == typeof t.unload && t.unload()
            }))
        }
    };
    Ro("footer", [sn, _n]);
    const Nn = "[data-section-type]",
        Rn = "[data-collection-sidebar]",
        Wn = "[data-collection-sidebar-slide-out]",
        zn = "[data-collection-sidebar-close]",
        Un = "[data-collection-filters-form]",
        Vn = "input",
        jn = "select",
        Xn = "label",
        Jn = "textarea",
        Yn = "[data-field-price-min]",
        Qn = "[data-field-price-max]",
        Gn = "data-field-price-min",
        Kn = "data-field-price-max",
        Zn = "[data-se-min-value]",
        tr = "[data-se-max-value]",
        er = "data-se-min-value",
        sr = "data-se-max-value",
        ir = "data-se-min",
        or = "data-se-max",
        nr = "[data-show-more]",
        rr = "[data-link-hidden]",
        ar = "[data-collection-nav]",
        lr = "[data-products-grid]",
        cr = "[data-active-filters]",
        hr = "data-active-filters-count",
        dr = "[data-filter-update-url]",
        ur = "[data-sort-enabled]",
        pr = "[data-sort-link]",
        mr = "data-value",
        vr = "[data-popout-toggle]",
        gr = "[data-sort-button-text]",
        fr = "[data-results-count]",
        yr = "hidden",
        br = "is-focused",
        wr = "is-loading",
        Er = "is-active";
    let Sr = class extends HTMLElement {
        connectedCallback() {
            this.sort && this.sortLinks.length && this.sortLinks.forEach((t => {
                t.addEventListener("click", this.onSortButtonClickEvent)
            })), this.collectionSidebar && this.form && (this.collectionSidebar.addEventListener("input", this.updatePriceEvent), this.collectionSidebar.addEventListener("theme:range:update", this.updateRangeEvent)), this.showMoreOptions.length && this.showMoreOptions.forEach((t => {
                t.addEventListener("click", this.showMoreEvent)
            })), (this.collectionSidebar || this.sort) && window.addEventListener("popstate", this.submitFormEvent), this.filterUrlButtons.length && this.filterUrlButtons.forEach((t => {
                t.addEventListener("click", this.filterUpdateFromUrlEvent)
            })), this.collectionSidebarCloseButtons.length && this.collectionSidebarCloseButtons.forEach((t => {
                t.addEventListener("click", this.collectionSidebarCloseEvent)
            }))
        }
        collectionSidebarClose(t) {
            t.preventDefault(), this.container.dispatchEvent(new CustomEvent("theme:filter:close", {
                bubbles: !1
            }))
        }
        onSortButtonClick(t) {
            t.preventDefault(), this.sortButton && this.sortButton.dispatchEvent(new Event("click")), this.sortActions(t, t.currentTarget)
        }
        sortActions(t, e, s = !0) {
            const i = this.sort.querySelector(gr),
                o = this.sort.querySelector(`.${Er}`);
            if (i) {
                const t = e ? e.textContent.trim() : "";
                i.textContent = t
            }
            o && o.classList.remove(Er), this.sort.classList.toggle(Er, e), e && (e.parentElement.classList.add(Er), s && this.submitForm(t))
        }
        onSortCheck(t) {
            let e = null;
            if (window.location.search.includes("sort_by")) {
                const t = new window.URL(window.location.href).searchParams;
                for (const [s, i] of t.entries()) {
                    const t = this.sort.querySelector(`[${mr}="${i}"]`);
                    if (s.includes("sort_by") && t) {
                        e = t;
                        break
                    }
                }
            }
            this.sortActions(t, e, !1)
        }
        showMore(t) {
            t.preventDefault();
            const e = t.target.matches(nr) ? t.target : t.target.closest(nr);
            e.parentElement.classList.add(yr), e.parentElement.previousElementSibling.querySelectorAll(rr).forEach(((t, e) => {
                t.classList.remove(yr);
                const s = t.querySelector(Vn);
                0 === e && document.body.classList.contains(br) && s && (this.collectionSidebarSlideOut || b() ? (this.a11y.removeTrapFocus(), this.a11y.trapFocus(this.collectionSidebar, {
                    elementToFocus: s
                })) : s.focus())
            }))
        }
        updatePrice(t) {
            const e = t.type,
                s = t.target;
            if ((e === Vn || e === jn || e === Xn || e === Jn) && this.form && "function" == typeof this.form.submit) {
                const e = this.form.querySelector(Yn),
                    i = this.form.querySelector(Qn);
                e && i && (s.hasAttribute(Gn) && !i.value ? i.value = i.placeholder : s.hasAttribute(Kn) && !e.value && (e.value = e.placeholder)), this.submitForm(t)
            }
        }
        updateRange(t) {
            if (this.form && "function" == typeof this.form.submit) {
                const e = this.form.querySelector(Zn),
                    s = this.form.querySelector(tr),
                    i = this.form.querySelector(Yn),
                    o = this.form.querySelector(Qn);
                if (e && s && i && o && e.hasAttribute(er) && s.hasAttribute(sr)) {
                    const n = parseInt(i.placeholder),
                        r = parseInt(o.placeholder),
                        a = parseInt(e.getAttribute(er)),
                        l = parseInt(s.getAttribute(sr));
                    n === a && r === l || (i.value = a, o.value = l, this.submitForm(t))
                }
            }
        }
        filterUpdateFromUrl(t) {
            t.preventDefault(), this.submitForm(t, t.currentTarget.getAttribute("href"))
        }
        submitForm(t, e = "") {
            if (!t || t && "popstate" !== t.type)
                if ("" === e) {
                    let t = new window.URL(window.location.href).searchParams;
                    const e = t,
                        s = Object.fromEntries(e),
                        i = t.toString();
                    if (i.includes("filter.") || i.includes("page=") || i.includes("sort_by="))
                        for (const e in s)(e.includes("filter.") || "page" === e || "sort_by" === e) && t.delete(e);
                    if (this.form) {
                        const e = new FormData(this.form),
                            s = new URLSearchParams(e),
                            i = this.form.querySelector(Zn),
                            o = this.form.querySelector(tr),
                            n = i && i.hasAttribute(ir) ? i.getAttribute(ir) : "",
                            r = o && o.hasAttribute(or) ? o.getAttribute(or) : "";
                        let a = 0;
                        for (let [e, i] of s.entries())(e.includes("filter.") && i || e.includes("sort_by") && i) && (t.append(e, i), (i === n && "filter.v.price.gte" === e || i === r && "filter.v.price.lte" === e) && (a += 1));
                        2 === a && (t.delete("filter.v.price.gte"), t.delete("filter.v.price.lte"))
                    }
                    const o = t.toString(),
                        n = o ? `?${o}` : location.pathname;
                    window.history.pushState(null, "", n)
                } else window.history.pushState(null, "", e);
            else this.sort && this.onSortCheck(t);
            this.productsContainer && (this.productsContainer.classList.add(wr), fetch(`${window.location.pathname}${window.location.search}`).then((t => t.text())).then((t => {
                const e = (new DOMParser).parseFromString(t, "text/html"),
                    s = this.container.querySelector(fr);
                if (s) {
                    const t = e.querySelector(fr);
                    s.innerHTML = t.innerHTML
                }
                if (this.productsContainer.innerHTML = e.querySelector(lr).innerHTML, this.collectionSidebar) {
                    this.collectionSidebar.innerHTML = e.querySelector(Rn).innerHTML;
                    const t = this.collectionSidebar.querySelector(`[${hr}]`),
                        s = this.container.querySelectorAll(cr);
                    if (t && s.length) {
                        const e = parseInt(t.getAttribute(hr));
                        s.forEach((t => {
                            t.textContent = e, t.classList.toggle(yr, e < 1)
                        }))
                    }
                }
                this.collectionNav && xn(this.productsContainer.getBoundingClientRect().top - this.collectionNav.offsetHeight), setTimeout((() => {
                    this.productsContainer.classList.remove(wr)
                }), 500)
            })).catch((t => {
                console.log(t)
            })))
        }
        disconnectedCallback() {
            this.collectionSidebar && this.form && (this.collectionSidebar.removeEventListener("input", this.updatePriceEvent), this.collectionSidebar.removeEventListener("theme:range:update", this.updateRangeEvent)), this.showMoreOptions.length && this.showMoreOptions.forEach((t => {
                t.removeEventListener("click", this.showMoreEvent)
            })), this.sort && this.sortLinks.length && this.sortLinks.forEach((t => {
                t.removeEventListener("click", this.onSortButtonClickEvent)
            })), (this.collectionSidebar || this.sort) && window.removeEventListener("popstate", this.submitFormEvent), this.filterUrlButtons.length && this.filterUrlButtons.forEach((t => {
                t.removeEventListener("click", this.filterUpdateFromUrlEvent)
            })), this.collectionSidebarCloseButtons.length && this.collectionSidebarCloseButtons.forEach((t => {
                t.removeEventListener("click", this.collectionSidebarCloseEvent)
            }))
        }
        constructor() {
            super(), this.container = this.closest(Nn), this.collectionSidebar = this.container.querySelector(Rn), this.collectionSidebarSlideOut = this.container.querySelector(Wn), this.form = this.querySelector(Un), this.productsContainer = this.container.querySelector(lr), this.collectionNav = this.container.querySelector(ar), this.sort = this.container.querySelector(ur), this.sortButton = this.container.querySelector(vr), this.sortLinks = this.container.querySelectorAll(pr), this.filterUrlButtons = this.container.querySelectorAll(dr), this.collectionSidebarCloseButtons = this.container.querySelectorAll(zn), this.showMoreOptions = this.querySelectorAll(nr), this.a11y = W, this.updatePriceEvent = v((t => this.updatePrice(t)), 500), this.updateRangeEvent = t => this.updateRange(t), this.showMoreEvent = t => this.showMore(t), this.onSortButtonClickEvent = t => this.onSortButtonClick(t), this.submitFormEvent = t => this.submitForm(t), this.collectionSidebarCloseEvent = t => this.collectionSidebarClose(t), this.filterUpdateFromUrlEvent = t => this.filterUpdateFromUrl(t)
        }
    };
    const Lr = "[data-collection-sidebar]",
        kr = "[data-range-left]",
        Ar = "[data-range-right]",
        Cr = "[data-range-line]",
        Tr = "[data-range-holder]",
        qr = "data-se-min",
        xr = "data-se-max",
        Mr = "data-se-min-value",
        Pr = "data-se-max-value",
        Ir = "data-se-step",
        Hr = "data-range-filter-update",
        Or = "[data-field-price-min]",
        Br = "[data-field-price-max]",
        Dr = "is-initialized";
    let Fr = class extends HTMLElement {
        connectedCallback() {
            let t = this.min;
            this.hasAttribute(Mr) && (t = parseFloat(this.getAttribute(Mr)));
            let e = this.max;
            this.hasAttribute(Pr) && (e = parseFloat(this.getAttribute(Pr))), t < this.min && (t = this.min), e > this.max && (e = this.max), t > e && (t = e), this.getAttribute(Ir) && (this.step = Math.abs(parseFloat(this.getAttribute(Ir)))), this.reset(), this.maxX = this.offsetWidth - this.touchRight.offsetWidth, this.selectedTouch = null, this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact, this.setMinValue(t), this.setMaxValue(e), this.touchLeft.addEventListener("mousedown", this.onStartEvent), this.touchRight.addEventListener("mousedown", this.onStartEvent), this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
                passive: !0
            }), this.touchRight.addEventListener("touchstart", this.onStartEvent, {
                passive: !0
            }), this.classList.add(Dr)
        }
        reset() {
            this.touchLeft.style.left = "0px", this.touchRight.style.left = this.offsetWidth - this.touchLeft.offsetWidth + "px", this.lineSpan.style.marginLeft = "0px", this.lineSpan.style.width = this.offsetWidth - this.touchLeft.offsetWidth + "px", this.startX = 0, this.x = 0
        }
        setMinValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            this.touchLeft.style.left = Math.ceil(e * (this.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.setAttribute(Mr, t)
        }
        setMaxValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            this.touchRight.style.left = Math.ceil(e * (this.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.setAttribute(Pr, t)
        }
        onStart(t) {
            let e = t;
            t.touches && (e = t.touches[0]), t.currentTarget === this.touchLeft ? this.x = this.touchLeft.offsetLeft : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft), this.startX = e.pageX - this.x, this.selectedTouch = t.currentTarget, document.addEventListener("mousemove", this.onMoveEvent), document.addEventListener("mouseup", this.onStopEvent), document.addEventListener("touchmove", this.onMoveEvent, {
                passive: !0
            }), document.addEventListener("touchend", this.onStopEvent, {
                passive: !0
            })
        }
        onMove(t) {
            let e = t;
            if (t.touches && (e = t.touches[0]), this.x = e.pageX - this.startX, this.selectedTouch === this.touchLeft ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 : this.x < 0 && (this.x = 0), this.selectedTouch.style.left = this.x + "px") : this.selectedTouch === this.touchRight && (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 : this.x > this.maxX && (this.x = this.maxX), this.selectedTouch.style.left = this.x + "px"), this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.calculateValue(), this.getAttribute("on-change")) {
                new Function("min, max", this.getAttribute("on-change"))(this.getAttribute(Mr), this.getAttribute(Pr))
            }
            this.onChange(this.getAttribute(Mr), this.getAttribute(Pr))
        }
        onStop() {
            document.removeEventListener("mousemove", this.onMoveEvent), document.removeEventListener("mouseup", this.onStopEvent), document.removeEventListener("touchmove", this.onMoveEvent), document.removeEventListener("touchend", this.onStopEvent), this.selectedTouch = null, this.calculateValue(), this.onChanged(this.getAttribute(Mr), this.getAttribute(Pr))
        }
        onChange(t, e) {
            const s = this.closest(Tr);
            if (s) {
                const i = s.querySelector(Or),
                    o = s.querySelector(Br);
                i && o && (i.value = t, o.value = e)
            }
        }
        onChanged(t, e) {
            this.hasAttribute(Hr) && this.dispatchEvent(new CustomEvent("theme:range:update", {
                bubbles: !0
            }))
        }
        calculateValue() {
            const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let e = this.lineSpan.offsetLeft / this.initialValue,
                s = e + t;
            if (e = e * (this.max - this.min) + this.min, s = s * (this.max - this.min) + this.min, 0 !== this.step) {
                let t = Math.floor(e / this.step);
                e = this.step * t, t = Math.floor(s / this.step), s = this.step * t
            }
            this.selectedTouch === this.touchLeft && this.setAttribute(Mr, e), this.selectedTouch === this.touchRight && this.setAttribute(Pr, s)
        }
        onSidebarTransitionEnd(t) {
            t.target == this.sidebar && "min-width" == t.propertyName && (this.sidebar.removeEventListener("transitionend", this.sidebarTransitionEvent), this.connectedCallback())
        }
        disconnectedCallback() {
            this.sidebar.removeEventListener("transitionend", this.sidebarTransitionEvent), this.resizeEvent && document.removeEventListener("theme:resize:width", this.resizeEvent)
        }
        constructor() {
            super(), this.sidebar = this.closest(Lr), this.sidebarTransitionEvent = t => this.onSidebarTransitionEnd(t), this.resizeEvent = () => {
                this.connectedCallback(), this.sidebar.addEventListener("transitionend", this.sidebarTransitionEvent)
            }, this.onMoveEvent = t => this.onMove(t), this.onStopEvent = t => this.onStop(t), this.onStartEvent = t => this.onStart(t), this.startX = 0, this.x = 0, this.touchLeft = this.querySelector(kr), this.touchRight = this.querySelector(Ar), this.lineSpan = this.querySelector(Cr), this.min = parseFloat(this.getAttribute(qr)), this.max = parseFloat(this.getAttribute(xr)), this.step = 0, this.normalizeFact = 26, document.addEventListener("theme:resize:width", this.resizeEvent)
        }
    };
    const $r = "[data-collection-sidebar]",
        _r = "[data-collection-sidebar-slide-out]",
        Nr = "[data-collection-sidebar-close]",
        Rr = "[data-aria-toggle]",
        Wr = "drawer--animated",
        zr = "expanded",
        Ur = "no-mobile-animation",
        Vr = "is-focused";
    let jr = {};
    Ro("collection", [qn, sn, {
        onLoad() {
            jr[this.id] = new class {
                init() {
                    null !== this.groupTagsButton && (document.addEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.addEventListener("click", this.groupTagsButtonClickEvent), this.collectionSidebar && setTimeout((() => {
                        this.collectionSidebar.classList.remove(Ur)
                    }), 1e3), new MutationObserver((t => {
                        for (const e of t) "attributes" === e.type && "true" == e.target.getAttribute("aria-expanded") && this.showSidebarCallback()
                    })).observe(this.groupTagsButton, {
                        attributes: !0,
                        childList: !1,
                        subtree: !1
                    })), this.container.addEventListener("keyup", function(t) {
                        "Escape" === t.code && this.hideSidebar()
                    }.bind(this)), this.collectionSidebar && (this.collectionSidebar.addEventListener("transitionend", (() => {
                        this.collectionSidebar.classList.contains(zr) || this.collectionSidebar.classList.remove(Wr)
                    })), this.toggleSidebarSlider(), this.container.addEventListener("theme:filter:close", this.collectionSidebarCloseEvent))
                }
                showSidebarCallback() {
                    const t = this.container.querySelector(_r),
                        e = document.documentElement.hasAttribute("data-scroll-locked"),
                        s = b();
                    this.collectionSidebar.classList.add(Wr), null === t && !s && e && (this.a11y.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))), (s || null !== t) && (t && this.a11y.trapFocus(this.collectionSidebar, {
                        elementToFocus: this.collectionSidebar.querySelector(Nr)
                    }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                        bubbles: !0
                    })))
                }
                hideSidebar() {
                    const t = this.container.querySelector(_r),
                        e = document.documentElement.hasAttribute("data-scroll-locked");
                    this.groupTagsButton.setAttribute("aria-expanded", "false"), this.collectionSidebar.classList.remove(zr), t && this.a11y.removeTrapFocus(), e && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))
                }
                toggleSidebarSlider() {
                    b() ? this.hideSidebar() : this.collectionSidebar.classList.contains(zr) && this.showSidebarCallback()
                }
                collectionSidebarClose(t) {
                    t.preventDefault(), this.hideSidebar(), document.body.classList.contains(Vr) && this.groupTagsButton && this.groupTagsButton.focus()
                }
                groupTagsButtonClick() {
                    document.documentElement.hasAttribute("data-scroll-locked") && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))
                }
                onUnload() {
                    null !== this.groupTagsButton && (document.removeEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.removeEventListener("click", this.groupTagsButtonClickEvent)), this.collectionSidebar && this.container.removeEventListener("theme:filter:close", this.collectionSidebarCloseEvent)
                }
                constructor(t) {
                    this.container = t.container, this.collectionSidebar = this.container.querySelector($r), this.groupTagsButton = this.container.querySelector(Rr), this.a11y = W, this.groupTagsButtonClickEvent = t => this.groupTagsButtonClick(t), this.sidebarResizeEvent = () => this.toggleSidebarSlider(), this.collectionSidebarCloseEvent = t => this.collectionSidebarClose(t), this.init()
                }
            }(this)
        },
        onUnload() {
            jr[this.id].onUnload()
        }
    }, tn]), customElements.get("collection-filters-form") || customElements.define("collection-filters-form", Sr), customElements.get("range-slider") || customElements.define("range-slider", Fr);
    const Xr = "[data-ticker-scale]",
        Jr = "[data-ticker-text]",
        Yr = "data-clone",
        Qr = "autoplay",
        Gr = "speed",
        Kr = "ticker--animated",
        Zr = "ticker--unloaded",
        ta = "ticker__comparitor",
        ea = 1.63,
        sa = 100;
    let ia = class extends HTMLElement {
        connectedCallback() {
            this.checkWidth(), this.addEventListener("theme:ticker:refresh", v((() => this.checkWidthEvent()), 50)), screen.orientation.addEventListener("change", this.checkWidthEvent), document.addEventListener("theme:resize:width", this.checkWidthEvent)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.checkWidthEvent)
        }
        checkWidth() {
            this.text = this.querySelector(Jr);
            const t = 2 * window.getComputedStyle(this).paddingLeft.replace("px", ""),
                e = this.clientWidth - t < this.comparitor.clientWidth;
            if (e || this.autoplay) {
                var s;
                this.text.classList.remove(Kr);
                const i = this.scale.querySelectorAll(`[${Yr}]`),
                    o = this.autoplay ? parseInt((window.innerWidth - t) / this.text.clientWidth) : 2;
                if (null == i || i.forEach((t => {
                        t.remove()
                    })), this.autoplay || e)
                    for (let t = 0; t <= o; t++) {
                        const t = this.text.cloneNode(!0);
                        t.setAttribute(Yr, ""), this.scale.appendChild(t)
                    }
                const n = (this.text.clientWidth / sa * Number(this.speed)).toFixed(2);
                this.scale.style.removeProperty("--animation-time"), this.scale.style.setProperty("--animation-time", `${n}s`), null === (s = this.scale.querySelectorAll(Jr)) || void 0 === s || s.forEach((t => {
                    t.classList.add(Kr)
                }))
            } else {
                this.text.classList.add(Kr);
                this.scale.querySelectorAll(`[${Yr}]`).forEach((t => {
                    t.parentNode.removeChild(t)
                })), this.text.classList.remove(Kr)
            }
        }
        constructor() {
            super(), this.autoplay = this.hasAttribute(Qr), this.scale = this.querySelector(Xr), this.text = this.querySelector(Jr), this.speed = this.hasAttribute(Gr) ? this.getAttribute(Gr) : ea, this.comparitor = this.text.cloneNode(!0), this.comparitor.classList.add(ta), this.appendChild(this.comparitor), this.scale.classList.remove(Zr), this.checkWidthEvent = this.checkWidth.bind(this)
        }
    };
    const oa = {
            marquee: ".announcement__bar-holder--marquee",
            slide: "[data-slide]",
            slider: "[data-slider]",
            ticker: "ticker-bar",
            tickerSlide: ".announcement__slide"
        },
        na = "hidden";
    let ra = class extends HTMLElement {
        connectedCallback() {
            this.slider && this.initSliders(), this.addEventListener("theme:block:select", (t => {
                this.onBlockSelect(t)
            })), this.addEventListener("theme:block:deselect", (t => {
                this.onBlockDeselect(t)
            })), this.addEventListener("theme:countdown:hide", (t => {
                if (window.Shopify.designMode) return;
                const e = t.target.closest(oa.marquee);
                if (1 === this.slidesCount) {
                    this.querySelector(oa.ticker).style.display = "none"
                }
                if (e) {
                    const e = t.target.closest(oa.tickerSlide);
                    this.removeTickerText(e)
                } else {
                    const e = t.target.closest(oa.slide);
                    this.removeSlide(e)
                }
            })), this.addEventListener("theme:countdown:expire", (() => {
                var t;
                null === (t = this.querySelectorAll(oa.ticker)) || void 0 === t || t.forEach((t => {
                    t.dispatchEvent(new CustomEvent("theme:ticker:refresh"))
                }))
            })), document.dispatchEvent(new CustomEvent("theme:announcement:init", {
                bubbles: !0
            }))
        }
        initSliders() {
            this.initSlider(), document.addEventListener("theme:resize:width", this.initSliderEvent), this.addEventListener("theme:slider:loaded", (() => {
                var t;
                null === (t = this.querySelectorAll(oa.tickerBar)) || void 0 === t || t.forEach((t => {
                    t.dispatchEvent(new CustomEvent("theme:ticker:refresh"))
                }))
            }))
        }
        initSlider() {
            const t = y(),
                e = !t;
            var s, i;
            (t && this.enableSlider || e && !this.enableSlider) && (null === (s = this.slider.flkty) || void 0 === s || s.destroy(), t && this.enableSlider ? this.enableSlider = !1 : e && !this.enableSlider && (this.enableSlider = !0), this.slider = new Tn(this, this.querySelector(oa.slider)), null === (i = this.slider.flkty) || void 0 === i || i.reposition())
        }
        removeSlide(t) {
            var e, s;
            null === (e = this.slider.flkty) || void 0 === e || e.remove(t), 0 === (null === (s = this.slider.flkty) || void 0 === s ? void 0 : s.cells.length) && this.section.classList.add(na)
        }
        removeTickerText(t) {
            const e = t.closest(oa.ticker);
            t.remove(), e.dispatchEvent(new CustomEvent("theme:ticker:refresh"))
        }
        onBlockSelect(t) {
            this.slider && this.slider.onBlockSelect(t)
        }
        onBlockDeselect(t) {
            this.slider && this.slider.onBlockDeselect(t)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.initSliderEvent), document.removeEventListener("theme:resize:width", this.tickerResizeEvent), this.removeEventListener("theme:block:select", (t => {
                this.onBlockSelect(t)
            })), this.removeEventListener("theme:block:deselect", (t => {
                this.onBlockDeselect(t)
            }))
        }
        constructor() {
            super(), this.slider = this.querySelector(oa.slider), this.enableSlider = y(), this.slidesCount = this.querySelectorAll(oa.tickerSlide).length, this.initSliderEvent = t => this.initSlider(t)
        }
    };
    customElements.get("announcement-bar") || customElements.define("announcement-bar", ra), customElements.get("ticker-bar") || customElements.define("ticker-bar", ia);
    const aa = "body",
        la = "[data-drawer]",
        ca = "[data-drawer-inner]",
        ha = "[data-drawer-underlay]",
        da = "[data-stagger-animation]",
        ua = "[data-header-wrapper]",
        pa = "data-drawer-toggle",
        ma = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        va = "drawer--animated",
        ga = "is-open",
        fa = "is-closing",
        ya = "is-focused";
    let ba = {};
    const wa = {
            onLoad() {
                ba[this.id] = [];
                this.container.querySelectorAll(la).forEach((t => {
                    ba[this.id].push(new class {
                        connectToggle() {
                            this.buttons.forEach((t => {
                                t.addEventListener("click", (() => {
                                    this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", {
                                        bubbles: !1
                                    }))
                                }))
                            }))
                        }
                        connectDrawer() {
                            this.drawer.addEventListener("theme:drawer:toggle", (() => {
                                this.drawer.classList.contains(ga) ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", {
                                    bubbles: !0
                                })) : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", {
                                    bubbles: !0
                                }))
                            })), document.addEventListener("theme:cart-drawer:open", this.hideDrawer), document.addEventListener("theme:drawer:close", this.hideDrawer), document.addEventListener("theme:drawer:open", this.showDrawer)
                        }
                        closers() {
                            this.wrapper.addEventListener("keyup", (t => {
                                "Escape" === t.code && this.hideDrawer()
                            })), this.underlay.addEventListener("click", (() => {
                                this.hideDrawer()
                            }))
                        }
                        showDrawer() {
                            this.isAnimating || (this.isAnimating = !0, this.buttons.forEach((t => {
                                t.setAttribute("aria-expanded", !0)
                            })), this.drawer.classList.add(ga, va), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                bubbles: !0
                            })), this.drawerInner && this.drawerInner.querySelector(this.btnSelector) && (N(), ci(this.drawerInner).then((() => {
                                this.drawer.querySelector(ma).focus(), this.isAnimating = !1, _(this.drawerInner, {
                                    elementToFocus: this.drawerInner.querySelector(this.btnSelector)
                                })
                            }))))
                        }
                        hideDrawer() {
                            this.drawer.classList.contains(ga) && !this.isAnimating && (this.isAnimating = !0, this.drawer.classList.add(fa), this.drawer.classList.remove(ga), N(), this.body.classList.contains(ya) && this.buttons.length && this.buttons[0].focus(), this.buttons.forEach((t => {
                                t.setAttribute("aria-expanded", !1)
                            })), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                bubbles: !0
                            })), ci(this.drawerInner).then((() => {
                                this.drawer.classList.remove(fa, va), this.isAnimating = !1, document.dispatchEvent(new CustomEvent("theme:sliderule:close", {
                                    bubbles: !1
                                }))
                            })))
                        }
                        onUnload() {
                            document.removeEventListener("theme:cart-drawer:open", this.hideDrawer), document.removeEventListener("theme:drawer:close", this.hideDrawer), document.removeEventListener("theme:drawer:open", this.showDrawer)
                        }
                        constructor(t) {
                            this.isAnimating = !1, this.drawer = t, this.drawerWrapper = this.drawer.closest(la), this.drawerInner = this.drawer.querySelector(ca), this.underlay = this.drawer.querySelector(ha), this.wrapper = this.drawer.closest(ua), this.key = this.drawer.dataset.drawer, this.btnSelector = `[${pa}='${this.key}']`, this.buttons = document.querySelectorAll(this.btnSelector), this.staggers = this.drawer.querySelectorAll(da), this.body = document.querySelector(aa), this.showDrawer = this.showDrawer.bind(this), this.hideDrawer = this.hideDrawer.bind(this), this.connectToggle(), this.connectDrawer(), this.closers()
                        }
                    }(t))
                }))
            },
            onUnload() {
                ba[this.id].forEach((t => {
                    "function" == typeof t.onUnload && t.onUnload()
                }))
            }
        },
        Ea = ".page-header",
        Sa = "js__header__stuck",
        La = "has-header-sticky",
        ka = "shopify-section-group-header-group",
        Aa = "data-header-sticky",
        Ca = "data-scroll-locked";
    let Ta = {};
    const qa = {
            onLoad() {
                Ta = new class {
                    listen() {
                        document.addEventListener("theme:scroll", this.scrollEvent), document.addEventListener("shopify:section:load", this.updateHeaderOffset), document.addEventListener("shopify:section:unload", this.updateHeaderOffset)
                    }
                    onScroll(t) {
                        t.detail.down ? !this.isStuck && t.detail.position > this.headerOffset && this.stickSimple() : t.detail.position <= this.headerOffset && this.unstickSimple()
                    }
                    updateHeaderOffset(t) {
                        t.target.classList.contains(ka) && setTimeout((() => {
                            var t;
                            this.headerOffset = null === (t = document.querySelector(Ea)) || void 0 === t ? void 0 : t.offsetTop
                        }))
                    }
                    stickOnLoad() {
                        window.scrollY > this.headerOffset && this.stickSimple()
                    }
                    stickSimple() {
                        this.cls.add(Sa), this.isStuck = !0
                    }
                    unstickSimple() {
                        document.documentElement.hasAttribute(Ca) || (this.cls.remove(Sa), this.isStuck = !1)
                    }
                    unload() {
                        document.removeEventListener("theme:scroll", this.scrollEvent), document.removeEventListener("shopify:section:load", this.updateHeaderOffset), document.removeEventListener("shopify:section:unload", this.updateHeaderOffset)
                    }
                    constructor(t) {
                        var e;
                        this.wrapper = t, this.sticks = this.wrapper.hasAttribute(Aa), document.body.classList.toggle(La, this.sticks), this.sticks && (this.isStuck = !1, this.cls = this.wrapper.classList, this.headerOffset = null === (e = document.querySelector(Ea)) || void 0 === e ? void 0 : e.offsetTop, this.updateHeaderOffset = this.updateHeaderOffset.bind(this), this.scrollEvent = t => this.onScroll(t), this.listen(), this.stickOnLoad())
                    }
                }(this.container)
            },
            onUnload: function() {
                "function" == typeof Ta.unload && Ta.unload()
            }
        },
        xa = "data-hover-disclosure-toggle",
        Ma = "[data-hover-disclosure]",
        Pa = "[data-top-link]",
        Ia = "[data-header-wrapper]",
        Ha = "[data-stagger]",
        Oa = "[data-stagger-first]",
        Ba = "[data-stagger-second]",
        Da = "is-visible",
        Fa = "meganav--visible",
        $a = "meganav--is-transitioning";
    let _a = {},
        Na = {};
    const Ra = {
            onLoad() {
                _a[this.id] = [], Na = this.container.querySelectorAll(Ma), Na.forEach((t => {
                    _a[this.id].push(new class {
                        onBlockSelect(t) {
                            this.disclosure.contains(t.target) && this.showDisclosure(t)
                        }
                        onBlockDeselect(t) {
                            this.disclosure.contains(t.target) && this.hideDisclosure()
                        }
                        showDisclosure(t) {
                            t && t.type && "mouseenter" === t.type && this.wrapper.classList.add($a), this.grandparent ? this.wrapper.classList.add(Fa) : this.wrapper.classList.remove(Fa), this.trigger.setAttribute("aria-expanded", !0), this.trigger.classList.add(Da), this.disclosure.classList.add(Da), this.transitionTimeout && clearTimeout(this.transitionTimeout), this.transitionTimeout = setTimeout((() => {
                                this.wrapper.classList.remove($a)
                            }), 200)
                        }
                        hideDisclosure() {
                            this.disclosure.classList.remove(Da), this.trigger.classList.remove(Da), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(Fa, $a)
                        }
                        staggerChildAnimations() {
                            this.disclosure.querySelectorAll(Ha).forEach(((t, e) => {
                                t.style.transitionDelay = 50 * e + 10 + "ms"
                            })), this.disclosure.querySelectorAll(Oa).forEach(((t, e) => {
                                const s = 100 * e;
                                t.style.transitionDelay = `${s}ms`, t.parentElement.querySelectorAll(Ba).forEach(((t, e) => {
                                    const i = 20 * (e + 1);
                                    t.style.transitionDelay = `${s+i}ms`
                                }))
                            }))
                        }
                        handleTablets() {
                            this.trigger.addEventListener("touchstart", function(t) {
                                this.disclosure.classList.contains(Da) || (t.preventDefault(), this.showDisclosure(t))
                            }.bind(this), {
                                passive: !0
                            })
                        }
                        connectHoverToggle() {
                            this.trigger.addEventListener("mouseenter", (t => this.showDisclosure(t))), this.link.addEventListener("focus", (t => this.showDisclosure(t))), this.trigger.addEventListener("mouseleave", (() => this.hideDisclosure())), this.trigger.addEventListener("focusout", (t => {
                                this.trigger.contains(t.relatedTarget) || this.hideDisclosure()
                            })), this.disclosure.addEventListener("keyup", (t => {
                                "Escape" === t.code && this.hideDisclosure()
                            }))
                        }
                        constructor(t) {
                            this.disclosure = t, this.wrapper = t.closest(Ia), this.key = this.disclosure.id, this.trigger = document.querySelector(`[${xa}='${this.key}']`), this.link = this.trigger.querySelector(Pa), this.grandparent = this.trigger.classList.contains("grandparent"), this.transitionTimeout = 0, this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.connectHoverToggle(), this.handleTablets(), this.staggerChildAnimations()
                        }
                    }(t))
                }))
            },
            onBlockSelect(t) {
                _a[this.id].forEach((e => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
                }))
            },
            onBlockDeselect(t) {
                _a[this.id].forEach((e => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
                }))
            }
        },
        Wa = {
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            slideruleWrappper: "[data-sliderule]",
            drawerContent: "[data-drawer-content]",
            focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
            dataAnimates: "data-animates",
            children: ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *"
        },
        za = "is-visible",
        Ua = "is-hiding",
        Va = "is-hidden",
        ja = "is-focused",
        Xa = "is-scrolling";
    let Ja = {};
    const Ya = {
            onLoad() {
                Ja[this.id] = [];
                this.container.querySelectorAll(Wa.slideruleWrappper).forEach((t => {
                    Ja[this.id].push(new class {
                        clickEvents() {
                            this.trigger.addEventListener("click", (() => {
                                this.cachedButton = this.trigger, this.showSliderule()
                            })), this.exit.forEach((t => {
                                t.addEventListener("click", (() => {
                                    this.hideSliderule()
                                }))
                            }))
                        }
                        keyboardEvents() {
                            this.sliderule.addEventListener("keyup", (t => {
                                t.stopPropagation(), "Escape" === t.code && this.hideSliderule()
                            }))
                        }
                        trapFocusSliderule(t = !0) {
                            const e = t ? this.sliderule.querySelector(this.exitSelector) : this.cachedButton;
                            this.accessibility.removeTrapFocus(), e && this.drawerContent && this.accessibility.trapFocus(this.drawerContent, {
                                elementToFocus: document.body.classList.contains(ja) ? e : null
                            })
                        }
                        hideSliderule(t = !1) {
                            const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                            this.pane.setAttribute(Wa.sliderulePane, e), this.pane.classList.add(Ua), this.sliderule.classList.add(Ua);
                            const s = t ? `[${Wa.dataAnimates}].${Va}` : `[${Wa.dataAnimates}="${e}"]`,
                                i = this.pane.querySelectorAll(s);
                            i.length && i.forEach((t => {
                                t.classList.remove(Va)
                            }));
                            const o = t ? this.pane.querySelectorAll(`.${za}, .${Ua}`) : this.children;
                            o.forEach(((s, i) => {
                                const n = o.length - 1 == i;
                                s.classList.remove(za), t && (s.classList.remove(Ua), this.pane.classList.remove(Ua));
                                const r = () => {
                                    parseInt(this.pane.getAttribute(Wa.sliderulePane)) === e && this.sliderule.classList.remove(za), this.sliderule.classList.remove(Ua), this.pane.classList.remove(Ua), n && (this.accessibility.removeTrapFocus(), t || this.trapFocusSliderule(!1)), s.removeEventListener("animationend", r)
                                };
                                window.theme.settings.enableAnimations ? s.addEventListener("animationend", r) : r()
                            }))
                        }
                        showSliderule() {
                            let t = null;
                            const e = this.sliderule.closest(`.${za}`);
                            let s = this.pane;
                            e && (s = e), s.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "smooth"
                            }), s.classList.add(Xa);
                            const i = () => {
                                s.scrollTop <= 0 ? (s.classList.remove(Xa), t && cancelAnimationFrame(t)) : t = requestAnimationFrame(i)
                            };
                            t = requestAnimationFrame(i), this.sliderule.classList.add(za);
                            const o = parseInt(this.pane.dataset.sliderulePane, 10),
                                n = o + 1;
                            this.pane.setAttribute(Wa.sliderulePane, n);
                            const r = this.pane.querySelectorAll(`[${Wa.dataAnimates}="${o}"]`);
                            r.length && r.forEach(((t, e) => {
                                const s = r.length - 1 == e;
                                t.classList.add(Ua);
                                const i = () => {
                                    t.classList.remove(Ua), parseInt(this.pane.getAttribute(Wa.sliderulePane)) !== o && t.classList.add(Va), s && this.trapFocusSliderule(), t.removeEventListener("animationend", i)
                                };
                                window.theme.settings.enableAnimations ? t.addEventListener("animationend", i) : i()
                            }))
                        }
                        closeSliderule() {
                            this.pane && this.pane.hasAttribute(Wa.sliderulePane) && parseInt(this.pane.getAttribute(Wa.sliderulePane)) > 0 && (this.hideSliderule(!0), parseInt(this.pane.getAttribute(Wa.sliderulePane)) > 0 && this.pane.setAttribute(Wa.sliderulePane, 0))
                        }
                        onUnload() {
                            document.removeEventListener("theme:sliderule:close", this.closeSliderule)
                        }
                        constructor(t) {
                            this.sliderule = t, this.key = this.sliderule.id;
                            const e = `[${Wa.slideruleOpen}='${this.key}']`;
                            this.exitSelector = `[${Wa.slideruleClose}='${this.key}']`, this.trigger = document.querySelector(e), this.exit = document.querySelectorAll(this.exitSelector), this.pane = document.querySelector(`[${Wa.sliderulePane}]`), this.children = this.sliderule.querySelectorAll(Wa.children), this.drawerContent = document.querySelector(Wa.drawerContent), this.cachedButton = null, this.accessibility = W, this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.closeSliderule = this.closeSliderule.bind(this), this.clickEvents(), this.keyboardEvents(), document.addEventListener("theme:sliderule:close", this.closeSliderule)
                        }
                    }(t))
                }))
            },
            onUnload() {
                Ja[this.id].forEach((t => {
                    "function" == typeof t.onUnload && t.onUnload()
                }))
            }
        },
        Qa = "[data-takes-space-wrapper]",
        Ga = "[data-child-takes-space]",
        Ka = "[data-header-desktop]",
        Za = '.navlink[href="#"]',
        tl = "cart-drawer",
        el = "[data-cart-toggle]",
        sl = ".main-content > .shopify-section.section-overlay-header:first-of-type",
        il = "js__header__clone",
        ol = "has-first-section-overlay-header",
        nl = "js__show__mobile",
        rl = "has-header-transparent",
        al = "data-header-transparent";
    let ll = {};
    Ro("header", [{
        onLoad() {
            ll = new class {
                initTicker(t = !1) {
                    this.tickerFrames.forEach((e => {
                        new ia(e, t)
                    })), this.tickerResizeEvent = t => this.onTickerResize(t), document.addEventListener("theme:resize:width", this.tickerResizeEvent)
                }
                listenWidth() {
                    "ResizeObserver" in window ? (this.resizeObserver = new ResizeObserver(this.checkWidth), this.resizeObserver.observe(this.wrapper)) : document.addEventListener("theme:resize", this.checkWidth)
                }
                killDeadLinks() {
                    this.deadLinks.forEach((t => {
                        t.onclick = t => {
                            t.preventDefault()
                        }
                    }))
                }
                checkWidth() {
                    if (document.body.clientWidth < this.minWidth) {
                        this.wrapper.classList.add(nl);
                        const {
                            headerHeight: t
                        } = c();
                        document.documentElement.style.setProperty("--header-height", `${t}px`)
                    } else this.wrapper.classList.remove(nl)
                }
                getMinWidth() {
                    const t = this.wrapper.cloneNode(!0);
                    t.classList.add(il), document.body.appendChild(t);
                    const e = t.querySelectorAll(Qa);
                    let s = 0,
                        i = 0;
                    return e.forEach((t => {
                        const e = t.querySelectorAll(Ga);
                        let o = 0;
                        o = 3 === e.length ? function(t) {
                            let e = [];
                            return t.forEach((t => {
                                t.firstElementChild && e.push(t.firstElementChild.clientWidth)
                            })), e[0] > e[2] ? e[2] = e[0] : e[0] = e[2], e.reduce(((t, e) => t + e))
                        }(e) : function(t) {
                            let e = 0;
                            return t.forEach((t => {
                                e += t.clientWidth
                            })), e
                        }(e), o > s && (s = o, i = 20 * e.length)
                    })), document.body.removeChild(t), s + i
                }
                cartToggleEvent() {
                    var t;
                    "drawer" === theme.settings.cartType && (null === (t = this.wrapper.querySelectorAll(el)) || void 0 === t || t.forEach((t => {
                        t.addEventListener("click", (e => {
                            const s = document.querySelector(tl);
                            s && (e.preventDefault(), s.dispatchEvent(new CustomEvent("theme:cart-drawer:show")), window.accessibility.lastElement = t)
                        }))
                    })))
                }
                toggleButtonClick(t) {
                    t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:toggle", {
                        bubbles: !0
                    }))
                }
                unload() {
                    var t;
                    "ResizeObserver" in window ? null === (t = this.resizeObserver) || void 0 === t || t.unobserve(this.wrapper) : document.removeEventListener("theme:resize", this.checkWidth)
                }
                constructor(t) {
                    this.wrapper = t, this.style = this.wrapper.dataset.style, this.desktop = this.wrapper.querySelector(Ka), this.deadLinks = document.querySelectorAll(Za), this.resizeObserver = null, this.checkWidth = this.checkWidth.bind(this), this.killDeadLinks(), "drawer" !== this.style && this.desktop && (this.minWidth = this.getMinWidth(), this.listenWidth()), this.cartToggleEvent();
                    const e = document.querySelector(sl);
                    document.body.classList.toggle(rl, this.wrapper.hasAttribute(al)), document.body.classList.toggle(ol, e)
                }
            }(this.container)
        },
        onUnload() {
            "function" == typeof ll.unload && ll.unload()
        }
    }, wa, Ya, qa, Ra]), customElements.get("ticker-bar") || customElements.define("ticker-bar", ia);
    const cl = "[data-block-scroll]",
        hl = "flickity-enabled",
        dl = {};
    const ul = {
            onLoad() {
                dl[this.id] = new class {
                    onBlockSelect(t) {
                        const e = this.container.querySelector(cl);
                        if (e && !e.classList.contains(hl)) {
                            const s = t.srcElement;
                            s && e.scrollTo({
                                top: 0,
                                left: s.offsetLeft,
                                behavior: "smooth"
                            })
                        }
                    }
                    constructor(t) {
                        this.container = t.container
                    }
                }(this)
            },
            onBlockSelect(t) {
                dl[this.id].onBlockSelect(t)
            }
        },
        pl = "[data-slider-mobile]",
        ml = "[data-slide]",
        vl = "[data-slider-thumb]",
        gl = "[data-slider-container]",
        fl = "[data-popup-container]",
        yl = "[data-popup-close]",
        bl = "is-animating",
        wl = "is-open",
        El = "data-slider-thumb",
        Sl = {};

    function Ll() {
        this.entries = []
    }

    function kl(t, e) {
        Al(t);
        var s = function(t, e) {
            Al(t),
                function(t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.")
                }(e);
            var s = [];
            return e.forEach((function(e) {
                for (var i = 0; i < t.options.length; i++) {
                    if ((t.options[i].name || t.options[i]).toLowerCase() === e.name.toLowerCase()) {
                        s[i] = e.value;
                        break
                    }
                }
            })), s
        }(t, e);
        return function(t, e) {
            return Al(t),
                function(t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.")
                }(e), t.variants.filter((function(t) {
                    return e.every((function(e, s) {
                        return t.options[s] === e
                    }))
                }))[0] || null
        }(t, s)
    }

    function Al(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.")
    }
    Ro("look", [{
        onLoad() {
            Sl[this.id] = new class {
                init() {
                    this.slider && this.slides.length && this.thumbs.length && (this.popupContainer.addEventListener("transitionend", (t => {
                        t.target == this.popupContainer && (this.popupContainer.classList.remove(bl), t.target.classList.contains(wl) ? this.popupOpenCallback() : this.popupCloseCallback())
                    })), this.popupContainer.addEventListener("transitionstart", (t => {
                        t.target == this.popupContainer && this.popupContainer.classList.add(bl)
                    })), this.popupClose.forEach((t => {
                        t.addEventListener("click", (() => {
                            this.popupContainer.classList.remove(wl), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                bubbles: !0
                            }))
                        }))
                    })), this.thumbs.forEach(((t, e) => {
                        t.addEventListener("click", (s => {
                            s.preventDefault();
                            const i = t.hasAttribute(El) && "" !== t.getAttribute(El) ? parseInt(t.getAttribute(El)) : e,
                                o = this.slides[i];
                            if (b()) {
                                const t = parseInt(window.getComputedStyle(this.slider).paddingLeft);
                                this.slider.scrollTo({
                                    top: 0,
                                    left: o.offsetLeft - t,
                                    behavior: "auto"
                                }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                    bubbles: !0
                                })), this.popupContainer.classList.add(bl, wl)
                            } else {
                                let {
                                    stickyHeaderHeight: t
                                } = c();
                                const e = o.getBoundingClientRect().top,
                                    s = o.offsetHeight / 2,
                                    i = window.innerHeight,
                                    n = i / 2,
                                    r = this.container.querySelector(gl);
                                let a = e + s - n + window.scrollY;
                                if (r) {
                                    const e = r.getBoundingClientRect().top + window.scrollY,
                                        s = e + r.offsetHeight;
                                    a < e ? a = e - t : a + i > s && (a = s - i)
                                }
                                window.scrollTo({
                                    top: a,
                                    left: 0,
                                    behavior: "smooth"
                                })
                            }
                        }))
                    })))
                }
                popupCloseByEvent() {
                    this.popupContainer.classList.remove(wl)
                }
                popupOpenCallback() {
                    document.addEventListener("theme:quick-add:open", this.popupCloseByEvent, {
                        once: !0
                    }), document.addEventListener("theme:product:added", this.popupCloseByEvent, {
                        once: !0
                    })
                }
                popupCloseCallback() {
                    document.removeEventListener("theme:quick-add:open", this.popupCloseByEvent, {
                        once: !0
                    }), document.removeEventListener("theme:product:added", this.popupCloseByEvent, {
                        once: !0
                    })
                }
                constructor(t) {
                    this.container = t.container, this.slider = this.container.querySelector(pl), this.slides = this.container.querySelectorAll(ml), this.thumbs = this.container.querySelectorAll(vl), this.popupContainer = this.container.querySelector(fl), this.popupClose = this.container.querySelectorAll(yl), this.popupCloseByEvent = this.popupCloseByEvent.bind(this), this.init()
                }
            }(this)
        }
    }, ul]), Ll.prototype.add = function(t, e, s) {
        this.entries.push({
            element: t,
            event: e,
            fn: s
        }), t.addEventListener(e, s)
    }, Ll.prototype.removeAll = function() {
        this.entries = this.entries.filter((function(t) {
            return t.element.removeEventListener(t.event, t.fn), !1
        }))
    };
    var Cl = '[name="id"]',
        Tl = '[name="selling_plan"]',
        ql = '[name^="options"]',
        xl = '[name="quantity"]',
        Ml = '[name^="properties"]';
    const Pl = "data-scrollbar",
        Il = "data-scrollbar-slider",
        Hl = "data-scrollbar-slide-fullwidth",
        Ol = "[data-scrollbar-arrow-prev]",
        Bl = "[data-scrollbar-arrow-next]",
        Dl = "is-hidden",
        Fl = 200;
    let $l = class {
        init() {
            this.arrowNext && this.arrowPrev && (this.toggleNextArrow(), this.events())
        }
        listen() {
            document.addEventListener("theme:modal:open", (() => {
                this.toggleNextArrow()
            })), document.addEventListener("theme:resize", (() => {
                this.toggleNextArrow()
            }))
        }
        events() {
            this.arrowNext.addEventListener("click", (t => {
                t.preventDefault(), this.goToNext()
            })), this.arrowPrev.addEventListener("click", (t => {
                t.preventDefault(), this.goToPrev()
            })), this.scrollbar.addEventListener("scroll", (() => {
                this.togglePrevArrow(), this.toggleNextArrow()
            }))
        }
        goToNext() {
            const t = (this.scrollbar.hasAttribute(Hl) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2) + this.scrollbar.scrollLeft;
            this.move(t), this.arrowPrev.classList.remove(Dl), this.toggleNextArrow()
        }
        goToPrev() {
            const t = this.scrollbar.hasAttribute(Hl) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2,
                e = this.scrollbar.scrollLeft - t;
            this.move(e), this.arrowNext.classList.remove(Dl), this.togglePrevArrow()
        }
        toggleNextArrow() {
            setTimeout((() => {
                var t;
                null === (t = this.arrowNext) || void 0 === t || t.classList.toggle(Dl, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth)
            }), Fl)
        }
        togglePrevArrow() {
            setTimeout((() => {
                this.arrowPrev.classList.toggle(Dl, this.scrollbar.scrollLeft <= 0)
            }), Fl)
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (t => {
                t.addEventListener("click", (e => {
                    e.preventDefault(), this.move(t.offsetLeft - t.clientWidth)
                }))
            }))
        }
        move(t) {
            this.scrollbar.scrollTo({
                top: 0,
                left: t,
                behavior: "smooth"
            })
        }
        constructor(t) {
            this.scrollbar = t, this.arrowNext = this.scrollbar.parentNode.querySelector(Bl), this.arrowPrev = this.scrollbar.parentNode.querySelector(Ol), this.scrollbar.hasAttribute(Pl) && (this.init(), this.listen()), this.scrollbar.hasAttribute(Il) && this.scrollToVisibleElement()
        }
    };
    const _l = "[data-grid-swatch-form]",
        Nl = "[data-grid-item]",
        Rl = "[data-product-information]",
        Wl = "[data-product-image]",
        zl = "[data-swatch-button]",
        Ul = "[data-swatch-link]",
        Vl = "[data-swatch-text]",
        jl = "[data-swatch-template]",
        Xl = "is-visible",
        Jl = "no-events",
        Yl = "swatch",
        Ql = "data-swatch-handle",
        Gl = "data-swatch-label",
        Kl = "data-scrollbar",
        Zl = "data-swatch-count",
        tc = "data-tooltip",
        ec = "data-swatch-variant-name",
        sc = "data-variant-title",
        ic = "data-swatch-values";
    let oc = class extends HTMLElement {
            connectedCallback() {
                this.hasAttribute(tc) && new Zo(this)
            }
            constructor() {
                super()
            }
        },
        nc = class extends HTMLElement {
            connectedCallback() {
                this.handle = this.getAttribute(Ql), this.productItem = this.closest(Nl), this.productInfo = this.closest(Rl), this.productImage = this.productItem.querySelector(Wl), this.template = document.querySelector(jl).innerHTML, this.swatchesJSON = this.getSwatchesJSON(), this.swatchesStyle = theme.settings.collectionSwatchStyle;
                const t = this.getAttribute(Gl).trim().toLowerCase();
                (function(t) {
                    const e = `${window.theme.routes.root}products/${t}.js`;
                    return window.fetch(e).then((t => t.json())).catch((t => {
                        console.error(t)
                    }))
                })(this.handle).then((e => {
                    this.product = e, this.colorOption = e.options.find((function(e) {
                        return e.name.toLowerCase() === t || null
                    })), this.colorOption && (this.swatches = this.colorOption.values, this.init())
                }))
            }
            init() {
                if (this.innerHTML = "", this.count = 0, this.limitedCount = 0, this.swatches.forEach((t => {
                        let e = null,
                            s = !1,
                            i = "";
                        for (const s of this.product.variants) {
                            const o = s.options.includes(t);
                            if (!e && o && (e = s), o && s.featured_media) {
                                i = s.featured_media.preview_image.src, e = s;
                                break
                            }
                        }
                        for (const e of this.product.variants) {
                            if (e.options.includes(t) && e.available) {
                                s = !0;
                                break
                            }
                        }
                        if (e) {
                            const r = document.createElement("div");
                            r.innerHTML = this.template;
                            const a = r.querySelector(zl),
                                l = r.querySelector(Ul),
                                c = r.querySelector(Vl),
                                h = this.swatchesJSON[t],
                                d = e.title.replaceAll('"', "'");
                            a.style = `--animation-delay: ${100*this.count/1250}s`, a.classList.add(`${Yl}-${h}`), a.dataset.tooltip = t, a.dataset.swatchVariant = e.id, a.dataset.swatchVariantName = d, a.dataset.swatchImage = i, a.dataset.variant = e.id, a.style.setProperty("--swatch", `var(--${h})`), l.href = (o = this.product.url, n = e.id, /variant=/.test(o) ? o.replace(/(variant=)[^&]+/, "$1" + n) : /\?/.test(o) ? o.concat("&variant=").concat(n) : o.concat("?variant=").concat(n)), l.dataset.swatch = t, l.disabled = !s, c.innerText = t, "limited" != this.swatchesStyle ? this.innerHTML += r.innerHTML : this.count <= 4 && (this.innerHTML += r.innerHTML, this.limitedCount++), this.count++
                        }
                        var o, n
                    })), this.swatchCount = this.productInfo.querySelector(`[${Zl}]`), this.swatchElements = this.querySelectorAll(Ul), this.swatchForm = this.productInfo.querySelector(_l), this.hideSwatchesTimer = 0, this.swatchCount.hasAttribute(Zl)) {
                    if ("text" == this.swatchesStyle || "text-slider" == this.swatchesStyle) {
                        if (this.swatchCount.innerText = `${this.count} ${this.count>1?theme.strings.otherColor:theme.strings.oneColor}`, "text" == this.swatchesStyle) return;
                        this.swatchCount.addEventListener("mouseenter", (() => {
                            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productInfo.classList.add(Jl), this.swatchForm.classList.add(Xl)
                        })), this.productInfo.addEventListener("mouseleave", (() => {
                            this.hideSwatchesTimer = setTimeout((() => {
                                this.productInfo.classList.remove(Jl), this.swatchForm.classList.remove(Xl)
                            }), 100)
                        }))
                    }
                    if ("slider" != this.swatchesStyle && "grid" != this.swatchesStyle || this.swatchForm.classList.add(Xl), "limited" == this.swatchesStyle) {
                        const t = this.count - this.limitedCount;
                        this.swatchForm.classList.add(Xl), t > 0 && (this.innerHTML += `<div class="swatch-limited">+${t}</div>`)
                    }
                }
                "text-slider" != this.swatchesStyle && "slider" != this.swatchesStyle || this.hasAttribute(Kl) && new $l(this), this.bindSwatchButtonEvents()
            }
            bindSwatchButtonEvents() {
                var t;
                null === (t = this.querySelectorAll(zl)) || void 0 === t || t.forEach((t => {
                    t.addEventListener("mouseenter", this.showVariantImageEvent), t.hasAttribute(tc) && new Zo(t)
                })), this.productItem.addEventListener("mouseleave", this.productItemMouseLeaveEvent)
            }
            showVariantImage(t) {
                var e;
                const s = null === (e = t.target.getAttribute(ec)) || void 0 === e ? void 0 : e.replaceAll('"', "'"),
                    i = this.productImage.querySelectorAll(`[${sc}]`),
                    o = this.productImage.querySelector(`[${sc}="${s}"]`);
                null == i || i.forEach((t => {
                    t.classList.remove(Xl)
                })), null == o || o.classList.add(Xl)
            }
            hideVariantImages() {
                var t;
                null === (t = this.productImage.querySelectorAll(`[${sc}].${Xl}`)) || void 0 === t || t.forEach((t => {
                    t.classList.remove(Xl)
                }))
            }
            getSwatchesJSON() {
                if (!this.hasAttribute(ic)) return {};
                const t = this.getAttribute(ic).split(","),
                    e = {};
                return null == t || t.forEach((t => {
                    const [s, i] = t.split(":");
                    e[s.trim()] = i.trim()
                })), e
            }
            constructor() {
                super(), this.productItemMouseLeaveEvent = () => this.hideVariantImages(), this.showVariantImageEvent = t => this.showVariantImage(t)
            }
        };
    const rc = {
            productCutline: "[data-product-cutline]",
            productLink: "[data-product-link]",
            productGridItem: "[data-grid-item]",
            productInfo: "[data-product-information]",
            productImage: "[data-product-image-default]",
            productImageSibling: "[data-product-image-sibling]",
            productPrice: "[data-product-price]",
            siblingsInnerHolder: "[data-sibling-inner]",
            siblingCount: "[data-sibling-count]",
            siblingFieldset: "[data-sibling-fieldset]",
            siblingLink: "[data-sibling-link]",
            tooltip: "[data-tooltip]"
        },
        ac = "is-visible",
        lc = "is-fade",
        cc = "no-events",
        hc = "is-active",
        dc = "data-sibling-cutline",
        uc = "data-sibling-image",
        pc = "data-sibling-link",
        mc = "data-sibling-price",
        vc = "data-product-link";
    let gc = class extends HTMLElement {
        connectedCallback() {
            this.product = this.closest(rc.productGridItem), this.siblingScrollbar = this.querySelector(rc.siblingsInnerHolder), this.siblingCount = this.querySelector(rc.siblingCount), this.siblingFieldset = this.querySelector(rc.siblingFieldset), this.siblingLinks = this.querySelectorAll(rc.siblingLink), this.productInfo = this.closest(rc.productInfo), this.productLink = this.closest(rc.link), this.hideSwatchesTimer = 0, this.swatchesStyle = theme.settings.collectionSwatchStyle, this.initScrollbar(), this.siblingFieldset && this.productInfo && ("grid" != this.swatchesStyle && "slider" != this.swatchesStyle && "limited" != this.swatchesStyle || this.siblingFieldset.classList.add(ac), this.siblingCount && (this.siblingCount.addEventListener("mouseenter", (() => this.showSiblings())), this.productInfo.addEventListener("mouseleave", (() => this.hideSiblings())))), this.siblingLinks.length && new class {
                init() {
                    this.cacheDefaultValues(), this.product.addEventListener("mouseleave", (() => this.resetProductValues())), this.swatches.forEach((t => {
                        t.addEventListener("mouseenter", (t => this.showSibling(t)))
                    })), this.productLinks.length && this.swatches.forEach((t => {
                        t.addEventListener("click", (() => {
                            this.productLinks[0].click()
                        }))
                    }))
                }
                cacheDefaultValues() {
                    this.productLinkValue = this.productLinks[0].hasAttribute(vc) ? this.productLinks[0].getAttribute(vc) : "", this.productPriceValue = this.productPrice.innerHTML, this.productCutline && (this.productCutlineValue = this.productCutline.innerHTML)
                }
                resetProductValues() {
                    this.product.classList.remove(hc), this.productLinkValue && this.productLinks.forEach((t => {
                        t.href = this.productLinkValue
                    })), this.productPrice && (this.productPrice.innerHTML = this.productPriceValue), this.productCutline && this.productCutline && (this.productCutline.innerHTML = this.productCutlineValue, this.productCutline.title = this.productCutlineValue), this.hideSiblingImage()
                }
                showSibling(t) {
                    const e = t.target,
                        s = e.hasAttribute(pc) ? e.getAttribute(pc) : "",
                        i = e.hasAttribute(mc) ? e.getAttribute(mc) : "",
                        o = e.hasAttribute(dc) ? e.getAttribute(dc) : "",
                        n = e.hasAttribute(uc) ? e.getAttribute(uc) : "";
                    s && this.productLinks.forEach((t => {
                        t.href = s
                    })), i && (this.productPrice.innerHTML = `<span class="price">${i}</span>`), this.productCutline && (o ? (this.productCutline.innerHTML = o, this.productCutline.title = o) : (this.productCutline.innerHTML = "", this.productCutline.title = "")), n && this.showSiblingImage(n)
                }
                showSiblingImage(t) {
                    if (!this.productImageSibling) return;
                    const e = window.devicePixelRatio || 1,
                        s = this.productImage.offsetWidth * e,
                        i = 180 * Math.ceil(s / 180),
                        o = r.getSizedImageUrl(t, `${i}x`),
                        n = this.productImageSibling.querySelector(`[src="${o}"]`),
                        a = () => {
                            this.productImageSibling.classList.add(ac), this.productImageSibling.querySelector(`[src="${o}"]`).classList.add(lc)
                        },
                        l = () => {
                            this.productImageSibling.querySelectorAll("img").forEach((t => {
                                t.classList.remove(lc)
                            })), requestAnimationFrame(a)
                        };
                    if (n) l();
                    else {
                        const t = document.createElement("img");
                        t.src = o, this.productCutline && (t.alt = this.productCutline.innerText), t.addEventListener("load", (() => {
                            this.productImageSibling.append(t), l()
                        }))
                    }
                }
                hideSiblingImage() {
                    this.productImageSibling && (this.productImageSibling.classList.remove(ac), this.productImageSibling.querySelectorAll("img").forEach((t => {
                        t.classList.remove(lc)
                    })))
                }
                constructor(t, e) {
                    this.swatches = t, this.product = e, this.productLinks = this.product.querySelectorAll(rc.productLink), this.productCutline = this.product.querySelector(rc.productCutline), this.productPrice = this.product.querySelector(rc.productPrice), this.productImage = this.product.querySelector(rc.productImage), this.productImageSibling = this.product.querySelector(rc.productImageSibling), this.init()
                }
            }(this.siblingLinks, this.product), this.querySelectorAll(rc.tooltip).forEach((t => {
                new Zo(t)
            }))
        }
        showSiblings() {
            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productLink && this.productLink.classList.add(cc), "text" != this.swatchesStyle && this.siblingFieldset.classList.add(ac)
        }
        hideSiblings() {
            this.hideSwatchesTimer = setTimeout((() => {
                this.productLink && this.productLink.classList.remove(cc), this.siblingFieldset.classList.remove(ac)
            }), 100)
        }
        initScrollbar() {
            this.siblingScrollbar && new $l(this.siblingScrollbar)
        }
        constructor() {
            super()
        }
    };
    const fc = "body",
        yc = "[data-related-section]",
        bc = "[data-tabs-holder]",
        wc = "data-tab",
        Ec = "data-tab-index",
        Sc = "[data-aos]",
        Lc = "data-block-id",
        kc = "[data-tab]",
        Ac = ".tab-link",
        Cc = ".tab-link__recent",
        Tc = ".tab-content",
        qc = "[data-scrollbar]",
        xc = "current",
        Mc = "hidden",
        Pc = "aos-animate",
        Ic = "aos-no-transition",
        Hc = "is-focused",
        Oc = {};
    const Bc = {
        onLoad() {
            Oc[this.id] = [];
            this.container.querySelectorAll(bc).forEach((t => {
                Oc[this.id].push(new class {
                    init() {
                        const t = this.container.querySelectorAll(kc);
                        this.container.addEventListener("theme:tab:check", (() => this.checkRecentTab())), this.container.addEventListener("theme:tab:hide", (() => this.hideRelatedTab())), t.length && t.forEach((t => {
                            const e = parseInt(t.getAttribute(wc)),
                                s = this.container.querySelector(`${Tc}-${e}`);
                            t.addEventListener("click", (() => {
                                this.tabChange(t, s)
                            })), t.addEventListener("keyup", (e => {
                                "Space" !== e.code && "Enter" !== e.code || !this.body.classList.contains(Hc) || this.tabChange(t, s)
                            }))
                        }))
                    }
                    tabChange(t, e) {
                        if (t.classList.contains(xc)) return;
                        const s = this.container.querySelector(`${kc}.${xc}`),
                            i = this.container.querySelector(`${Tc}.${xc}`);
                        null == s || s.classList.remove(xc), null == i || i.classList.remove(xc), t.classList.add(xc), e.classList.add(xc), t.classList.contains(Mc) && e.classList.add(Mc), this.accessibility.a11y.removeTrapFocus(), this.container.dispatchEvent(new CustomEvent("theme:tab:change", {
                            bubbles: !0
                        })), t.dispatchEvent(new CustomEvent("theme:form:sticky", {
                            bubbles: !0,
                            detail: {
                                element: "tab"
                            }
                        })), this.animateItems(e)
                    }
                    animateItems(t, e = !0) {
                        const s = t.querySelectorAll(Sc);
                        s.length && s.forEach((t => {
                            t.classList.remove(Pc), e && (t.classList.add(Ic), requestAnimationFrame((() => {
                                t.classList.remove(Ic), t.classList.add(Pc)
                            })))
                        }))
                    }
                    initNativeScrollbar() {
                        this.scrollbarHolder.length && this.scrollbarHolder.forEach((t => {
                            new $l(t)
                        }))
                    }
                    checkRecentTab() {
                        const t = this.container.querySelector(Cc);
                        if (t) {
                            t.classList.remove(Mc);
                            const e = parseInt(t.getAttribute(wc)),
                                s = this.container.querySelector(`${Tc}[${Ec}="${e}"]`);
                            s && (s.classList.remove(Mc), this.animateItems(s, !1)), this.initNativeScrollbar()
                        }
                    }
                    hideRelatedTab() {
                        const t = this.container.querySelector(yc);
                        if (!t) return;
                        const e = t.closest(`${Tc}.${xc}`);
                        if (!e) return;
                        const s = parseInt(e.getAttribute(Ec)),
                            i = this.container.querySelectorAll(kc);
                        if (i.length > s) {
                            const t = i[s].nextSibling;
                            t && (i[s].classList.add(Mc), t.dispatchEvent(new Event("click")), this.initNativeScrollbar())
                        }
                    }
                    onBlockSelect(t) {
                        const e = this.container.querySelector(`${Ac}[${Lc}="${t.detail.blockId}"]`);
                        e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({
                            top: 0,
                            left: e.offsetLeft - e.clientWidth,
                            behavior: "smooth"
                        }))
                    }
                    constructor(t) {
                        this.container = t, this.body = document.querySelector(fc), this.accessibility = window.accessibility, this.container && (this.scrollbarHolder = this.container.querySelectorAll(qc), this.init(), this.initNativeScrollbar())
                    }
                }(t))
            }))
        },
        onBlockSelect(t) {
            Oc[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        }
    };

    function Dc() {
        const t = Boolean(document.querySelectorAll("dialog[open][data-scroll-lock-required]").length),
            e = Boolean(document.querySelectorAll(".drawer.is-open").length);
        return t || e
    }
    const Fc = {
            added: "is-added",
            animated: "is-animated",
            disabled: "is-disabled",
            error: "has-error",
            loading: "is-loading",
            open: "is-open",
            overlayText: "product-item--overlay-text",
            visible: "is-visible",
            siblingLinkCurrent: "sibling__link--current"
        },
        $c = 3e3,
        _c = "[data-animation]",
        Nc = "[data-api-content]",
        Rc = "[data-quick-add-btn]",
        Wc = "[data-add-to-cart]",
        zc = "cart-drawer",
        Uc = "[data-cart-page]",
        Vc = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        jc = "[data-message-error]",
        Xc = "[data-quick-add-modal-handle]",
        Jc = "[data-product-upsell-ajax]",
        Yc = "[data-quick-add-modal-close]",
        Qc = "data-grid-item",
        Gc = "[data-product-information]",
        Kc = "[data-quick-add-holder]",
        Zc = "[data-quick-add-modal]",
        th = "[data-quick-add-modal-template]",
        eh = "closing",
        sh = "data-product-id",
        ih = "data-quick-add-modal-handle",
        oh = "data-sibling-swapper",
        nh = "data-quick-add-holder";
    let rh = class extends HTMLElement {
        connectedCallback() {
            this.modalButton && this.modalButton.addEventListener("click", this.modalButtonClickEvent), this.buttonATC && this.cart && this.buttonATC.addEventListener("click", (t => {
                t.preventDefault(), window.accessibility.lastElement = this.buttonATC, document.dispatchEvent(new CustomEvent("theme:cart:add", {
                    detail: {
                        button: this.buttonATC
                    }
                }))
            })), this.quickAddHolder && (this.quickAddHolder.addEventListener("animationend", this.quickAddLoadingToggle), this.errorHandler())
        }
        modalButtonClickEvent(t) {
            t.preventDefault();
            const e = this.modalButton.hasAttribute(oh),
                s = this.modalButton.classList.contains(Fc.siblingLinkCurrent);
            s || (this.modalButton.classList.add(Fc.loading), this.modalButton.disabled = !0, e && !s && (this.currentModal = t.target.closest(Zc), this.currentModal.classList.add(Fc.loading)), this.renderModal())
        }
        modalCreate(t) {
            const e = document.querySelector(`${Zc}[${sh}="${this.productId}"]`);
            if (e) this.modal = e, this.modalOpen();
            else {
                const e = this.quickAddHolder.querySelector(th);
                if (!e) return;
                const s = document.createElement("div");
                s.innerHTML = e.innerHTML, document.body.appendChild(s.querySelector(Zc)), e.remove(), this.modal = document.querySelector(`${Zc}[${sh}="${this.productId}"]`), this.modal.querySelector(Jc).innerHTML = (new DOMParser).parseFromString(t, "text/html").querySelector(Nc).innerHTML, this.modalCreatedCallback()
            }
        }
        modalOpen() {
            this.currentModal && this.currentModal.dispatchEvent(new CustomEvent("theme:modal:close", {
                bubbles: !1
            })), "function" == typeof this.modal.show && this.modal.show(), this.modal.setAttribute("open", !0), this.modal.removeAttribute("inert"), this.quickAddHolder.classList.add(Fc.disabled), this.modalButton && (this.modalButton.classList.remove(Fc.loading), this.modalButton.disabled = !1, window.accessibility.lastElement = this.modalButton), requestAnimationFrame((() => {
                this.modal.querySelectorAll(_c).forEach((t => {
                    t.classList.add(Fc.animated)
                }))
            })), document.dispatchEvent(new CustomEvent("theme:quick-add:open", {
                bubbles: !0
            })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), document.addEventListener("theme:product:added", this.modalCloseOnProductAdded, {
                once: !0
            })
        }
        modalClose() {
            if (!this.isAnimating) {
                if (!this.modal.hasAttribute(eh)) return this.modal.setAttribute(eh, ""), void(this.isAnimating = !0);
                "function" == typeof this.modal.close ? this.modal.close() : this.modal.removeAttribute("open"), this.modal.removeAttribute(eh), this.modal.setAttribute("inert", ""), this.modal.classList.remove(Fc.loading), this.modalButton && (this.modalButton.disabled = !1), this.quickAddHolder && this.quickAddHolder.classList.contains(Fc.disabled) && this.quickAddHolder.classList.remove(Fc.disabled), this.resetAnimatedItems(), Dc() || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0
                })), document.removeEventListener("theme:product:added", this.modalCloseOnProductAdded), this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()
            }
        }
        modalEvents() {
            var t;
            null === (t = this.modal.querySelector(Yc)) || void 0 === t || t.addEventListener("click", (t => {
                t.preventDefault(), this.modalClose()
            })), this.modal.addEventListener("click", (t => {
                "DIALOG" === t.target.nodeName && "click" === t.type && this.modalClose()
            })), this.modal.addEventListener("keydown", (t => {
                "Escape" == t.code && (t.preventDefault(), this.modalClose())
            })), this.modal.addEventListener("theme:modal:close", (() => {
                this.modalClose()
            })), this.modal.addEventListener("animationend", (t => {
                t.target === this.modal && (this.isAnimating = !1, this.modal.hasAttribute(eh) ? this.modalClose() : setTimeout((() => {
                    this.a11y.trapFocus(this.modal);
                    const t = this.modal.querySelector("[autofocus]") || this.modal.querySelector(Vc);
                    null == t || t.focus()
                }), 50))
            }))
        }
        modalCloseOnProductAdded() {
            this.resetQuickAddButtons(), this.modal && this.modal.hasAttribute("open") && this.modalClose()
        }
        quickAddLoadingToggle(t) {
            t.target == this.quickAddHolder && this.quickAddHolder.classList.remove(Fc.disabled)
        }
        errorHandler() {
            this.quickAddHolder.addEventListener("theme:cart:error", (t => {
                const e = t.detail.holder,
                    s = e.closest(`[${Qc}]`);
                if (!s) return;
                const i = e.querySelector(jc),
                    o = s.classList.contains(Fc.overlayText),
                    n = s.querySelector(Gc),
                    r = e.querySelector(Wc);
                r && (r.classList.remove(Fc.added, Fc.loading), e.classList.add(Fc.error)), i && (i.innerText = t.detail.description), o && n.classList.add(Fc.hidden), setTimeout((() => {
                    this.resetQuickAddButtons(), o && n.classList.remove(Fc.hidden)
                }), $c)
            }))
        }
        resetQuickAddButtons() {
            this.quickAddHolder && this.quickAddHolder.classList.remove(Fc.visible, Fc.error), this.buttonQuickAdd && (this.buttonQuickAdd.classList.remove(Fc.added), this.buttonQuickAdd.disabled = !1)
        }
        renderModal() {
            this.modal ? this.modalOpen() : window.fetch(`${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`).then(this.upsellErrorsHandler).then((t => t.text())).then((t => {
                this.modalCreate(t)
            }))
        }
        modalCreatedCallback() {
            this.modalEvents(), this.modalOpen(), I(this.modal)
        }
        upsellErrorsHandler(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new Ne({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        resetAnimatedItems() {
            var t;
            null === (t = this.modal) || void 0 === t || t.querySelectorAll(_c).forEach((t => {
                t.classList.remove(Fc.animated)
            }))
        }
        constructor() {
            var t;
            (super(), this.container = this, this.cart = document.querySelector(zc) || document.querySelector(Uc), this.quickAddHolder = this.container.querySelector(Kc), this.quickAddHolder) && (this.modal = null, this.currentModal = null, this.productId = this.quickAddHolder.getAttribute(nh), this.modalButton = this.quickAddHolder.querySelector(Xc), this.handle = null === (t = this.modalButton) || void 0 === t ? void 0 : t.getAttribute(ih), this.cartDrawer = document.querySelector(zc), this.buttonQuickAdd = this.quickAddHolder.querySelector(Rc), this.buttonATC = this.quickAddHolder.querySelector(Wc), this.button = this.modalButton || this.buttonATC, this.modalClose = this.modalClose.bind(this), this.modalCloseOnProductAdded = this.modalCloseOnProductAdded.bind(this), this.a11y = W, this.isAnimating = !1, this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this), this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this))
        }
    };
    Ro("product-grid", [Bc]), customElements.get("quick-add-product") || customElements.define("quick-add-product", rh), customElements.get("radio-swatch") || customElements.define("radio-swatch", oc), customElements.get("grid-swatch") || customElements.define("grid-swatch", nc), customElements.get("product-siblings") || customElements.define("product-siblings", gc);
    const ah = "complementary-products",
        lh = "quick-add-product",
        ch = "is-loaded",
        hh = "data-url";
    let dh = class extends HTMLElement {
        connectedCallback() {
            new IntersectionObserver(((t, e) => {
                t[0].isIntersecting && (e.unobserve(this), this.hasAttribute(hh) && "" !== this.getAttribute(hh) && fetch(this.getAttribute(hh)).then((t => t.text())).then((t => {
                    const e = document.createElement("div");
                    e.innerHTML = t;
                    const s = e.querySelector(ah);
                    s && s.innerHTML.trim().length && (this.innerHTML = s.innerHTML), e.querySelector(`${ah} ${lh}`) && this.classList.add(ch)
                })).catch((t => {
                    console.error(t)
                })))
            }).bind(this), {
                rootMargin: "0px 0px 400px 0px"
            }).observe(this)
        }
        constructor() {
            super()
        }
    };
    const uh = 'input:not([type="checkbox"]):not([type="hidden"]), textarea',
        ph = 'input[type="email"]',
        mh = 'input[type="checkbox"]',
        vh = "[data-form-wrapper]";
    let gh = class extends HTMLElement {
        connectedCallback() {
            this.fieldCheckbox && (this.fieldCheckbox.addEventListener("change", this.onChangeEvent), this.form && this.form.addEventListener("theme:product:add", (() => {
                this.fieldCheckbox.checked = !1, this.fieldCheckbox.dispatchEvent(new Event("change"))
            })))
        }
        clearInputValues() {
            this.fields.length && this.fields.forEach((t => {
                t.value = ""
            }))
        }
        onChange(t) {
            this.fieldEmail.required = Boolean(t.target.checked), t.target.checked || this.clearInputValues()
        }
        disconnectedCallback() {
            this.fieldCheckbox.removeEventListener("change", this.onChangeEvent)
        }
        constructor() {
            super(), this.fieldCheckbox = this.querySelector(mh), this.fieldEmail = this.querySelector(ph), this.fields = this.querySelectorAll(uh), this.form = this.closest(vh), this.onChangeEvent = t => this.onChange(t)
        }
    };
    const fh = ".product__page",
        yh = "[data-form-wrapper]",
        bh = "[data-header-sticky]",
        wh = "[data-product-media-list]",
        Eh = "is-sticky",
        Sh = "data-sticky-enabled";
    window.theme.variables = {
        productPageSticky: !1
    };
    const Lh = {};
    const kh = {
            onLoad() {
                Lh[this.id] = new class {
                    init() {
                        this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky()
                    }
                    initSticky() {
                        theme.variables.productPageSticky && (this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition())), this.formWrapper.addEventListener("theme:form:sticky", this.stickyFormEvent), document.addEventListener("theme:scroll", this.scrollEvent))
                    }
                    stickyFormEvents(t) {
                        this.removeAnimationFrameSticky(), this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition(t)))
                    }
                    scrollEvents(t) {
                        this.scrollTop = t.detail.position, this.scrollDirectionDown = t.detail.down, this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition())))
                    }
                    resizeEvents(t) {
                        this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.formWrapper.removeEventListener("theme:form:sticky", this.stickyFormEvent), this.initSticky()
                    }
                    stickyScrollCheck() {
                        const t = this.container.querySelector(`${fh} ${yh}`);
                        if (t)
                            if (y()) {
                                const e = this.container.querySelector(yh),
                                    s = this.container.querySelector(wh);
                                if (!e || !s) return;
                                e.offsetHeight < s.offsetHeight ? (theme.variables.productPageSticky = !0, t.classList.add(Eh)) : (theme.variables.productPageSticky = !1, t.classList.remove(Eh))
                            } else theme.variables.productPageSticky = !1, t.classList.remove(Eh)
                    }
                    calculateStickyPosition(t = null) {
                        if (document.documentElement.hasAttribute("data-scroll-locked")) return void this.removeAnimationFrameSticky();
                        const e = Boolean(t && t.detail),
                            s = Boolean(e && t.detail.element && "accordion" === t.detail.element),
                            i = this.formWrapper.offsetHeight,
                            o = window.innerHeight - i - this.defaultTopBottomSpacings,
                            n = Math.abs(this.scrollTop - this.scrollLastPosition);
                        if (this.scrollDirectionDown ? this.stickyScrollTop -= n : this.stickyScrollTop += n, this.stickyFormLoad) {
                            if (document.querySelector(bh)) {
                                let {
                                    headerHeight: t
                                } = c();
                                this.stickyDefaultTop = t
                            } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
                            this.stickyScrollTop = this.stickyDefaultTop
                        }
                        this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop);
                        const r = this.stickyScrollTop - this.currentPoint;
                        this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + .5 * r, this.formWrapper.style.setProperty("--sticky-top", `${this.currentPoint}px`), this.scrollLastPosition = this.scrollTop, this.stickyFormLoad = !1, s && this.onChangeCounter <= 10 || s && this.stickyFormLastHeight !== i || this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky ? (s && (this.onChangeCounter += 1), s && this.stickyFormLastHeight !== i && (this.onChangeCounter = 11), this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition(t)))) : this.requestAnimationSticky && this.removeAnimationFrameSticky(), this.stickyFormLastHeight = i
                    }
                    removeAnimationFrameSticky() {
                        this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), this.requestAnimationSticky = null, this.onChangeCounter = 0)
                    }
                    onUnload() {
                        this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent)
                    }
                    constructor(t) {
                        this.section = t, this.container = t.container, this.stickyEnabled = "true" === this.container.getAttribute(Sh), this.formWrapper = this.container.querySelector(yh), this.stickyScrollTop = 0, this.scrollLastPosition = 0, this.stickyDefaultTop = 0, this.currentPoint = 0, this.defaultTopBottomSpacings = 30, this.scrollTop = window.scrollY, this.scrollDirectionDown = !0, this.requestAnimationSticky = null, this.stickyFormLoad = !0, this.stickyFormLastHeight = null, this.onChangeCounter = 0, this.scrollEvent = t => this.scrollEvents(t), this.resizeEvent = t => this.resizeEvents(t), this.stickyFormEvent = t => this.stickyFormEvents(t), setTimeout((() => {
                            this.init()
                        }), 50)
                    }
                }(this)
            },
            onUnload() {
                Lh[this.id].onUnload()
            }
        },
        Ah = "data-section-type",
        Ch = "[data-share-button]",
        Th = "[data-share-message]",
        qh = "is-visible";
    let xh = class extends HTMLElement {
        init() {
            navigator.share ? this.shareButton.addEventListener("click", (() => {
                navigator.share({
                    url: this.urlToShare,
                    title: document.title
                })
            })) : this.shareButton.addEventListener("click", this.copyToClipboard.bind(this))
        }
        updateShareLink() {
            "product" == this.container.getAttribute(Ah) && this.container.addEventListener("theme:variant:change", (t => {
                t.detail.variant && (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`)
            }))
        }
        copyToClipboard() {
            navigator.clipboard.writeText(this.urlToShare).then((() => {
                this.shareMessage.classList.add(qh);
                const t = () => {
                    this.shareMessage.classList.remove(qh), this.shareMessage.removeEventListener("animationend", t)
                };
                this.shareMessage.addEventListener("animationend", t)
            }))
        }
        constructor() {
            super(), this.container = this.closest(`[${Ah}]`), this.shareButton = this.querySelector(Ch), this.shareMessage = this.querySelector(Th), this.urlToShare = this.shareButton.dataset.shareUrl ? this.shareButton.dataset.shareUrl : document.location.href, this.init(), this.updateShareLink()
        }
    };
    const Mh = "[data-button-arrow]",
        Ph = "[data-deferred-media-button]",
        Ih = "model-viewer, video, iframe, button, [href], input, [tabindex]",
        Hh = "[data-image-id]",
        Oh = "[data-product-media-list]",
        Bh = "[data-section-type]",
        Dh = "slider__arrows",
        Fh = "is-dragging",
        $h = "is-focused",
        _h = "media--active",
        Nh = "media--hidden",
        Rh = "media--hiding",
        Wh = "data-active-media",
        zh = "data-button-prev",
        Uh = "data-button-next",
        Vh = "data-image-id",
        jh = "data-media-id",
        Xh = "data-fader-desktop",
        Jh = "data-fader-mobile";
    let Yh = class extends HTMLElement {
        connectedCallback() {
            1 !== Object.keys(this.productMediaItems).length && (this.productMediaObserver(), this.toggleEvents(), this.listen(), this.setHeight())
        }
        disconnectedCallback() {
            this.unlisten()
        }
        listen() {
            document.addEventListener("theme:resize:width", this.toggleEvents), document.addEventListener("theme:resize:width", this.setHeight), this.addEventListener("theme:media:select", this.selectMediaEvent)
        }
        unlisten() {
            document.removeEventListener("theme:resize:width", this.toggleEvents), document.removeEventListener("theme:resize:width", this.setHeight), this.removeEventListener("theme:media:select", this.selectMediaEvent)
        }
        toggleEvents() {
            const t = b();
            t && this.hasAttribute(Jh) || !t && this.hasAttribute(Xh) ? this.bindEventListeners() : this.unbindEventListeners()
        }
        bindEventListeners() {
            this.initialized || (this.productMediaList.addEventListener("mousedown", this.handleMouseDown), this.productMediaList.addEventListener("mouseleave", this.handleMouseLeave), this.productMediaList.addEventListener("mouseup", this.handleMouseUp), this.productMediaList.addEventListener("mousemove", this.handleMouseMove), this.productMediaList.addEventListener("touchstart", this.handleMouseDown, {
                passive: !0
            }), this.productMediaList.addEventListener("touchend", this.handleMouseUp, {
                passive: !0
            }), this.productMediaList.addEventListener("touchmove", this.handleMouseMove, {
                passive: !0
            }), this.productMediaList.addEventListener("keyup", this.handleKeyUp), this.initArrows(), this.resetScrollPosition(), this.initialized = !0)
        }
        unbindEventListeners() {
            this.initialized && (this.productMediaList.removeEventListener("mousedown", this.handleMouseDown), this.productMediaList.removeEventListener("mouseleave", this.handleMouseLeave), this.productMediaList.removeEventListener("mouseup", this.handleMouseUp), this.productMediaList.removeEventListener("mousemove", this.handleMouseMove), this.productMediaList.removeEventListener("touchstart", this.handleMouseDown), this.productMediaList.removeEventListener("touchend", this.handleMouseUp), this.productMediaList.removeEventListener("touchmove", this.handleMouseMove), this.productMediaList.removeEventListener("keyup", this.handleKeyUp), this.removeArrows(), this.initialized = !1)
        }
        handleMouseDown(t) {
            this.isDown = !0, this.startX = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft, this.startY = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop
        }
        handleMouseLeave() {
            this.isDown && (this.isDown = !1)
        }
        handleMouseUp(t) {
            const e = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft,
                s = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop,
                i = e - this.startX,
                o = s - this.startY,
                n = i > 0 ? 1 : -1;
            Math.abs(i) > 10 && Math.abs(i) > Math.abs(o) && (n < 0 ? this.showNextImage() : this.showPreviousImage()), this.isDown = !1, requestAnimationFrame((() => {
                this.classList.remove(Fh)
            }))
        }
        handleMouseMove() {
            this.isDown && this.classList.add(Fh)
        }
        handleKeyUp(t) {
            "ArrowLeft" === t.code && this.showPreviousImage(), "ArrowRight" === t.code && this.showNextImage()
        }
        handleArrowsClickEvent() {
            var t;
            null === (t = this.querySelectorAll(Mh)) || void 0 === t || t.forEach((t => {
                t.addEventListener("click", (t => {
                    t.preventDefault(), t.target.hasAttribute(zh) && this.showPreviousImage(), t.target.hasAttribute(Uh) && this.showNextImage()
                }))
            }))
        }
        resetScrollPosition() {
            0 !== this.productMediaList.scrollLeft && (this.productMediaList.scrollLeft = 0)
        }
        initArrows() {
            if (!this.buttons.length) {
                const t = document.createElement("div");
                t.classList.add(Dh), t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next, this.productMediaList.append(t), this.buttons = this.querySelectorAll(Mh), this.buttonPrev = this.querySelector(`[${zh}]`), this.buttonNext = this.querySelector(`[${Uh}]`)
            }
            this.handleArrowsClickEvent(), this.preloadImageOnArrowHover()
        }
        removeArrows() {
            var t;
            null === (t = this.querySelector(`.${Dh}`)) || void 0 === t || t.remove()
        }
        preloadImageOnArrowHover() {
            var t, e;
            null === (t = this.buttonPrev) || void 0 === t || t.addEventListener("mouseover", (() => {
                const t = this.getPreviousMediaId();
                this.preloadImage(t)
            })), null === (e = this.buttonNext) || void 0 === e || e.addEventListener("mouseover", (() => {
                const t = this.getNextMediaId();
                this.preloadImage(t)
            }))
        }
        preloadImage(t) {
            var e;
            null === (e = this.querySelector(`[${jh}="${t}"] img`)) || void 0 === e || e.setAttribute("loading", "eager")
        }
        showMediaOnVariantSelect(t) {
            const e = t.detail.id;
            this.setActiveMedia(e)
        }
        getCurrentMedia() {
            return this.querySelector(`${Hh}.${_h}`)
        }
        getNextMediaId() {
            const t = this.getCurrentMedia(),
                e = (null == t ? void 0 : t.nextElementSibling.hasAttribute(Vh)) ? null == t ? void 0 : t.nextElementSibling : this.querySelector(Hh);
            return null == e ? void 0 : e.getAttribute(jh)
        }
        getPreviousMediaId() {
            const t = this.getCurrentMedia(),
                e = this.productMediaItems.length - 1,
                s = (null == t ? void 0 : t.previousElementSibling) || this.productMediaItems[e];
            return null == s ? void 0 : s.getAttribute(jh)
        }
        showNextImage() {
            const t = this.getNextMediaId();
            this.selectMedia(t)
        }
        showPreviousImage() {
            const t = this.getPreviousMediaId();
            this.selectMedia(t)
        }
        selectMedia(t) {
            this.dispatchEvent(new CustomEvent("theme:media:select", {
                detail: {
                    id: t
                }
            }))
        }
        setActiveMedia(t) {
            if (!t) return;
            this.setAttribute(Wh, t);
            const e = this.querySelector(`${Hh}.${_h}`),
                s = this.querySelector(`[${jh}="${t}"]`),
                i = null == s ? void 0 : s.querySelector(Ih),
                o = s.querySelector("deferred-media");
            var n;
            (null == e || e.classList.add(Rh), null == e || e.classList.remove(_h), null == s || s.classList.remove(Rh, Nh), null == s || s.classList.add(_h), o && !0 !== o.getAttribute("loaded")) && (null === (n = s.querySelector(Ph)) || void 0 === n || n.dispatchEvent(new Event("click", {
                bubbles: !1
            })));
            requestAnimationFrame((() => {
                this.setHeight(), document.body.classList.contains($h) && (null == i || i.focus())
            }))
        }
        setHeight() {
            var t, e;
            const s = (null === (t = this.querySelector(`${Hh}.${_h}`)) || void 0 === t ? void 0 : t.offsetHeight) || (null === (e = this.productMediaItems[0]) || void 0 === e ? void 0 : e.offsetHeight);
            this.style.setProperty("--height", `${s}px`)
        }
        productMediaObserver() {
            this.productMediaItems.forEach((t => {
                t.addEventListener("transitionend", (e => {
                    e.target == t && t.classList.contains(Rh) && (t.classList.remove(Rh), t.classList.add(Nh))
                })), t.addEventListener("transitioncancel", (e => {
                    e.target == t && t.classList.contains(Rh) && (t.classList.remove(Rh), t.classList.add(Nh))
                }))
            }))
        }
        constructor() {
            super(), this.initialized = !1, this.buttons = !1, this.isDown = !1, this.startX = 0, this.startY = 0, this.scrollLeft = 0, this.onButtonArrowClick = t => this.buttonArrowClickEvent(t), this.container = this.closest(Bh), this.handleMouseDown = this.handleMouseDown.bind(this), this.handleMouseLeave = this.handleMouseLeave.bind(this), this.handleMouseUp = this.handleMouseUp.bind(this), this.handleMouseMove = this.handleMouseMove.bind(this), this.handleKeyUp = this.handleKeyUp.bind(this), this.productMediaItems = this.querySelectorAll(Hh), this.productMediaList = this.querySelector(Oh), this.setHeight = this.setHeight.bind(this), this.toggleEvents = this.toggleEvents.bind(this), this.selectMediaEvent = t => this.showMediaOnVariantSelect(t)
        }
    };
    const Qh = "data-option-position",
        Gh = '[name^="options"], [data-popout-option]',
        Kh = '[name^="options"]:checked, [name^="options"][type="hidden"]',
        Zh = "data-value",
        td = "[data-popout]",
        ed = "sold-out",
        sd = "unavailable",
        id = "sale";
    const od = "[data-product]",
        nd = "[data-product-form]",
        rd = "product-notification",
        ad = "[data-variant-title]",
        ld = "[data-notification-product]",
        cd = "[data-add-to-cart]",
        hd = "[data-add-to-cart-text]",
        dd = "cart-drawer",
        ud = "[data-cart-page]",
        pd = "[data-compare-price]",
        md = "[data-compare-text]",
        vd = "[data-form-wrapper]",
        gd = "[data-product-select]",
        fd = "[data-price-wrapper]",
        yd = "product-images",
        bd = "[data-product-media-list]",
        wd = "[data-product-json]",
        Ed = "[data-product-price]",
        Sd = "[data-product-unit-price]",
        Ld = "[data-product-base]",
        kd = "[data-product-unit]",
        Ad = "[data-product-preorder]",
        Cd = "[data-subscription-watch-price]",
        Td = "[data-subscription-selectors]",
        qd = "[data-toggles-group]",
        xd = "data-group-toggle",
        Md = "[data-plan-description]",
        Pd = "[data-section-type]",
        Id = "[data-variant-sku]",
        Hd = "[data-variant-final-sale-metafield]",
        Od = "[data-variant-option-image]",
        Bd = "[data-quick-add-modal]",
        Dd = "[data-price-off]",
        Fd = "[data-price-off-type]",
        $d = "[data-price-off-amount]",
        _d = "[data-remaining-count]",
        Nd = "[data-remaining-max]",
        Rd = "[data-remaining-wrapper]",
        Wd = "[data-product-remaining-json]",
        zd = "[data-option-value]",
        Ud = "[data-option-position]",
        Vd = "[data-product-form-installment]",
        jd = 'input[name="id"]',
        Xd = "hidden",
        Jd = "variant--soldout",
        Yd = "variant--unavailable",
        Qd = "product__price--sale",
        Gd = "count-is-low",
        Kd = "count-is-in",
        Zd = "count-is-out",
        tu = "count-is-unavailable",
        eu = "data-remaining-max",
        su = "data-enable-history-state",
        iu = "data-fader-desktop",
        ou = "data-fader-mobile",
        nu = "data-option-position",
        ru = "data-image-id",
        au = "data-media-id",
        lu = "data-quick-add-btn",
        cu = "data-final-sale",
        hu = "data-variant-image-scroll";
    let du = class extends HTMLElement {
        connectedCallback() {
            if (this.cartAddEvents(), this.container = this.closest(Pd) || this.closest(Bd), !this.container) return;
            if (this.sectionId = this.container.dataset.sectionId, this.product = this.container.querySelector(od), this.productForm = this.container.querySelector(nd), this.productNotification = this.container.querySelector(rd), this.productImages = this.container.querySelector(yd), this.productMediaList = this.container.querySelector(bd), this.installmentForm = this.container.querySelector(Vd), this.skuWrapper = this.container.querySelector(Id), this.sellout = null, this.variantImageScroll = "true" === this.container.getAttribute(hu), this.priceOffWrap = this.container.querySelector(Dd), this.priceOffAmount = this.container.querySelector($d), this.priceOffType = this.container.querySelector(Fd), this.planDescription = this.container.querySelector(Md), this.remainingWrapper = this.container.querySelector(Rd), this.remainingWrapper) {
                const t = this.container.querySelector(Nd);
                t && (this.remainingMaxInt = parseInt(t.getAttribute(eu), 10), this.remainingCount = this.container.querySelector(_d), this.remainingJSONWrapper = this.container.querySelector(Wd), this.remainingJSON = null, this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML) : console.warn("Missing product quantity JSON"))
            }
            this.enableHistoryState = "true" === this.container.getAttribute(su), this.hasUnitPricing = this.container.querySelector(kd), this.subSelectors = this.container.querySelector(Td), this.subPrices = this.container.querySelector(Cd), this.isPreOrder = this.container.querySelector(Ad);
            let t = null;
            const e = this.container.querySelector(wd);
            e && (t = e.innerHTML), t ? (this.productJSON = JSON.parse(t), this.linkForm(), this.sellout = new class {
                init() {
                    this.update()
                }
                update() {
                    this.getCurrentState(), this.optionElements.forEach((t => {
                        const e = t.closest(`[${Qh}]`);
                        if (!e) return;
                        const s = t.value || t.getAttribute(Zh),
                            i = e.getAttribute(Qh),
                            o = parseInt(i, 10) - 1,
                            n = t.closest(td);
                        let r = [...this.selections];
                        r[o] = s;
                        const a = this.productJSON.variants.find((t => {
                            let e = !0;
                            for (let s = 0; s < r.length; s++) t.options[s] !== r[s] && (e = !1);
                            return e
                        }));
                        t.classList.remove(ed, sd), t.parentNode.classList.remove(id), n && n.classList.remove(ed, sd, id), void 0 === a ? (t.classList.add(sd), n && n.classList.add(sd)) : a && !1 === a.available && (t.classList.add(ed), n && n.classList.add(ed)), a && a.compare_at_price > a.price && theme.settings.variantOnSale && t.parentNode.classList.add(id)
                    }))
                }
                getCurrentState() {
                    this.selections = [];
                    const t = this.container.querySelectorAll(Kh);
                    t.length && t.forEach((t => {
                        const e = t.value;
                        e && "" !== e && this.selections.push(e)
                    }))
                }
                constructor(t, e) {
                    this.container = t, this.productJSON = e, this.optionElements = this.container.querySelectorAll(Gh), this.productJSON && this.optionElements.length && this.init()
                }
            }(this.container, this.productJSON)) : console.error("Missing product JSON"), this.variantOptionImages = this.container.querySelectorAll(Od), this.variantOptionImages.length > 1 && this.optionImagesWidth()
        }
        cartAddEvents() {
            this.buttonATC = this.querySelector(cd);
            const t = document.querySelector(dd) || document.querySelector(ud);
            this.buttonATC && t && this.buttonATC.addEventListener("click", (t => {
                t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:add", {
                    detail: {
                        button: this.buttonATC
                    },
                    bubbles: !1
                })), this.closest(Bd) || (window.accessibility.lastElement = this.buttonATC)
            }))
        }
        destroy() {
            this.productForm.destroy()
        }
        linkForm() {
            this.productForm = new class {
                destroy() {
                    this._listeners.removeAll()
                }
                options() {
                    return this._serializeInputValues(this.optionInputs, (function(t) {
                        return t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2], t
                    }))
                }
                variant() {
                    const t = this.options();
                    return t.length ? kl(this.product, t) : this.product.variants[0]
                }
                plan(t) {
                    let e = {
                        allocation: null,
                        group: null,
                        detail: null
                    };
                    const s = this.element.querySelector(`${Tl}:checked`);
                    if (!s) return null;
                    const i = s.value,
                        o = i && "" !== i ? i : null;
                    return o && t && (e.allocation = t.selling_plan_allocations.find((function(t) {
                        return t.selling_plan_id.toString() === o.toString()
                    }))), e.allocation && (e.group = this.product.selling_plan_groups.find((function(t) {
                        return t.id.toString() === e.allocation.selling_plan_group_id.toString()
                    }))), e.group && (e.detail = e.group.selling_plans.find((function(t) {
                        return t.id.toString() === o.toString()
                    }))), e && e.allocation && e.detail && e.allocation ? e : null
                }
                properties() {
                    return this._serializeInputValues(this.propertyInputs, (function(t) {
                        return t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2], t
                    }))
                }
                quantity() {
                    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
                }
                getFormState() {
                    const t = this.variant();
                    return {
                        options: this.options(),
                        variant: t,
                        properties: this.properties(),
                        quantity: this.quantity(),
                        plan: this.plan(t)
                    }
                }
                _setIdInputValue(t) {
                    t && t.id ? this.variantElement.value = t.id.toString() : this.variantElement.value = "", this.variantElement.dispatchEvent(new Event("change"))
                }
                _onSubmit(t, e) {
                    e.dataset = this.getFormState(), t.onFormSubmit && t.onFormSubmit(e)
                }
                _onOptionChange(t) {
                    this._setIdInputValue(t.dataset.variant)
                }
                _onFormEvent(t) {
                    return void 0 === t ? Function.prototype.bind() : function(e) {
                        e.dataset = this.getFormState(), this._setIdInputValue(e.dataset.variant), t(e)
                    }.bind(this)
                }
                _initInputs(t, e) {
                    return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(function(t) {
                        return this._listeners.add(t, "change", this._onFormEvent(e)), t
                    }.bind(this))
                }
                _serializeInputValues(t, e) {
                    return t.reduce((function(t, s) {
                        return (s.checked || "radio" !== s.type && "checkbox" !== s.type) && t.push(e({
                            name: s.name,
                            value: s.value
                        })), t
                    }), [])
                }
                _validateProductObject(t) {
                    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                    if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from null or from the http://[your-product-url].js route");
                    return t
                }
                constructor(t, e, s) {
                    this.element = t, this.product = this._validateProductObject(e), this.variantElement = this.element.querySelector(Cl), s = s || {}, this._listeners = new Ll, this._listeners.add(this.element, "submit", this._onSubmit.bind(this, s)), this.optionInputs = this._initInputs(ql, s.onOptionChange), this.planInputs = this._initInputs(Tl, s.onPlanChange), this.quantityInputs = this._initInputs(xl, s.onQuantityChange), this.propertyInputs = this._initInputs(Ml, s.onPropertyChange)
                }
            }(this.container, this.productJSON, {
                onOptionChange: this.onOptionChange.bind(this),
                onPlanChange: this.onPlanChange.bind(this)
            }), this.pushState(this.productForm.getFormState(), !0), this.subsToggleListeners()
        }
        onOptionChange(t) {
            this.pushState(t.dataset), this.updateProductImage(t)
        }
        onPlanChange(t) {
            this.subPrices && this.pushState(t.dataset)
        }
        pushState(t, e = !1) {
            var s;
            this.productState = this.setProductState(t), this.updateAddToCartState(t), this.updateNotificationForm(t), this.updateProductPrices(t), this.updateSaleText(t), this.updateSku(t), this.updateSubscriptionText(t), this.updateRemaining(t), this.updateLegend(t), this.fireHookEvent(t), null === (s = this.sellout) || void 0 === s || s.update(t), this.enableHistoryState && !e && this.updateHistoryState(t)
        }
        updateAddToCartState(t) {
            const e = t.variant;
            let s = theme.strings.addToCart;
            const i = this.container.querySelectorAll(fd),
                o = this.container.querySelectorAll(cd),
                n = this.container.querySelectorAll(hd),
                r = this.container.querySelectorAll(vd);
            if (this.installmentForm && e) {
                const t = this.installmentForm.querySelector(jd);
                t.value = e.id, t.dispatchEvent(new Event("change", {
                    bubbles: !0
                }))
            }
            this.isPreOrder && (s = theme.strings.preOrder), i.length && e && i.forEach((t => {
                t.classList.remove(Xd)
            })), null == o || o.forEach((t => {
                t.hasAttribute(lu) || (e && e.available ? t.disabled = !1 : t.disabled = !0)
            })), null == n || n.forEach((t => {
                let i = s;
                e ? e.available || (i = theme.strings.soldOut) : i = theme.strings.unavailable, t.textContent = i
            })), r.length && r.forEach((t => {
                if (e) {
                    e.available ? t.classList.remove(Jd, Yd) : (t.classList.add(Jd), t.classList.remove(Yd));
                    const s = t.querySelector(gd);
                    s && (s.value = e.id);
                    const i = t.querySelector(`${jd}[form]`);
                    i && (i.value = e.id, i.dispatchEvent(new Event("change")))
                } else t.classList.add(Yd), t.classList.remove(Jd)
            }))
        }
        updateNotificationForm(t) {
            if (!this.productNotification) return;
            const e = this.productNotification.querySelector(ad),
                s = this.productNotification.querySelector(ld);
            null != e && (e.textContent = t.variant.title, s.value = t.variant.name)
        }
        updateHistoryState(t) {
            const e = t.variant,
                s = t.plan,
                i = window.location.href;
            if (e && i.includes("/product")) {
                const t = new window.URL(i),
                    o = t.searchParams;
                o.set("variant", e.id), s && s.detail && s.detail.id && this.productState.hasPlan ? o.set("selling_plan", s.detail.id) : o.delete("selling_plan"), t.search = o.toString();
                const n = t.toString();
                window.history.replaceState({
                    path: n
                }, "", n)
            }
        }
        updateRemaining(t) {
            var e;
            const s = t.variant;
            if (null === (e = this.remainingWrapper) || void 0 === e || e.classList.remove(Kd, Zd, tu, Gd), s && this.remainingWrapper && this.remainingJSON) {
                const t = this.remainingJSON[s.id];
                ("out" === t || t < 1) && this.remainingWrapper.classList.add(Zd), ("in" === t || t >= this.remainingMaxInt) && this.remainingWrapper.classList.add(Kd), ("low" === t || t > 0 && t < this.remainingMaxInt) && (this.remainingWrapper.classList.add(Gd), this.remainingCount && (this.remainingCount.innerHTML = t))
            } else !s && this.remainingWrapper && this.remainingWrapper.classList.add(tu)
        }
        optionImagesWidth() {
            let t = 0;
            for (const e of this.variantOptionImages) {
                const s = e.offsetWidth;
                s > t && (t = s)
            }
            for (const e of this.variantOptionImages) e.style.width = t + "px"
        }
        getBaseUnit(t) {
            return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit
        }
        subsToggleListeners() {
            this.container.querySelectorAll(qd).forEach((t => {
                t.addEventListener("change", function(t) {
                    const e = t.target.value.toString(),
                        s = this.container.querySelector(`[${xd}="${e}"]`),
                        i = this.container.querySelectorAll(`[${xd}]`);
                    if (s) {
                        s.classList.remove(Xd);
                        const t = s.querySelector('[name="selling_plan"]');
                        t.checked = !0, t.dispatchEvent(new Event("change"))
                    }
                    i.forEach((t => {
                        if (t !== s) {
                            t.classList.add(Xd);
                            t.querySelectorAll('[name="selling_plan"]').forEach((t => {
                                t.checked = !1, t.dispatchEvent(new Event("change"))
                            }))
                        }
                    }))
                }.bind(this))
            }))
        }
        updateSaleText(t) {
            this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(Xd)
        }
        isVariantFinalSale(t) {
            const e = document.querySelector(Hd).textContent,
                s = JSON.parse(e);
            let i = !1;
            return s.forEach((e => {
                Number(e.variant_id) === t.id && (i = "true" === e.metafield_value)
            })), i
        }
        updateSaleTextStandard(t) {
            const e = t.variant;
            if (this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"), this.priceOffAmount && this.priceOffWrap) {
                const t = (e.compare_at_price - e.price) / e.compare_at_price,
                    s = Math.floor(100 * t);
                this.priceOffAmount.innerHTML = `${s}%`, this.priceOffWrap.classList.remove(Xd)
            }
            this.closest(Bd) || (this.priceOffWrap.hasAttribute(cu) || this.isVariantFinalSale(e) ? this.priceOffWrap.classList.remove(Xd) : this.priceOffWrap.classList.add(Xd))
        }
        updateSubscriptionText(t) {
            t.plan && this.planDescription ? (this.planDescription.innerHTML = t.plan.detail.description, this.planDescription.classList.remove(Xd)) : this.planDescription && this.planDescription.classList.add(Xd)
        }
        updateSaleTextSubscription(t) {
            if (this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton"), this.priceOffAmount && this.priceOffWrap) {
                const e = t.plan.detail.price_adjustments[0],
                    i = e.value;
                e && "percentage" === e.value_type ? this.priceOffAmount.innerHTML = `${i}%` : this.priceOffAmount.innerHTML = s.formatMoney(i, theme.moneyFormat), this.priceOffWrap.classList.remove(Xd)
            }
        }
        updateProductPrices(t) {
            const e = t.variant,
                i = t.plan;
            this.container.querySelectorAll(fd).forEach((t => {
                const o = t.querySelector(pd),
                    n = t.querySelector(Ed),
                    r = t.querySelector(md);
                let a = "",
                    l = "";
                this.productState.available && (a = e.compare_at_price, l = e.price), this.productState.hasPlan && (l = i.allocation.price), this.productState.planSale && (a = i.allocation.compare_at_price, l = i.allocation.price), o && (this.productState.onSale || this.productState.planSale ? (o.classList.remove(Xd), r.classList.remove(Xd), n.classList.add(Qd)) : (o.classList.add(Xd), r.classList.add(Xd), n.classList.remove(Qd)), o.innerHTML = s.formatMoney(a, theme.moneyFormat)), n.innerHTML = 0 === l ? window.theme.strings.free : s.formatMoney(l, theme.moneyFormat)
            })), this.hasUnitPricing && this.updateProductUnits(t)
        }
        updateProductUnits(t) {
            const e = t.variant,
                i = t.plan;
            let o = null;
            if (e && e.unit_price && (o = e.unit_price), i && i.allocation && i.allocation.unit_price && (o = i.allocation.unit_price), o) {
                const t = this.getBaseUnit(e),
                    i = s.formatMoney(o, theme.moneyFormat);
                this.container.querySelector(Sd).innerHTML = i, this.container.querySelector(Ld).innerHTML = t, $e(this.container.querySelector(kd))
            } else(n = this.container.querySelector(kd)) && (n.style.display = "none");
            var n
        }
        updateSku(t) {
            this.skuWrapper && (this.skuWrapper.innerHTML = `${theme.strings.sku}: ${t.variant.sku}`)
        }
        fireHookEvent(t) {
            const e = t.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", {
                detail: {
                    variant: e
                },
                bubbles: !0
            }))
        }
        setProductState(t) {
            const e = t.variant,
                s = t.plan,
                i = {
                    available: !0,
                    soldOut: !1,
                    onSale: !1,
                    showUnitPrice: !1,
                    requiresPlan: !1,
                    hasPlan: !1,
                    planPerDelivery: !1,
                    planSale: !1
                };
            return !e || e.requires_selling_plan && !s ? i.available = !1 : (e.available || (i.soldOut = !0), e.compare_at_price > e.price && (i.onSale = !0), e.unit_price && (i.showUnitPrice = !0), this.product && this.product.requires_selling_plan && (i.requiresPlan = !0), s && this.subPrices && (i.hasPlan = !0, s.allocation.per_delivery_price !== s.allocation.price && (i.planPerDelivery = !0), e.price > s.allocation.price && (i.planSale = !0))), i
        }
        updateProductImage(t) {
            const e = t.dataset.variant;
            if (e && e.featured_media) {
                const t = this.container.querySelector(`[${ru}="${e.featured_media.id}"]`);
                if (t) {
                    const e = t.getAttribute(au),
                        s = y();
                    if (t.dispatchEvent(new CustomEvent("theme:media:select", {
                            bubbles: !0,
                            detail: {
                                id: e
                            }
                        })), s && !this.productImages.hasAttribute(iu) && this.variantImageScroll) {
                        const e = t.getBoundingClientRect().top;
                        document.dispatchEvent(new CustomEvent("theme:tooltip:close", {
                            bubbles: !1,
                            detail: {
                                hideTransition: !1
                            }
                        })), xn(e)
                    }
                    s || this.productImages.hasAttribute(ou) || this.productMediaList.scrollTo({
                        left: t.offsetLeft
                    })
                }
            }
        }
        updateLegend(t) {
            const e = t.variant;
            if (e) {
                const t = this.container.querySelectorAll(zd);
                t.length && t.forEach((t => {
                    const s = t.closest(Ud);
                    if (s) {
                        const i = s.getAttribute(nu),
                            o = parseInt(i, 10) - 1,
                            n = e.options[o];
                        t.innerHTML = n
                    }
                }))
            }
        }
        constructor() {
            super()
        }
    };
    const uu = "[data-image-id]",
        pu = "product-images",
        mu = "[data-section-type]",
        vu = "[data-thumb-item]",
        gu = "[data-thumb-link]",
        fu = "[data-thumbs-slider]",
        yu = "data-active-media",
        bu = "data-media-id",
        wu = "is-active";
    class Eu extends HTMLElement {
        connectedCallback() {
            this.handleEvents(), this.preloadImagesOnHover(), this.activeMediaObserver()
        }
        disconnectedCallback() {
            this.observer && this.observer.disconnect()
        }
        activeMediaObserver() {
            this.observer = new MutationObserver((t => {
                for (const e of t) "attributes" === e.type && e.attributeName == yu && this.setActiveThumb()
            })), this.observer.observe(this.productImagesContainer, {
                attributes: !0,
                childList: !1,
                subtree: !1
            })
        }
        handleEvents() {
            this.thumbLinks.forEach((t => {
                t.addEventListener("click", (e => {
                    e.preventDefault();
                    const s = t.closest(vu),
                        i = t.getAttribute(bu);
                    s.classList.contains(wu) || this.dispatchEvent(new CustomEvent("theme:media:select", {
                        bubbles: !0,
                        detail: {
                            id: i
                        }
                    }))
                })), t.addEventListener("keyup", (e => {
                    if ("Enter" === e.code) {
                        var s;
                        const e = t.getAttribute(bu),
                            i = null === (s = this.productImagesContainer.querySelector(`[${bu}="${e}"]`)) || void 0 === s ? void 0 : s.querySelectorAll('model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])')[0];
                        i && (i.dispatchEvent(new Event("focus")), i.dispatchEvent(new Event("select")))
                    }
                }))
            }))
        }
        preloadImagesOnHover() {
            this.thumbLinks.forEach((t => {
                t.addEventListener("mouseover", (() => {
                    const e = t.getAttribute(bu),
                        s = this.productImagesContainer.querySelector(`[${bu}="${e}"] img`);
                    null == s || s.setAttribute("loading", "eager")
                }))
            }))
        }
        setActiveThumb() {
            var t;
            const e = this.productImagesContainer.getAttribute(yu),
                s = this.querySelector(`[${bu}="${e}"]`);
            null === (t = this.querySelector(`${vu}.${wu}`)) || void 0 === t || t.classList.remove(wu), null == s || s.parentNode.classList.add(wu), requestAnimationFrame((() => {
                this.scrollToThumb()
            }))
        }
        scrollToThumb() {
            const t = this.thumbSlider;
            if (t) {
                const e = t.querySelector(`.${wu}`);
                if (!e) return;
                const s = t.scrollTop,
                    i = t.scrollLeft,
                    o = t.offsetWidth,
                    n = t.offsetHeight,
                    r = s + n,
                    a = i + o,
                    l = e.offsetTop,
                    c = e.offsetLeft,
                    h = e.offsetWidth,
                    d = e.offsetHeight,
                    u = s > l,
                    p = i > c,
                    m = c + h > a,
                    v = l + d > r || u,
                    g = m || p,
                    f = b();
                if (v || g) {
                    let e = l - n + d,
                        s = c - o + h;
                    u && (e = l), m && f && (s += parseInt(window.getComputedStyle(t).paddingRight)), p && (s = c, f && (s -= parseInt(window.getComputedStyle(t).paddingLeft))), t.scrollTo({
                        top: e,
                        left: s,
                        behavior: "smooth"
                    })
                }
            }
        }
        constructor() {
            super(), this.container = this.closest(mu), this.productImages = this.container.querySelectorAll(uu), this.productImagesContainer = this.container.querySelector(pu), this.productThumbs = this.container.querySelectorAll(vu), this.thumbSlider = this.querySelector(fu), this.thumbLinks = this.querySelectorAll(gu)
        }
    }
    const Su = "[data-popup-open]",
        Lu = "[data-popup-close]",
        ku = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Au = "closing";
    let Cu = class {
        popupOpen() {
            this.popup && (this.isAnimating = !0, this.showModal && "function" == typeof this.popup.showModal ? this.popup.showModal() : this.showModal || "function" != typeof this.popup.show ? this.popup.setAttribute("open", "") : this.popup.show(), this.popup.removeAttribute("inert"), this.popup.focus(), this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), ci(this.popup).then((() => {
                this.isAnimating = !1, this.enableScrollLock && this.a11y.trapFocus(this.popup);
                const t = this.popup.querySelector("[autofocus]") || this.popup.querySelector(ku);
                null == t || t.focus()
            })))
        }
        popupClose() {
            if (!this.isAnimating && this.popup && !this.popup.hasAttribute("inert")) {
                if (!this.popup.hasAttribute(Au)) return this.popup.setAttribute(Au, ""), this.isAnimating = !0, void ci(this.popup).then((() => {
                    this.isAnimating = !1, this.popupClose()
                }));
                "function" == typeof this.popup.close ? this.popup.close() : this.popup.removeAttribute("open"), this.popupCloseActions()
            }
        }
        popupCloseActions() {
            this.popup.hasAttribute("inert") || (this.popup.setAttribute("inert", ""), this.popup.removeAttribute(Au), !Dc() && this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            })), this.popup.dispatchEvent(new CustomEvent("theme:popup:onclose", {
                bubbles: !1
            })), this.enableScrollLock && (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()))
        }
        popupEvents() {
            var t;
            if (!this.popup) return;
            null === (t = this.buttonPopupOpen) || void 0 === t || t.addEventListener("click", (t => {
                t.preventDefault(), this.popupOpen(), window.accessibility.lastElement = this.buttonPopupOpen
            }));
            const e = this.popup.querySelectorAll(Lu);
            e.length && e.forEach((t => {
                t.addEventListener("click", (t => {
                    t.preventDefault(), this.popupClose()
                }))
            })), this.showModal && this.popup.addEventListener("click", (t => {
                "DIALOG" === t.target.nodeName && "click" === t.type && this.popupClose()
            })), this.popup.addEventListener("keydown", (t => {
                "Escape" === t.code && (t.preventDefault(), this.popupClose())
            })), this.popup.addEventListener("close", (() => this.popupCloseActions()))
        }
        constructor(t, e, s = !0, i = !0) {
            var o;
            this.popup = t, this.holder = e, this.a11y = W, this.isAnimating = !1, this.showModal = s, this.enableScrollLock = i, this.buttonPopupOpen = null === (o = this.holder) || void 0 === o ? void 0 : o.querySelector(Su), this.popupEvents()
        }
    };
    const Tu = "dialog";
    let qu = class extends HTMLElement {
            connectedCallback() {
                new Cu(this.querySelector(Tu), this, !0, !0)
            }
            constructor() {
                super()
            }
        },
        xu = class extends Jt {
            loadContent() {
                super.loadContent(), Shopify.loadFeatures([{
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: this.setupModelViewerUI.bind(this)
                }])
            }
            setupModelViewerUI(t) {
                t || (this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer")))
            }
            constructor() {
                super()
            }
        };
    window.ProductModel = {
        loadShopifyXR() {
            Shopify.loadFeatures([{
                name: "shopify-xr",
                version: "1.0",
                onLoad: this.setupShopifyXR.bind(this)
            }])
        },
        setupShopifyXR(t) {
            t || (window.ShopifyXR ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t => {
                window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove()
            })), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", (() => this.setupShopifyXR())))
        }
    }, window.addEventListener("DOMContentLoaded", (() => {
        window.ProductModel && window.ProductModel.loadShopifyXR()
    }));
    const Mu = "data-store-availability-container",
        Pu = ".shopify-section",
        Iu = "[data-pickup-drawer]",
        Hu = "[data-section-type]",
        Ou = "hidden";
    let Bu = class extends HTMLElement {
        connectedCallback() {
            this.container = this.closest(Hu), this.drawer = null, this.container.addEventListener("theme:variant:change", (t => this.fetchPickupAvailability(t))), this.fetchPickupAvailability()
        }
        fetchPickupAvailability(t) {
            if (t && !t.detail.variant || t && t.detail.variant && !t.detail.variant.available) return void this.classList.add(Ou);
            const e = t && t.detail.variant ? t.detail.variant.id : this.getAttribute(Mu);
            e && (this.popupActions = null, fetch(`${window.theme.routes.root}variants/${e}/?section_id=api-pickup-availability`).then(this.handleErrors).then((t => t.text())).then((t => {
                const e = (new DOMParser).parseFromString(t, "text/html").querySelector(Pu).innerHTML;
                this.innerHTML = e, this.drawer = this.querySelector(Iu), this.drawer ? (this.classList.remove(Ou), this.popupActions = new Cu(this.drawer, this, !0, !0)) : this.classList.add(Ou)
            })).catch((t => {
                console.error(t)
            })))
        }
        handleErrors(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new Ne({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        constructor() {
            super()
        }
    };
    const Du = {};

    function Fu(t = {}) {
        if (t.type || (t.type = "json"), t.url) return Du[t.url] ? Du[t.url] : function(t, e) {
            const s = new Promise(((s, i) => {
                "text" === e ? fetch(t).then((t => t.text())).then((t => {
                    s(t)
                })).catch((t => {
                    i(t)
                })) : function(t, e, s) {
                    let i = document.getElementsByTagName("head")[0],
                        o = !1,
                        n = document.createElement("script");
                    n.src = t, n.onload = n.onreadystatechange = function() {
                        o || this.readyState && "loaded" != this.readyState && "complete" != this.readyState ? s() : (o = !0, e())
                    }, i.appendChild(n)
                }(t, (function() {
                    s()
                }), (function() {
                    i()
                }))
            }));
            return Du[t] = s, s
        }(t.url, t.type);
        if (t.json) return Du[t.json] ? Promise.resolve(Du[t.json]) : window.fetch(t.json).then((t => t.json())).then((e => (Du[t.json] = e, e)));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return Du[e] ? Du[e] : function(t) {
                const e = "".concat(t.name, t.version),
                    s = new Promise(((e, s) => {
                        try {
                            window.Shopify.loadFeatures([{
                                name: t.name,
                                version: t.version,
                                onLoad: t => {
                                    ! function(t, e, s) {
                                        s ? e(s) : t()
                                    }(e, s, t)
                                }
                            }])
                        } catch (t) {
                            s(t)
                        }
                    }));
                return Du[e] = s, s
            }(t)
        }
        return Promise.reject()
    }
    window.isYoutubeAPILoaded = !1, window.isVimeoAPILoaded = !1;
    const $u = ".pswp",
        _u = ".pswp__custom-close",
        Nu = "iframe, video",
        Ru = ".pswp__thumbs",
        Wu = "is-current",
        zu = "pswp--custom-loader",
        Uu = "pswp--custom-opening",
        Vu = "pswp__loader",
        ju = "is-focused",
        Xu = "data-pswp-option-classes",
        Ju = "aria-current",
        Yu = `<div class="${Vu}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
    let Qu = class {
        init() {
            this.pswpElement.classList.add(Uu), this.initLoader(), Fu({
                url: window.theme.assets.photoswipe
            }).then((() => this.loadPopup())).catch((t => console.error(t)))
        }
        initLoader() {
            if (this.pswpElement.classList.contains(zu) && "" !== this.options && this.options.mainClass) {
                this.pswpElement.setAttribute(Xu, this.options.mainClass);
                let t = document.createElement("div");
                t.innerHTML = Yu, t = t.firstChild, this.pswpElement.appendChild(t)
            } else this.pswpElement.setAttribute(Xu, "")
        }
        loadPopup() {
            const t = window.themePhotoswipe.PhotoSwipe.default,
                e = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.contains(zu) && this.pswpElement.classList.remove(zu), this.pswpElement.classList.remove(Uu), this.popup = new t(this.pswpElement, e, this.items, this.options), this.popup.init(), this.thumbsActions(), document.body.classList.contains(ju) && setTimeout((() => {
                this.a11y.trapFocus(this.pswpElement, {
                    elementToFocus: this.closeBtn
                })
            }), 200), this.popup.listen("close", (() => this.onClose())), this.options && this.options.closeElClasses && this.options.closeElClasses.length && this.options.closeElClasses.forEach((t => {
                const e = this.pswpElement.querySelector(`.pswp__${t}`);
                e && e.addEventListener("keyup", this.keyupCloseEvent)
            }))
        }
        thumbsActions() {
            this.popupThumbsContainer && this.popupThumbsContainer.children.length && (this.popupThumbsContainer.addEventListener("wheel", (t => this.stopDisabledScroll(t))), this.popupThumbsContainer.addEventListener("mousewheel", (t => this.stopDisabledScroll(t))), this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t => this.stopDisabledScroll(t))), this.popupThumbs = this.pswpElement.querySelectorAll(`${Ru} > *`), this.popupThumbs.forEach(((t, e) => {
                t.addEventListener("click", (s => {
                    s.preventDefault();
                    const i = t.parentElement.querySelector(`.${Wu}`);
                    i.classList.remove(Wu), i.setAttribute(Ju, !1), t.classList.add(Wu), t.setAttribute(Ju, !0), this.popup.goTo(e)
                }))
            })), this.popup.listen("imageLoadComplete", (() => this.setCurrentThumb())), this.popup.listen("beforeChange", (() => this.setCurrentThumb())))
        }
        stopDisabledScroll(t) {
            t.stopPropagation()
        }
        keyupClose(t) {
            "Enter" === t.code && this.popup.close()
        }
        onClose() {
            const t = this.pswpElement.querySelector(Nu);
            if (t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
                for (; this.popupThumbsContainer.firstChild;) this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            this.pswpElement.setAttribute(Xu, "");
            const e = this.pswpElement.querySelector(`.${Vu}`);
            e && this.pswpElement.removeChild(e), this.options && this.options.closeElClasses && this.options.closeElClasses.length && this.options.closeElClasses.forEach((t => {
                const e = this.pswpElement.querySelector(`.pswp__${t}`);
                e && e.removeEventListener("keyup", this.keyupCloseEvent)
            })), this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()
        }
        setCurrentThumb() {
            const t = this.pswpElement.querySelector(`${Ru} > .${Wu}`);
            if (t && (t.classList.remove(Wu), t.setAttribute(Ju, !1)), !this.popupThumbs) return;
            const e = this.popupThumbs[this.popup.getCurrentIndex()];
            e.classList.add(Wu), e.setAttribute(Ju, !0), this.scrollThumbs(e)
        }
        scrollThumbs(t) {
            const e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                s = t.offsetLeft;
            if (e <= s + t.offsetWidth || e > s) {
                const e = parseInt(window.getComputedStyle(t).marginLeft);
                this.popupThumbsContainer.scrollTo({
                    top: 0,
                    left: s - e,
                    behavior: "smooth"
                })
            }
        }
        constructor(t, e = "") {
            this.items = t, this.pswpElement = document.querySelectorAll($u)[0], this.popup = null, this.popupThumbs = null, this.popupThumbsContainer = this.pswpElement.querySelector(Ru), this.closeBtn = this.pswpElement.querySelector(_u), this.keyupCloseEvent = t => this.keyupClose(t), this.a11y = W;
            this.options = "" !== e ? e : {
                history: !1,
                focus: !1,
                mainClass: ""
            }, this.init()
        }
    };
    const Gu = "[data-zoom-caption]",
        Ku = "[data-zoom-image]",
        Zu = "[data-pswp-thumbs-template]",
        tp = "[data-section-type]",
        ep = ".pswp__thumbs",
        sp = "product-images",
        ip = "is-dragging",
        op = "variant--soldout",
        np = "variant--unavailable",
        rp = "pswp-zoom-gallery",
        ap = "pswp-zoom-gallery--single",
        lp = "data-image-src",
        cp = "data-image-width",
        hp = "data-image-height";
    let dp = class extends HTMLElement {
        connectedCallback() {
            this.images.forEach(((t, e) => {
                t.addEventListener("click", (s => {
                    s.preventDefault(), t.closest(sp).classList.contains(ip) || (this.createZoom(e), window.accessibility.lastElement = t)
                })), t.addEventListener("keyup", (s => {
                    "Enter" === s.code && (s.preventDefault(), this.createZoom(e), window.accessibility.lastElement = t)
                }))
            }))
        }
        createZoom(t) {
            const e = this.container.querySelector(Zu),
                s = null == e ? void 0 : e.innerHTML;
            let i = [],
                o = 0;
            this.images.forEach((e => {
                const n = e.getAttribute(lp);
                if (o += 1, i.push({
                        src: n,
                        w: parseInt(e.getAttribute(cp)),
                        h: parseInt(e.getAttribute(hp)),
                        msrc: n
                    }), this.images.length === o) {
                    new Qu(i, {
                        history: !1,
                        focus: !1,
                        index: t,
                        mainClass: 1 === o ? `${rp} ${ap}` : `${rp}`,
                        showHideOpacity: !0,
                        howAnimationDuration: 150,
                        hideAnimationDuration: 250,
                        closeOnScroll: !1,
                        closeOnVerticalDrag: !1,
                        captionEl: !0,
                        closeEl: !0,
                        closeElClasses: ["caption-close", "title"],
                        tapToClose: !1,
                        clickToCloseNonZoomable: !1,
                        maxSpreadZoom: 2,
                        loop: !0,
                        spacing: 0,
                        allowPanToNext: !0,
                        pinchToClose: !1,
                        addCaptionHTMLFn: (t, e, s) => {
                            this.zoomCaption(t, e, s)
                        },
                        getThumbBoundsFn: () => {
                            const e = this.images[t],
                                s = window.scrollY || document.documentElement.scrollTop,
                                i = e.getBoundingClientRect();
                            return {
                                x: i.left,
                                y: i.top + s,
                                w: i.width
                            }
                        }
                    }), this.thumbsContainer && "" !== s && (this.thumbsContainer.innerHTML = s)
                }
            }))
        }
        zoomCaption(t, e) {
            let s = "";
            const i = e.children[0];
            return this.zoomCaptions && (s = this.zoomCaptions.innerHTML, this.zoomCaptions.closest(`.${op}`) ? i.classList.add(op) : i.classList.remove(op), this.zoomCaptions.closest(`.${np}`) ? i.classList.add(np) : i.classList.remove(np)), i.innerHTML = s, !1
        }
        constructor() {
            super(), this.container = this.closest(tp), this.images = this.querySelectorAll(Ku), this.zoomCaptions = this.container.querySelector(Gu), this.thumbsContainer = document.querySelector(ep)
        }
    };
    const up = "[data-add-to-cart]",
        pp = "[data-product-json]",
        mp = "[data-product-form]",
        vp = "#cart-bar",
        gp = ".product__submit__add",
        fp = "[data-form-wrapper]",
        yp = "[data-product-variants]",
        bp = "[data-slider]",
        wp = "is-visible",
        Ep = "is-loading",
        Sp = "data-cart-bar-enabled",
        Lp = "data-add-to-cart-bar",
        kp = "data-cart-bar-scroll",
        Ap = "data-section-id",
        Cp = "data-slider-index",
        Tp = {};
    const qp = {
        onLoad() {
            Tp[this.id] = new class {
                initCartBar() {
                    this.cartBarBtn = this.cartBar.querySelector(gp), this.cartBarBtn && (this.cartBarBtn.addEventListener("click", (t => {
                        t.preventDefault(), t.currentTarget.hasAttribute(Lp) ? (this.cartBarEnabled && (t.currentTarget.classList.add(Ep), t.currentTarget.setAttribute("disabled", "disabled")), this.form.querySelector(up).dispatchEvent(new Event("click", {
                            bubbles: !0
                        }))) : t.currentTarget.hasAttribute(kp) && this.scrollToTop()
                    })), this.cartBarBtn.hasAttribute(Lp) && document.addEventListener("theme:product:add-error", this.scrollToTop)), this.setCartBarHeight()
                }
                scrollToTop() {
                    const t = this.container.querySelector(yp),
                        e = (y() ? this.container : t || this.form).getBoundingClientRect().top;
                    xn(y() ? e : e - 10)
                }
                toggleCartBarOnScroll() {
                    const t = window.scrollY,
                        e = theme.variables.productPageSticky && this.formWrapper ? this.formWrapper : this.form;
                    if (e && this.cartBar) {
                        const s = t > e.offsetTop + e.offsetHeight;
                        this.cartBar.classList.toggle(wp, s)
                    }
                }
                setCartBarHeight() {
                    const t = this.cartBar.offsetHeight;
                    document.documentElement.style.setProperty("--cart-bar-height", `${t}px`)
                }
                onUnload() {
                    document.removeEventListener("theme:product:add-error", this.scrollToTop), this.cartBarEnabled && (document.removeEventListener("theme:scroll", this.toggleCartBarOnScroll), document.removeEventListener("theme:resize", this.setCartBarHeight))
                }
                onBlockSelect(t) {
                    const e = t.srcElement.closest(bp);
                    if (e && this.slider.length) {
                        const s = e.hasAttribute(Cp) ? e.getAttribute(Cp) : 0;
                        if (!this.slider[s]) return;
                        this.slider[s].onBlockSelect(t)
                    }
                }
                onBlockDeselect(t) {
                    const e = t.srcElement.closest(bp);
                    if (e && this.slider.length) {
                        const s = e.hasAttribute(Cp) ? e.getAttribute(Cp) : 0;
                        if (!this.slider[s]) return;
                        this.slider[s].onBlockDeselect(t)
                    }
                }
                constructor(t) {
                    this.section = t, this.container = t.container, this.id = this.container.getAttribute(Ap), this.sliders = this.container.querySelectorAll(bp), this.slider = [], this.formWrapper = this.container.querySelector(fp), this.cartBarEnabled = this.container.hasAttribute(Sp), this.cartBar = this.container.querySelector(vp), this.setCartBarHeight = this.setCartBarHeight.bind(this), this.scrollToTop = this.scrollToTop.bind(this), this.toggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this), this.unlockTimer = 0, this.accessibility = W;
                    const e = this.container.querySelector(pp);
                    if (e && !e.innerHTML || !e) return;
                    const s = JSON.parse(e.innerHTML).handle;
                    let i = {};
                    s && (i = {
                        handle: s
                    }), Shopify.Products.recordRecentlyViewed(i), this.form = this.container.querySelector(mp), this.sliders.length && this.sliders.forEach(((t, e) => {
                        t.setAttribute(Cp, e), this.slider.push(new Tn(this.container, t))
                    })), this.cartBarEnabled && (this.initCartBar(), this.setCartBarHeight(), document.addEventListener("theme:scroll", this.toggleCartBarOnScroll), document.addEventListener("theme:resize", this.setCartBarHeight))
                }
            }(this)
        },
        onUnload(t) {
            Tp[this.id].onUnload(t)
        },
        onBlockSelect(t) {
            Tp[this.id].onBlockSelect(t)
        },
        onBlockDeselect(t) {
            Tp[this.id].onBlockDeselect(t)
        }
    };
    Ro("product", [qp, tn, Bc, kh]), customElements.get("complementary-products") || customElements.define("complementary-products", dh), customElements.get("pickup-availability") || customElements.define("pickup-availability", Bu), customElements.get("product-form") || customElements.define("product-form", du), customElements.get("product-images") || customElements.define("product-images", Yh), customElements.get("product-thumbs") || customElements.define("product-thumbs", Eu), customElements.get("product-modal") || customElements.define("product-modal", qu), customElements.get("product-model") || customElements.define("product-model", xu), customElements.get("product-siblings") || customElements.define("product-siblings", gc), customElements.get("radio-swatch") || customElements.define("radio-swatch", oc), customElements.get("recipient-form") || customElements.define("recipient-form", gh), customElements.get("share-button") || customElements.define("share-button", xh), customElements.get("zoom-images") || customElements.define("zoom-images", dp);
    const xp = "[data-api-related-template]",
        Mp = "[data-related-section]",
        Pp = "[data-grid-item]",
        Ip = "[data-recent-wrapper]",
        Hp = "[data-recently-viewed-wrapper]",
        Op = ".product-item",
        Bp = "grid-slider",
        Dp = "data-limit",
        Fp = "data-minimum",
        $p = "data-product-id",
        _p = "is-hidden",
        Np = "grid--mobile-slider",
        Rp = {};
    const Wp = {
        onLoad() {
            Rp[this.id] = new class {
                related() {
                    const t = this.container.querySelector(Mp);
                    if (!t) return;
                    const e = t.getAttribute($p),
                        s = t.getAttribute(Dp),
                        i = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${s}&product_id=${e}&intent=related`;
                    fetch(i).then((t => t.text())).then((e => {
                        const s = document.createElement("div");
                        s.innerHTML = (new DOMParser).parseFromString(e, "text/html").querySelector(xp).innerHTML, s.querySelector(Pp) ? (t.innerHTML = s.innerHTML, 0 === parseInt(t.style.getPropertyValue("--COLUMNS-MOBILE")) && t.querySelector(Pp).parentElement.classList.add(Np)) : t.dispatchEvent(new CustomEvent("theme:tab:hide", {
                            bubbles: !0
                        }))
                    })).catch((function() {
                        t.dispatchEvent(new CustomEvent("theme:tab:hide", {
                            bubbles: !0
                        }))
                    }))
                }
                recent() {
                    const t = this.container.querySelector(Ip),
                        e = t ? parseInt(t.getAttribute(Dp)) : 4;
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: e,
                        wrapperId: `recently-viewed-products-${this.sectionId}`,
                        section: this.section,
                        target: "api-product-grid-item",
                        onComplete: (t, e) => {
                            const s = e.container;
                            if (!s) return;
                            const i = s.querySelector(Ip),
                                o = s.querySelector(Hp),
                                n = t.querySelectorAll(Op),
                                r = i.querySelector(Bp),
                                a = i.hasAttribute(Fp) ? parseInt(i.getAttribute(Fp)) : 4,
                                l = !o && n.length > 0,
                                c = o && n.length >= a;
                            (l || c) && (c && o.classList.remove(_p), i.classList.remove("is-hidden"), i.dispatchEvent(new CustomEvent("theme:tab:check", {
                                bubbles: !0
                            })), r && r.dispatchEvent(new CustomEvent("theme:grid-slider:init", {
                                bubbles: !0
                            })))
                        }
                    })
                }
                constructor(t) {
                    this.section = t, this.sectionId = t.id, this.container = t.container, this.related(), this.recent()
                }
            }(this)
        }
    };
    Ro("related", [Wp, Bc]), Ro("reviews", [qn, ul]);
    const zp = {},
        Up = "[data-slider-logos]",
        Vp = "[data-slider-text]",
        jp = "[data-slide]",
        Xp = "is-selected",
        Jp = "is-initialized",
        Yp = "flickity-enabled",
        Qp = "data-slide",
        Gp = "data-slide-index";
    Ro("logos", [{
        onLoad() {
            zp[this.id] = new class {
                getSlidesWidth() {
                    return 200 * this.logoSlides.length
                }
                initSlideshowText() {
                    this.slideshowText && (this.flkty = new n(this.slideshowText, {
                        fade: !0,
                        autoPlay: !1,
                        prevNextButtons: !1,
                        cellAlign: "left",
                        contain: !0,
                        pageDots: !1,
                        wrapAround: !1,
                        selectedAttraction: .2,
                        friction: .6,
                        draggable: !1,
                        accessibility: !1,
                        on: {
                            ready: () => this.sliderAccessibility(),
                            change: () => this.sliderAccessibility()
                        }
                    }))
                }
                sliderAccessibility() {
                    const t = this.slideshowText.querySelectorAll(`${jp} a, ${jp} button`);
                    t.length && t.forEach((t => {
                        const e = t.closest(jp);
                        if (e) {
                            const s = e.classList.contains(Xp) ? 0 : -1;
                            t.setAttribute("tabindex", s)
                        }
                    }))
                }
                initSlideshowNav() {
                    this.slideshowNav && (this.logoSlides.length && this.logoSlides.forEach((t => {
                        t.addEventListener("click", (() => {
                            const e = parseInt(t.getAttribute(Gp)),
                                s = this.slideshowNav.classList.contains(Yp);
                            if (this.flkty && this.flkty.select(e), s) this.flktyNav.select(e), this.slideshowNav.classList.contains(Xp) || this.flktyNav.playPlayer();
                            else {
                                const e = this.slideshowNav.querySelector(`.${Xp}`);
                                e && e.classList.remove(Xp), t.classList.add(Xp)
                            }
                        }))
                    })), this.setSlideshowNavState(), document.addEventListener("theme:resize", this.setSlideshowNavStateOnResize))
                }
                setSlideshowNavState() {
                    const t = this.slideshowNav.classList.contains(Yp);
                    if (this.logoSlidesWidth > g()) {
                        if (!t) {
                            this.slideshowNav.classList.add(Jp);
                            const t = this.slideshowNav.querySelector(`.${Xp}`);
                            t && t.classList.remove(Xp), this.logoSlides[0].classList.add(Xp), this.flktyNav || (this.flktyNav = new o(this.slideshowNav, {
                                autoPlay: 4e3,
                                prevNextButtons: !1,
                                contain: !1,
                                pageDots: !1,
                                wrapAround: !0,
                                watchCSS: !0,
                                selectedAttraction: .05,
                                friction: .8,
                                initialIndex: 0
                            }), this.flktyNav.on("deactivate", (() => {
                                this.slideshowNav.querySelector(jp).classList.add(Xp), this.flkty && this.flkty.select(0)
                            })), this.flkty && (this.flkty.select(0), this.flktyNav.on("change", (t => this.flkty.select(t)))))
                        }
                    } else t && this.slideshowNav.classList.remove(Jp)
                }
                onBlockSelect(t) {
                    if (!this.slideshowNav) return;
                    const e = this.slideshowNav.querySelector(`[${Qp}="${t.detail.blockId}"]`),
                        s = parseInt(e.getAttribute(Gp));
                    this.slideshowNav.classList.contains(Yp) ? (this.flktyNav.select(s), this.flktyNav.stopPlayer(), this.slideshowNav.classList.add(Xp)) : e.dispatchEvent(new Event("click"))
                }
                onBlockDeselect() {
                    this.slideshowNav && this.slideshowNav.classList.contains(Yp) && (this.flktyNav.playPlayer(), this.slideshowNav.classList.remove(Xp))
                }
                onUnload() {
                    document.removeEventListener("theme:resize", this.setSlideshowNavStateOnResize)
                }
                constructor(t) {
                    this.container = t.container, this.slideshowNav = this.container.querySelector(Up), this.slideshowText = this.container.querySelector(Vp), this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState(), this.flkty = null, this.flktyNav = null, this.logoSlides = this.slideshowNav.querySelectorAll(jp), this.logoSlidesWidth = this.getSlidesWidth(), this.initSlideshowText(), this.initSlideshowNav()
                }
            }(this)
        },
        onUnload(t) {
            zp[this.id].onUnload(t)
        },
        onBlockSelect(t) {
            zp[this.id].onBlockSelect(t)
        },
        onBlockDeselect(t) {
            zp[this.id].onBlockDeselect(t)
        }
    }, ul]);
    const Kp = "data-video-play";
    let Zp = class extends HTMLElement {
        connectedCallback() {
            var t;
            this.videoPlay = this.querySelectorAll(`[${Kp}]`), null === (t = this.videoPlay) || void 0 === t || t.forEach((t => {
                t.addEventListener("click", (t => {
                    const e = t.currentTarget;
                    if ("" !== e.getAttribute(Kp).trim()) {
                        t.preventDefault();
                        const s = [{
                            html: e.getAttribute(Kp)
                        }];
                        new Qu(s, {
                            mainClass: "pswp--video"
                        }), window.accessibility.lastElement = e
                    }
                }))
            }))
        }
        constructor() {
            super()
        }
    };
    const tm = "[data-video-template]",
        em = "is-loading",
        sm = "data-video-id";
    let im = class extends HTMLElement {
        connectedCallback() {
            this.videoId = this.getAttribute(sm), this.videoTemplate = this.querySelector(tm), this.video = null, this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this), this.videoId && this.renderVideo()
        }
        powerSaverVideoPlay() {
            var t;
            null === (t = this.video) || void 0 === t || t.play()
        }
        renderVideo() {
            this.videoTemplateObserver = new IntersectionObserver(((t, e) => {
                t.forEach((t => {
                    if (t.isIntersecting) {
                        const s = this.videoTemplate.innerHTML;
                        this.innerHTML = s, this.classList.remove(em), this.video = this.querySelector("video"), this.observeVideoPlayToggle(), this.video.play().then((() => {})).catch((() => {
                            document.addEventListener("click", this.powerSaverVideoPlay, {
                                passive: !0,
                                bubbles: !0,
                                once: !0
                            }), document.addEventListener("touchstart", this.powerSaverVideoPlay, {
                                passive: !0,
                                bubbles: !0,
                                once: !0
                            })
                        })), e.unobserve(t.target)
                    }
                }))
            }), {
                root: null,
                rootMargin: "300px",
                threshold: [0, .1, .25, .5, .75, 1]
            }), this.videoTemplateObserver.observe(this)
        }
        observeVideoPlayToggle() {
            if (!this.video) return;
            this.videoPlayObserver = new IntersectionObserver((t => {
                t.forEach((t => {
                    const e = t.isIntersecting;
                    e && "function" == typeof this.video.play && this.video.play(), e || "function" != typeof this.video.pause || this.video.pause()
                }))
            }), {
                rootMargin: "0px",
                threshold: [0, 1]
            }), this.videoPlayObserver.observe(this.video)
        }
        disconnectedCallback() {
            this.videoTemplateObserver && this.videoTemplateObserver.disconnect(), this.videoPlayObserver && this.videoPlayObserver.disconnect(), this.videoId && (document.removeEventListener("click", this.powerSaverVideoPlay), document.removeEventListener("touchstart", this.powerSaverVideoPlay))
        }
        constructor() {
            super()
        }
    };
    Ro("featured-video", [sn]), customElements.get("video-background") || customElements.define("video-background", im), customElements.get("video-popup") || customElements.define("video-popup", Zp), Ro("slideshow", [qn, sn]);
    const om = "[data-image-holder]",
        nm = "[data-image-element]",
        rm = "[data-range-button]",
        am = "[data-range-input]";
    let lm = class extends HTMLElement {
        connectedCallback() {
            this.setOverlapImageSize(), this.setImagePosition(), this.rangeInput.addEventListener("input", (() => this.setImagePosition())), document.addEventListener("theme:resize", this.setOverlapImageSize)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize", this.setOverlapImageSize)
        }
        setImagePosition() {
            const t = this.rangeInput.value,
                e = this.imageElement.offsetWidth,
                s = this.rangeButton.offsetWidth;
            this.rangeButton.style.left = `${t}%`, this.imageHolder.style.width = (e - s) * (100 - t) / 100 + s / 2 + "px"
        }
        setOverlapImageSize() {
            const t = this.offsetWidth;
            this.imageElement.style.width = `${t}px`, this.setImagePosition()
        }
        constructor() {
            super(), this.imageHolder = this.querySelector(om), this.imageElement = this.querySelector(nm), this.rangeButton = this.querySelector(rm), this.rangeInput = this.querySelector(am), this.setOverlapImageSize = this.setOverlapImageSize.bind(this)
        }
    };
    Ro("custom-content", [qn, sn, _n]), customElements.get("video-background") || customElements.define("video-background", im), customElements.get("video-popup") || customElements.define("video-popup", Zp), customElements.get("compare-images") || customElements.define("compare-images", lm);
    var cm = {};

    function hm(t) {
        return cm[t]
    }
    cm.basic = [], cm.light = [{
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "64"
        }, {
            hue: "#ff0000"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#bdbdbd"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f0f0f0"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "labels",
        stylers: [{
            lightness: "100"
        }]
    }, {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
            saturation: "-41"
        }, {
            color: "#e8ede7"
        }]
    }, {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: "-100"
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            lightness: "25"
        }, {
            gamma: "1.06"
        }, {
            saturation: "-100"
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            gamma: "10.00"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            gamma: "10.00"
        }, {
            lightness: "100"
        }, {
            weight: "0.4"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            weight: "0.01"
        }, {
            lightness: "39"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.50"
        }, {
            gamma: "10.00"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#cfe5ee"
        }, {
            visibility: "on"
        }]
    }], cm.white_label = [{
        featureType: "all",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            gamma: "3.86"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#cccccc"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f2f2f2"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: -100
        }, {
            lightness: 45
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#e4e4e4"
        }, {
            visibility: "on"
        }]
    }], cm.dark_label = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
            saturation: 36
        }, {
            color: "#000000"
        }, {
            lightness: 40
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
            visibility: "on"
        }, {
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: 1.2
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "-82"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{
            invert_lightness: !0
        }, {
            weight: "7.15"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 21
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 29
        }, {
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 18
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 19
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }]
    }], window.theme.allMaps = window.theme.allMaps || {};
    let dm = window.theme.allMaps;
    window.theme.mapAPI = window.theme.mapAPI || null;
    Ro("map", {
        onLoad() {
            dm[this.id] = new class {
                initMaps() {
                    (function(t) {
                        if (null === window.theme.mapAPI) {
                            const e = `https://maps.googleapis.com/maps/api/js?key=${t}`;
                            window.theme.mapAPI = Fu({
                                url: e
                            })
                        }
                        return window.theme.mapAPI
                    })(this.key).then((() => {
                        return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long ? new google.maps.LatLng(this.lat, this.long) : (t = this.address, new Promise(((e, s) => {
                            (new google.maps.Geocoder).geocode({
                                address: t
                            }, (function(t, i) {
                                if ("OK" == i) {
                                    var o = {
                                        lat: t[0].geometry.location.lat(),
                                        lng: t[0].geometry.location.lng()
                                    };
                                    e(o)
                                } else s(i)
                            }))
                        })));
                        var t
                    })).then((t => {
                        const e = {
                                zoom: parseInt(this.zoomString, 10),
                                styles: hm(this.styleString),
                                center: t,
                                draggable: !0,
                                clickableIcons: !1,
                                scrollwheel: !1,
                                zoomControl: !1,
                                disableDefaultUI: !0
                            },
                            s = function(t, e) {
                                var s = new google.maps.Map(t, e),
                                    i = s.getCenter();
                                return new google.maps.Marker({
                                    map: s,
                                    position: i
                                }), google.maps.event.addDomListener(window, "resize", (function() {
                                    google.maps.event.trigger(s, "resize"), s.setCenter(i)
                                })), s
                            }(this.mapContainer, e);
                        return s
                    })).then((t => {
                        this.map = t, dm[this.id] = t
                    })).catch((t => {
                        console.log("Failed to load Google Map"), console.log(t)
                    }))
                }
                unload() {
                    void 0 !== window.google && google.maps.event.clearListeners(this.map, "resize")
                }
                constructor(t) {
                    this.container = t.container, this.mapContainer = this.container.querySelector("[data-map-container]"), this.key = this.container.getAttribute("data-api-key"), this.styleString = this.container.getAttribute("data-style") || "", this.zoomString = this.container.getAttribute("data-zoom") || 14, this.address = this.container.getAttribute("data-address"), this.enableCorrection = this.container.getAttribute("data-latlong-correction"), this.lat = this.container.getAttribute("data-lat"), this.long = this.container.getAttribute("data-long"), this.key && this.initMaps()
                }
            }(this)
        },
        onUnload() {
            "function" == typeof dm[this.id].unload && dm[this.id].unload()
        }
    });
    const um = "[data-large-promo]",
        pm = "[data-large-promo-inner]",
        mm = "[data-tracking-consent]",
        vm = "[data-confirm-cookies]",
        gm = "cart-bar",
        fm = "[data-newsletter]",
        ym = "[data-newsletter-holder]",
        bm = "[data-newsletter-heading]",
        wm = "[data-newsletter-field]",
        Em = "[data-promo-text]",
        Sm = "[data-newsletter-form]",
        Lm = "data-popup-delay",
        km = "data-cookie-name",
        Am = "data-target-referrer",
        Cm = "hidden",
        Tm = "has-value",
        qm = "cart-bar-visible",
        xm = "is-visible",
        Mm = "has-success",
        Pm = "selected",
        Im = "has-block-selected",
        Hm = "mobile",
        Om = "desktop",
        Bm = "bottom",
        Dm = "data-enable";
    let Fm = {},
        $m = class {
            always() {
                this.popupActions.popupOpen()
            }
            delayed(t = 10) {
                setTimeout((() => {
                    this.popupActions.popupOpen()
                }), 1e3 * t)
            }
            idle() {
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    s = ["load", "resize", "scroll"],
                    i = () => {
                        t = setTimeout((() => {
                            t = 0, this.popupActions.popupOpen()
                        }), 6e4), e.forEach((t => {
                            document.addEventListener(t, o)
                        })), s.forEach((t => {
                            window.addEventListener(t, o)
                        }))
                    },
                    o = () => {
                        t && clearTimeout(t), e.forEach((t => {
                            document.removeEventListener(t, o)
                        })), s.forEach((t => {
                            window.removeEventListener(t, o)
                        })), i()
                    };
                i()
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent)
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight && (this.popupActions.popupOpen(), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent))
            }
            onUnload() {
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent)
            }
            constructor(t, e, s) {
                if (this.element = e, this.delay = t.getAttribute(Lm), this.isSubmitted = -1 !== window.location.href.indexOf("accepts_marketing") || -1 !== window.location.href.indexOf("customer_posted=true"), this.popupActions = s, this.showPopupOnScrollEvent = () => this.showPopupOnScroll(), ("always" === this.delay || this.isSubmitted) && this.always(), this.delay && this.delay.includes("delayed") && !this.isSubmitted) {
                    const t = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                    this.delayed(t)
                }
                "bottom" !== this.delay || this.isSubmitted || this.bottom(), "idle" !== this.delay || this.isSubmitted || this.idle()
            }
        },
        _m = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(Am)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el)
            }
            constructor(t) {
                if (this.el = t, this.locationPath = location.href, !this.el.hasAttribute(Am)) return !1;
                this.init()
            }
        };
    const Nm = {
        onLoad() {
            Fm[this.id] = [];
            this.container.querySelectorAll(um).forEach((t => {
                Fm[this.id].push(new class {
                    init() {
                        const t = !1 !== this.cookie.read(),
                            e = this.popup.classList.contains(Hm),
                            s = this.popup.classList.contains(Om),
                            i = !y();
                        let o = !0;
                        if ((e && !i || s && i) && (o = !1), !o) return this.a11y.removeTrapFocus(), void document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        }));
                        t && !window.Shopify.designMode || (window.Shopify.designMode || window.location.pathname.endsWith("/challenge") || new $m(this.popup, this.modal, this.popupActions), this.form && this.form.classList.contains(Mm) && this.checkForSuccess(), this.modal.addEventListener("theme:popup:onclose", (() => this.cookie.write())))
                    }
                    checkForSuccess() {
                        this.popupActions.popupOpen(), this.cookie.write()
                    }
                    onBlockSelect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupOpen(), this.popup.classList.add(Pm), this.popup.parentNode.classList.add(Im))
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupClose(), this.popup.classList.remove(Pm), this.popup.parentNode.classList.remove(Im))
                    }
                    constructor(t) {
                        this.popup = t, this.modal = this.popup.querySelector(pm), this.form = this.popup.querySelector(Sm), this.cookie = new Mn(this.popup.getAttribute(km), "user_has_closed"), this.isTargeted = new _m(this.popup), this.popupActions = new Cu(this.modal, this.modal, !0, !0), this.a11y = W, this.init()
                    }
                }(t))
            }));
            this.container.querySelectorAll(mm).forEach((t => {
                Fm[this.id].push(new class {
                    init() {
                        this.showPopup && this.popupActions.popupOpen(), this.clickEvents()
                    }
                    clickEvents() {
                        this.acceptButton.addEventListener("click", (t => {
                            t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, (() => this.popupActions.popupClose())), document.documentElement.style.setProperty("--cookie-bar-height", "0px")
                        })), document.addEventListener("trackingConsentAccepted", (() => {}))
                    }
                    onSelect() {
                        this.showPopup && (this.popupActions.popupOpen(), this.popup.classList.add(Pm), this.popup.parentNode.classList.add(Im))
                    }
                    onDeselect() {
                        this.showPopup && (this.popupActions.popupClose(), this.popup.classList.remove(Pm), this.popup.parentNode.classList.remove(Im))
                    }
                    constructor(t) {
                        this.popup = t, this.modal = document.querySelector(mm), this.acceptButton = this.modal.querySelector(vm), this.enable = "true" === this.modal.getAttribute(Dm), this.showPopup = !1, this.popupActions = new Cu(this.popup, this.popup, !1, !1), window.Shopify.loadFeatures([{
                            name: "consent-tracking-api",
                            version: "0.1"
                        }], (t => {
                            if (t) throw t;
                            const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                s = window.Shopify.customerPrivacy.getTrackingConsent();
                            this.showPopup = !e && "no_interaction" === s && this.enable, window.Shopify.designMode && (this.showPopup = !0), this.init()
                        }))
                    }
                }(t))
            }));
            this.container.querySelectorAll(fm).forEach((t => {
                Fm[this.id].push(new class {
                    init() {
                        const t = !1 !== this.cookie.read(),
                            e = -1 !== window.location.search.indexOf("?customer_posted=true"),
                            s = [...this.holder.classList].toString().includes(Bm);
                        e && (this.delay = 0), t && !window.Shopify.designMode || (this.show(), this.form.classList.contains(Mm) && this.checkForSuccess()), s && this.observeCartBar()
                    }
                    show() {
                        window.location.pathname.endsWith("/challenge") || (window.Shopify.designMode ? this.popupActions.popupOpen() : new $m(this.popup, this.holder, this.popupActions)), this.showForm(), this.inputField(), this.holder.addEventListener("theme:popup:onclose", (() => this.cookie.write()))
                    }
                    checkForSuccess() {
                        this.popupActions.popupOpen(), this.cookie.write()
                    }
                    observeCartBar() {
                        if (this.cartBar = document.getElementById(gm), !this.cartBar) return;
                        let t = this.cartBar.classList.contains(xm);
                        document.body.classList.toggle(qm, t), this.observer = new MutationObserver((e => {
                            for (const s of e) "attributes" === s.type && (t = s.target.classList.contains(xm), document.body.classList.toggle(qm, t))
                        })), this.observer.observe(this.cartBar, {
                            attributes: !0,
                            childList: !1,
                            subtree: !1
                        })
                    }
                    showForm() {
                        this.heading.addEventListener("click", (t => {
                            t.preventDefault(), this.heading.classList.add(Cm), this.form.classList.remove(Cm), this.newsletterField.focus()
                        })), this.heading.addEventListener("keyup", (t => {
                            "Enter" === t.code && this.heading.dispatchEvent(new Event("click"))
                        }))
                    }
                    inputField() {
                        const t = () => {
                            this.resetClassTimer && clearTimeout(this.resetClassTimer), "" !== this.newsletterField.value && this.holder.classList.add(Tm)
                        };
                        this.newsletterField.addEventListener("input", t), this.newsletterField.addEventListener("focus", t), this.newsletterField.addEventListener("focusout", (() => {
                            this.resetClassTimer && clearTimeout(this.resetClassTimer), this.resetClassTimer = setTimeout((() => {
                                this.holder.classList.remove(Tm)
                            }), 2e3)
                        }))
                    }
                    onBlockSelect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupOpen(), this.popup.classList.add(Pm), this.popup.parentNode.classList.add(Im))
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupClose(), this.popup.classList.remove(Pm), this.popup.parentNode.classList.remove(Im))
                    }
                    onUnload() {
                        this.observer && this.observer.disconnect()
                    }
                    constructor(t) {
                        this.popup = t, this.holder = this.popup.querySelector(ym), this.heading = this.popup.querySelector(bm), this.newsletterField = this.popup.querySelector(wm), this.cookie = new Mn(this.popup.getAttribute(km), "newsletter_is_closed"), this.form = this.popup.querySelector(Sm), this.isTargeted = new _m(this.popup), this.popupActions = new Cu(this.holder, this.holder, !1, !1), this.resetClassTimer = 0, this.init()
                    }
                }(t))
            }));
            this.container.querySelectorAll(Em).forEach((t => {
                Fm[this.id].push(new class {
                    init() {
                        !1 !== this.cookie.read() && !window.Shopify.designMode || (window.Shopify.designMode ? this.popupActions.popupOpen() : new $m(this.popup, this.popup, this.popupActions), this.popup.addEventListener("theme:popup:onclose", (() => this.cookie.write())))
                    }
                    onSelect() {
                        this.popupActions.popupOpen(), this.popup.classList.add(Pm), this.popup.parentNode.classList.add(Im)
                    }
                    onDeselect() {
                        this.popupActions.popupClose(), this.popup.classList.remove(Pm), this.popup.parentNode.classList.remove(Im)
                    }
                    constructor(t) {
                        this.popup = t, this.cookie = new Mn(this.popup.getAttribute(km), "user_has_closed"), this.isTargeted = new _m(this.popup), this.popupActions = new Cu(this.popup, this.popup, !1, !1), this.init()
                    }
                }(t))
            }))
        },
        onBlockSelect(t) {
            Fm[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            Fm[this.id].forEach((e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            }))
        },
        onSelect() {
            Fm[this.id].forEach((t => {
                "function" == typeof t.onSelect && t.onSelect()
            }))
        },
        onDeselect() {
            Fm[this.id].forEach((t => {
                "function" == typeof t.onDeselect && t.onDeselect()
            }))
        },
        onUnload() {
            Fm[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        }
    };
    Ro("popups", [Nm, _n]);
    const Rm = "[data-password-modal]",
        Wm = "#login_form .errors";
    Ro("password-template", {
        onLoad() {
            new class {
                constructor(t) {
                    this.container = t.container, this.popupActions = new Cu(this.container.querySelector(Rm), this.container, !0, !0), this.container.querySelector(Wm) && this.popupActions.popupOpen()
                }
            }(this)
        }
    }), Ro("list-collections", [qn, ul]), Ro("columns", [ul, qn]), Ro("newsletter", _n), customElements.get("compare-images") || customElements.define("compare-images", lm);
    const zm = "[data-scroll-to]",
        Um = "[data-tooltip]",
        Vm = "[data-collapsible-trigger]",
        jm = "open",
        Xm = "data-scroll-to",
        Jm = "data-tooltip-stop-mouseenter",
        Ym = {};
    const Qm = {
            onLoad() {
                Ym[this.id] = new class {
                    init() {
                        this.scrollToButtons.forEach((t => {
                            t.addEventListener("click", (() => {
                                const e = this.container.querySelector(t.getAttribute(Xm));
                                e && "A" !== t.tagName && this.scrollToElement(e)
                            }))
                        }))
                    }
                    scrollToElement(t) {
                        xn(t.getBoundingClientRect().top + 1);
                        const e = t.nextElementSibling.matches("details") ? t.nextElementSibling : null;
                        if (e) {
                            const t = null == e ? void 0 : e.querySelector(Vm);
                            e.hasAttribute(jm) || null == t || t.dispatchEvent(new Event("click"))
                        }
                        const s = document.querySelectorAll(`${Um}:not([${Jm}])`);
                        s.length && s.forEach((t => {
                            t.setAttribute(Jm, ""), setTimeout((() => {
                                t.removeAttribute(Jm)
                            }), 1e3)
                        }))
                    }
                    constructor(t) {
                        this.section = t, this.container = t.container, this.scrollToButtons = this.container.querySelectorAll(zm), this.scrollToButtons.length && this.init()
                    }
                }(this)
            }
        },
        Gm = "[data-scroll-spy]",
        Km = "is-selected",
        Zm = "data-scroll-spy",
        tv = "data-scroll-spy-mobile",
        ev = "data-scroll-spy-desktop",
        sv = "data-scroll-trigger-point",
        iv = {};
    const ov = {
        onLoad() {
            var t;
            iv[this.id] = [], null === (t = this.container.querySelectorAll(Gm)) || void 0 === t || t.forEach((t => {
                const e = this.container.querySelector(t.getAttribute(Zm));
                iv[this.id].push(new class {
                    init() {
                        this.toggleScrollObserver(), document.addEventListener("theme:resize:width", this.toggleScrollObserver)
                    }
                    toggleScrollObserver() {
                        this.isEligible() ? this.initialized || (document.addEventListener("theme:scroll", this.scrollCallback), this.initialized = !0) : (document.removeEventListener("theme:scroll", this.scrollCallback), this.initialized = !1)
                    }
                    isEligible() {
                        const t = y();
                        return !t && this.anchor.hasAttribute(tv) || t && this.anchor.hasAttribute(ev) || !this.anchor.hasAttribute(ev) && !this.anchor.hasAttribute(tv)
                    }
                    onScroll() {
                        this.top = this.elementToSpy.getBoundingClientRect().top;
                        const t = Math.round(window.innerHeight),
                            e = Math.round(window.scrollY),
                            s = e + t,
                            i = Math.round(this.top + e),
                            o = this.elementToSpy.offsetHeight;
                        i < s && !(i + o < e) && this.triggerPointReached() && (this.anchorSiblings.forEach((t => {
                            t.matches(this.anchorSelector) || t.classList.remove(Km)
                        })), this.anchor.classList.add(Km))
                    }
                    triggerPointReached() {
                        let t = !1;
                        switch (this.triggerPoint) {
                            case "top":
                            default:
                                t = this.top <= 0;
                                break;
                            case "middle":
                                t = this.top <= window.innerHeight / 2;
                                break;
                            case "bottom":
                                t = this.top <= window.innerHeight
                        }
                        return t
                    }
                    onUnload() {
                        document.removeEventListener("theme:resize:width", this.toggleScrollObserver), document.removeEventListener("theme:scroll", this.scrollCallback)
                    }
                    constructor(t, e) {
                        this.container = t, this.elementToSpy = e, this.anchorSelector = `[${Zm}="#${this.elementToSpy.id}"]`, this.anchor = this.container.querySelector(this.anchorSelector), this.anchorSiblings = this.container.querySelectorAll(`[${Zm}]`), this.initialized = !1, this.anchor && (this.triggerPoint = this.anchor.getAttribute(sv), this.scrollCallback = () => this.onScroll(), this.toggleScrollObserver = this.toggleScrollObserver.bind(this), this.init())
                    }
                }(this.container, e))
            }))
        },
        onUnload() {
            iv[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        }
    };
    Ro("sidebar", [Qm, ov]);
    const nv = "[data-hover-target]",
        rv = "[data-collection-image]",
        av = "data-hover-target",
        lv = "is-visible",
        cv = "is-selected";
    let hv = {};
    Ro("collections-hover", [{
        onLoad() {
            hv[this.id] = new class {
                init() {
                    this.buttons.length && this.buttons.forEach((t => {
                        t.addEventListener("mouseenter", (t => {
                            const e = t.currentTarget.getAttribute(av);
                            this.updateState(e)
                        }))
                    }))
                }
                updateState(t) {
                    const e = this.container.querySelector(`[${av}="${t}"]`),
                        s = this.container.querySelector(`#${t}:not(.${lv})`),
                        i = this.container.querySelector(`${nv}.${cv}`),
                        o = this.container.querySelector(`${rv}.${lv}`);
                    s && y() && (null == o || o.classList.remove(lv), null == i || i.classList.remove(cv), s.classList.add(lv), e.classList.add(cv))
                }
                onBlockSelect(t) {
                    this.updateState(t.target.id)
                }
                constructor(t) {
                    this.container = t.container, this.buttons = this.container.querySelectorAll(nv), this.init()
                }
            }(this)
        },
        onBlockSelect(t) {
            hv[this.id].onBlockSelect(t)
        }
    }, ov]);
    const dv = "[data-featured-image]",
        uv = "[data-featured-aside]",
        pv = "[data-featured-content]",
        mv = "[data-featured-wrapper]",
        vv = "data-horizontal-scroll",
        gv = "data-horizontal-scroll-reversed",
        fv = {};
    Ro("featured-product", [{
        onLoad() {
            fv[this.id] = new class {
                init() {
                    this.horizontalScroll && this.imagesHolder && (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent), document.addEventListener("theme:scroll", this.scrollEvent)), this.wrapper && this.contentHolder && this.images.length && (this.calculateHeight(), document.addEventListener("theme:resize:width", this.calculateHeightEvent))
                }
                scrollEvents() {
                    this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent))
                }
                removeAnimationFrame() {
                    this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), this.requestAnimationSticky = null)
                }
                calculateHorizontalPosition() {
                    let t = window.scrollY + this.headerHeight;
                    const e = t + window.innerHeight,
                        s = this.imagesHolder.offsetTop,
                        i = this.imagesHolder.offsetHeight,
                        o = s + i + this.headerHeight,
                        n = i - (window.innerHeight - this.headerHeight),
                        r = this.horizontalScrollReversed ? 1 : -1;
                    let a = 0;
                    a = t >= s && e <= o ? (t - s) / n * 100 : t < s ? 0 : 100, a *= this.images.length - 1, this.container.style.setProperty("--translateX", a * r + "%"), this.lastPercent !== a ? this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent) : this.requestAnimationSticky && this.removeAnimationFrame(), this.lastPercent = a
                }
                calculateHeight() {
                    let {
                        stickyHeaderHeight: t
                    } = c();
                    this.container.style.removeProperty("--min-height"), this.container.style.setProperty("--min-height", `${this.wrapper.offsetHeight+this.contentHolder.offsetHeight}px`), this.headerHeight = t
                }
                onUnload() {
                    this.horizontalScroll && this.imagesHolder && document.removeEventListener("theme:scroll", this.calculateHorizontalPositionEvent), this.wrapper && this.contentHolder && this.images.length && document.removeEventListener("theme:resize:width", this.calculateHeightEvent)
                }
                constructor(t) {
                    this.container = t.container, this.horizontalScroll = this.container.hasAttribute(vv), this.horizontalScrollReversed = this.container.hasAttribute(gv), this.images = this.container.querySelectorAll(dv), this.imagesHolder = this.container.querySelector(uv), this.contentHolder = this.container.querySelector(pv), this.wrapper = this.container.querySelector(mv), this.requestAnimationSticky = null, this.lastPercent = 0, this.scrollEvent = () => this.scrollEvents(), this.calculateHorizontalPositionEvent = () => this.calculateHorizontalPosition(), this.calculateHeightEvent = () => this.calculateHeight(), this.init()
                }
            }(this)
        },
        onUnload(t) {
            fv[this.id].onUnload(t)
        }
    }]);
    const yv = "[data-timeline-holder]",
        bv = "[data-timeline-rows]",
        wv = "[data-timeline-row]",
        Ev = "[data-timeline-row-editor]",
        Sv = "[data-timeline-button]",
        Lv = "[data-block-scroll]",
        kv = "is-selected",
        Av = {};
    Ro("timeline", [{
        onLoad() {
            Av[this.id] = new class {
                init() {
                    this.calculateRowsDimensions(), this.requestAnimation = requestAnimationFrame((() => this.calculatePosition())), this.isDesktopView && !this.isScrollEnabled && (this.isScrollEnabled = !0, document.addEventListener("theme:scroll", this.scrollEvent)), this.rowsHolder.addEventListener("scroll", this.scrollEvent), document.addEventListener("theme:resize:width", this.resizeEvent), this.buttons.length && this.buttons.forEach(((t, e) => {
                        t.addEventListener("click", (t => {
                            t.preventDefault();
                            const s = t.currentTarget.closest(wv);
                            if (!s) return;
                            const i = Math.max(...this.rowsHeight),
                                o = this.holderHeight / this.rows.length,
                                n = this.holder.getBoundingClientRect().top,
                                r = e > 0 && i < o ? o * e + n : n,
                                a = y() ? r + 1 : s.getBoundingClientRect().top;
                            xn(a)
                        }))
                    }))
                }
                resizeEvents() {
                    this.holderTop = this.holder.getBoundingClientRect().top + window.scrollY, this.holderHeight = this.holder.offsetHeight, this.calculateRowsDimensions(), this.requestAnimation = requestAnimationFrame((() => this.calculatePosition()));
                    const t = y();
                    t && !this.isScrollEnabled ? (this.isScrollEnabled = !0, document.addEventListener("theme:scroll", this.scrollEvent)) : !t && this.isScrollEnabled && (this.isScrollEnabled = !1, document.removeEventListener("theme:scroll", this.scrollEvent))
                }
                scrollEvents(t) {
                    if (!this.requestAnimation) {
                        const e = t.currentTarget;
                        this.requestAnimation = requestAnimationFrame((() => this.calculatePosition(e)))
                    }
                }
                removeAnimationFrame() {
                    this.requestAnimation && (cancelAnimationFrame(this.requestAnimation), this.requestAnimation = null)
                }
                calculateRowsDimensions() {
                    if (this.rows.length) {
                        this.rowsHeight = [], this.rowsWidth = 0;
                        let t = 0;
                        this.rows.forEach(((e, s) => {
                            if (this.rowsHeight.push(e.offsetHeight), this.rowsWidth += e.offsetWidth + parseInt(getComputedStyle(e).marginRight), window.Shopify.designMode) {
                                const n = this.container.querySelectorAll(Ev);
                                var i, o;
                                n.length && (t += e.offsetHeight, null === (i = n[s]) || void 0 === i || i.style.setProperty("--row-height-min", `${e.offsetHeight}px`), null === (o = n[s + 1]) || void 0 === o || o.style.setProperty("--row-top-mobile", `${t}px`))
                            }
                        }))
                    }
                }
                calculatePosition(t = null) {
                    this.removeAnimationFrame();
                    const e = y(),
                        s = this.holderHeight / this.rows.length;
                    let i = this.holderTop;
                    const o = window.innerHeight,
                        n = window.scrollY + 1.5 * o;
                    let r = 0;
                    if (!e && t) {
                        const e = t.scrollLeft - 16,
                            s = t.offsetWidth;
                        r = e / (this.rowsWidth - s) * 100, this.holder.style.setProperty("--percent-mobile", `${r}%`)
                    }
                    e && (n < this.holderTop || n > this.holderTop + this.holderHeight + o) || this.rows.forEach(((t, o) => {
                        if (o > 0) {
                            const o = t.offsetLeft / this.rowsWidth * 100;
                            let l = r > o;
                            var a;
                            e && (l = i + s < n, i - s < n && (null === (a = t.previousElementSibling) || void 0 === a || a.style.setProperty("--percent-desktop", (n - i) / s * 100 + "%"))), t.classList.toggle(kv, l)
                        }
                        i += s
                    }))
                }
                onUnload() {
                    this.isScrollEnabled && (this.isScrollEnabled = !1, document.removeEventListener("theme:scroll", this.scrollEvent)), this.rowsHolder.removeEventListener("scroll", this.scrollEvent), document.removeEventListener("theme:resize:width", this.resizeEvent)
                }
                onBlockSelect(t) {
                    const e = this.container.querySelector(Lv);
                    if (e) {
                        const s = t.srcElement,
                            i = [...s.parentElement.children].indexOf(s),
                            o = this.rows[i];
                        o && e.scrollTo({
                            top: 0,
                            left: o.offsetLeft,
                            behavior: "smooth"
                        })
                    }
                }
                constructor(t) {
                    this.container = t.container, this.rows = this.container.querySelectorAll(wv), this.holder = this.container.querySelector(yv), this.rows.length < 2 || !this.holder || (this.rowsWidth = 0, this.rowsHeight = [], this.holderTop = this.holder.getBoundingClientRect().top + window.scrollY, this.holderHeight = this.holder.offsetHeight, this.buttons = this.container.querySelectorAll(Sv), this.rowsHolder = this.container.querySelector(bv), this.requestAnimation = null, this.isDesktopView = y(), this.isScrollEnabled = !1, this.scrollEvent = t => this.scrollEvents(t), this.resizeEvent = () => this.resizeEvents(), this.init())
                }
            }(this)
        },
        onUnload(t) {
            Av[this.id].onUnload(t)
        },
        onBlockSelect(t) {
            Av[this.id].onBlockSelect(t)
        }
    }]), document.addEventListener("DOMContentLoaded", (function() {
        Wo("*");
        const t = document.querySelector("[data-scroll-top-button]");
        t && (t.addEventListener("click", (() => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            })
        })), document.addEventListener("theme:scroll", (() => {
            t.classList.toggle("is-visible", window.scrollY > window.innerHeight)
        }))), window.self !== window.top && document.querySelector("html").classList.add("iframe"), "scrollBehavior" in document.documentElement.style || Fu({
            url: window.theme.assets.smoothscroll
        })
    })), window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies"))
}(themeVendor.ScrollLock, themeVendor.themeAddresses, themeVendor.themeCurrency, themeVendor.Rellax, themeVendor.Flickity, themeVendor.FlickityFade, themeVendor.themeImages);